// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cds--chart-holder {
  --cds-charts-1-1-1: #6929c4;
  --cds-charts-1-1-1-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-1-2-1: #002d9c;
  --cds-charts-1-2-1-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-1-3-1: #1192e8;
  --cds-charts-1-3-1-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-1-4-1: #007d79;
  --cds-charts-1-4-1-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-2-1-1: #6929c4;
  --cds-charts-2-1-1-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-2-1-2: #009d9a;
  --cds-charts-2-1-2-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-2-2-1: #8a3ffc;
  --cds-charts-2-2-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-2-2-2: #520408;
  --cds-charts-2-2-2-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-2-3-1: #9f1853;
  --cds-charts-2-3-1-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-2-3-2: #520408;
  --cds-charts-2-3-2-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-2-4-1: #1192e8;
  --cds-charts-2-4-1-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-2-4-2: #005d5d;
  --cds-charts-2-4-2-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-2-5-1: #009d9a;
  --cds-charts-2-5-1-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-2-5-2: #002d9c;
  --cds-charts-2-5-2-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-3-1-1: #ee5396;
  --cds-charts-3-1-1-hovered: rgb(234.7888888889, 50.5111111111, 130.1666666667);
  --cds-charts-3-1-2: #1192e8;
  --cds-charts-3-1-2-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-3-1-3: #6929c4;
  --cds-charts-3-1-3-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-3-2-1: #9f1853;
  --cds-charts-3-2-1-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-3-2-2: #fa4d56;
  --cds-charts-3-2-2-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-3-2-3: #520408;
  --cds-charts-3-2-3-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-3-3-1: #a56eff;
  --cds-charts-3-3-1-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-3-3-2: #005d5d;
  --cds-charts-3-3-2-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-3-3-3: #002d9c;
  --cds-charts-3-3-3-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-3-4-1: #a56eff;
  --cds-charts-3-4-1-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-3-4-2: #005d5d;
  --cds-charts-3-4-2-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-3-4-3: #9f1853;
  --cds-charts-3-4-3-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-3-5-1: #012749;
  --cds-charts-3-5-1-hovered: rgb(0.5175675676, 20.1851351351, 37.7824324324);
  --cds-charts-3-5-2: #6929c4;
  --cds-charts-3-5-2-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-3-5-3: #009d9a;
  --cds-charts-3-5-3-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-4-1-1: #6929c4;
  --cds-charts-4-1-1-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-4-1-2: #012749;
  --cds-charts-4-1-2-hovered: rgb(0.5175675676, 20.1851351351, 37.7824324324);
  --cds-charts-4-1-3: #009d9a;
  --cds-charts-4-1-3-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-4-1-4: #ee5396;
  --cds-charts-4-1-4-hovered: rgb(234.7888888889, 50.5111111111, 130.1666666667);
  --cds-charts-4-2-1: #9f1853;
  --cds-charts-4-2-1-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-4-2-2: #fa4d56;
  --cds-charts-4-2-2-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-4-2-3: #520408;
  --cds-charts-4-2-3-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-4-2-4: #a56eff;
  --cds-charts-4-2-4-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-4-3-1: #009d9a;
  --cds-charts-4-3-1-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-4-3-2: #002d9c;
  --cds-charts-4-3-2-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-4-3-3: #a56eff;
  --cds-charts-4-3-3-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-4-3-4: #9f1853;
  --cds-charts-4-3-4-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-5-1-1: #6929c4;
  --cds-charts-5-1-1-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-5-1-2: #1192e8;
  --cds-charts-5-1-2-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-5-1-3: #005d5d;
  --cds-charts-5-1-3-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-5-1-4: #9f1853;
  --cds-charts-5-1-4-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-5-1-5: #520408;
  --cds-charts-5-1-5-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-5-2-1: #002d9c;
  --cds-charts-5-2-1-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-5-2-2: #009d9a;
  --cds-charts-5-2-2-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-5-2-3: #9f1853;
  --cds-charts-5-2-3-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-5-2-4: #520408;
  --cds-charts-5-2-4-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-5-2-5: #a56eff;
  --cds-charts-5-2-5-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-14-1-1: #6929c4;
  --cds-charts-14-1-1-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-14-1-2: #1192e8;
  --cds-charts-14-1-2-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-14-1-3: #005d5d;
  --cds-charts-14-1-3-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-14-1-4: #9f1853;
  --cds-charts-14-1-4-hovered: rgb(127.9819672131, 19.3180327869, 66.8081967213);
  --cds-charts-14-1-5: #fa4d56;
  --cds-charts-14-1-5-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-14-1-6: #520408;
  --cds-charts-14-1-6-hovered: rgb(47.9604651163, 2.3395348837, 4.6790697674);
  --cds-charts-14-1-7: #198038;
  --cds-charts-14-1-7-hovered: rgb(19.1666666667, 98.1333333333, 42.9333333333);
  --cds-charts-14-1-8: #002d9c;
  --cds-charts-14-1-8-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-14-1-9: #ee5396;
  --cds-charts-14-1-9-hovered: rgb(234.7888888889, 50.5111111111, 130.1666666667);
  --cds-charts-14-1-10: #b28600;
  --cds-charts-14-1-10-hovered: rgb(142.3, 107.1247191011, 0);
  --cds-charts-14-1-11: #009d9a;
  --cds-charts-14-1-11-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-14-1-12: #012749;
  --cds-charts-14-1-12-hovered: rgb(0.5175675676, 20.1851351351, 37.7824324324);
  --cds-charts-14-1-13: #8a3800;
  --cds-charts-14-1-13-hovered: rgb(102.3, 41.5130434783, 0);
  --cds-charts-14-1-14: #a56eff;
  --cds-charts-14-1-14-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-mono-1-1: #ffffff;
  --cds-charts-mono-1-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-1-2: #f6f2ff;
  --cds-charts-mono-1-2-hovered: rgb(221.2846153846, 206.3, 255);
  --cds-charts-mono-1-3: #e8daff;
  --cds-charts-mono-1-3-hovered: rgb(209.8081081081, 182.3, 255);
  --cds-charts-mono-1-4: #d4bbff;
  --cds-charts-mono-1-4-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-mono-1-5: #be95ff;
  --cds-charts-mono-1-5-hovered: rgb(168.108490566, 113.3, 255);
  --cds-charts-mono-1-6: #a56eff;
  --cds-charts-mono-1-6-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-mono-1-7: #8a3ffc;
  --cds-charts-mono-1-7-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-mono-1-8: #6929c4;
  --cds-charts-mono-1-8-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-mono-1-9: #491d8b;
  --cds-charts-mono-1-9-hovered: rgb(57.4875, 22.8375, 109.4625);
  --cds-charts-mono-1-10: #31135e;
  --cds-charts-mono-1-10-hovered: rgb(33.5194690265, 12.9973451327, 64.3026548673);
  --cds-charts-mono-1-11: #1c0f30;
  --cds-charts-mono-1-11-hovered: rgb(12.1333333333, 6.5, 20.8);
  --cds-charts-mono-2-1: #ffffff;
  --cds-charts-mono-2-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-2-2: #edf5ff;
  --cds-charts-mono-2-2-hovered: rgb(201.3, 225.1666666667, 255);
  --cds-charts-mono-2-3: #d0e2ff;
  --cds-charts-mono-2-3-hovered: rgb(172.3, 203.9723404255, 255);
  --cds-charts-mono-2-4: #a6c8ff;
  --cds-charts-mono-2-4-hovered: rgb(130.3, 177.9382022472, 255);
  --cds-charts-mono-2-5: #78a9ff;
  --cds-charts-mono-2-5-hovered: rgb(84.3, 146.2577777778, 255);
  --cds-charts-mono-2-6: #4589ff;
  --cds-charts-mono-2-6-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-mono-2-7: #0f62fe;
  --cds-charts-mono-2-7-hovered: rgb(0.9680497925, 81.3161825726, 232.3319502075);
  --cds-charts-mono-2-8: #0043ce;
  --cds-charts-mono-2-8-hovered: rgb(0, 55.3888349515, 170.3);
  --cds-charts-mono-2-9: #002d9c;
  --cds-charts-mono-2-9-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-mono-2-10: #001d6c;
  --cds-charts-mono-2-10-hovered: rgb(0, 19.4138888889, 72.3);
  --cds-charts-mono-2-11: #001141;
  --cds-charts-mono-2-11-hovered: rgb(0, 7.6630769231, 29.3);
  --cds-charts-mono-3-1: #ffffff;
  --cds-charts-mono-3-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-3-2: #e5f6ff;
  --cds-charts-mono-3-2-hovered: rgb(193.3, 233.6423076923, 255);
  --cds-charts-mono-3-3: #bae6ff;
  --cds-charts-mono-3-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-mono-3-4: #82cfff;
  --cds-charts-mono-3-4-hovered: rgb(94.3, 193.2912, 255);
  --cds-charts-mono-3-5: #33b1ff;
  --cds-charts-mono-3-5-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-mono-3-6: #1192e8;
  --cds-charts-mono-3-6-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-mono-3-7: #0072c3;
  --cds-charts-mono-3-7-hovered: rgb(0, 93.1292307692, 159.3);
  --cds-charts-mono-3-8: #00539a;
  --cds-charts-mono-3-8-hovered: rgb(0, 63.7590909091, 118.3);
  --cds-charts-mono-3-9: #003a6d;
  --cds-charts-mono-3-9-hovered: rgb(0, 39.0036697248, 73.3);
  --cds-charts-mono-3-10: #012749;
  --cds-charts-mono-3-10-hovered: rgb(0.5175675676, 20.1851351351, 37.7824324324);
  --cds-charts-mono-3-11: #061727;
  --cds-charts-mono-3-11-hovered: rgb(1.24, 4.7533333333, 8.06);
  --cds-charts-mono-4-1: #ffffff;
  --cds-charts-mono-4-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-4-2: #d9fbfb;
  --cds-charts-mono-4-2-hovered: rgb(184.7, 247.6, 247.6);
  --cds-charts-mono-4-3: #9ef0f0;
  --cds-charts-mono-4-3-hovered: rgb(127.08125, 235.21875, 235.21875);
  --cds-charts-mono-4-4: #3ddbd9;
  --cds-charts-mono-4-4-hovered: rgb(38.2382608696, 206.0617391304, 203.9373913043);
  --cds-charts-mono-4-5: #08bdba;
  --cds-charts-mono-4-5-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-mono-4-6: #009d9a;
  --cds-charts-mono-4-6-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-mono-4-7: #007d79;
  --cds-charts-mono-4-7-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-mono-4-8: #005d5d;
  --cds-charts-mono-4-8-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-mono-4-9: #004144;
  --cds-charts-mono-4-9-hovered: rgb(0, 30.875, 32.3);
  --cds-charts-mono-4-10: #022b30;
  --cds-charts-mono-4-10-hovered: rgb(0.572, 12.298, 13.728);
  --cds-charts-mono-4-11: #081a1c;
  --cds-charts-mono-4-11-hovered: rgb(0.0666666667, 0.2166666667, 0.2333333333);
  --cds-charts-diverge-1-1: #750e13;
  --cds-charts-diverge-1-1-hovered: rgb(85.1152671756, 10.1847328244, 13.8221374046);
  --cds-charts-diverge-1-2: #a2191f;
  --cds-charts-diverge-1-2-hovered: rgb(131.0727272727, 20.2272727273, 25.0818181818);
  --cds-charts-diverge-1-3: #da1e28;
  --cds-charts-diverge-1-3-hovered: rgb(186.6185483871, 25.6814516129, 34.2419354839);
  --cds-charts-diverge-1-4: #fa4d56;
  --cds-charts-diverge-1-4-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-diverge-1-5: #ff8389;
  --cds-charts-diverge-1-5-hovered: rgb(255, 95.3, 103.0274193548);
  --cds-charts-diverge-1-6: #ffb3b8;
  --cds-charts-diverge-1-6-hovered: rgb(255, 143.3, 150.6486842105);
  --cds-charts-diverge-1-7: #ffd7d9;
  --cds-charts-diverge-1-7-hovered: rgb(255, 179.3, 183.085);
  --cds-charts-diverge-1-8: #fff1f1;
  --cds-charts-diverge-1-8-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-diverge-1-9: #ffffff;
  --cds-charts-diverge-1-9-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-diverge-1-10: #e5f6ff;
  --cds-charts-diverge-1-10-hovered: rgb(193.3, 233.6423076923, 255);
  --cds-charts-diverge-1-11: #bae6ff;
  --cds-charts-diverge-1-11-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-diverge-1-12: #82cfff;
  --cds-charts-diverge-1-12-hovered: rgb(94.3, 193.2912, 255);
  --cds-charts-diverge-1-13: #33b1ff;
  --cds-charts-diverge-1-13-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-diverge-1-14: #1192e8;
  --cds-charts-diverge-1-14-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-diverge-1-15: #0072c3;
  --cds-charts-diverge-1-15-hovered: rgb(0, 93.1292307692, 159.3);
  --cds-charts-diverge-1-16: #00539a;
  --cds-charts-diverge-1-16-hovered: rgb(0, 63.7590909091, 118.3);
  --cds-charts-diverge-1-17: #003a6d;
  --cds-charts-diverge-1-17-hovered: rgb(0, 39.0036697248, 73.3);
  --cds-charts-diverge-2-1: #491d8b;
  --cds-charts-diverge-2-1-hovered: rgb(57.4875, 22.8375, 109.4625);
  --cds-charts-diverge-2-2: #6929c4;
  --cds-charts-diverge-2-2-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-diverge-2-3: #8a3ffc;
  --cds-charts-diverge-2-3-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-diverge-2-4: #a56eff;
  --cds-charts-diverge-2-4-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-diverge-2-5: #be95ff;
  --cds-charts-diverge-2-5-hovered: rgb(168.108490566, 113.3, 255);
  --cds-charts-diverge-2-6: #d4bbff;
  --cds-charts-diverge-2-6-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-diverge-2-7: #e8daff;
  --cds-charts-diverge-2-7-hovered: rgb(209.8081081081, 182.3, 255);
  --cds-charts-diverge-2-8: #f6f2ff;
  --cds-charts-diverge-2-8-hovered: rgb(221.2846153846, 206.3, 255);
  --cds-charts-diverge-2-9: #ffffff;
  --cds-charts-diverge-2-9-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-diverge-2-10: #d9fbfb;
  --cds-charts-diverge-2-10-hovered: rgb(184.7, 247.6, 247.6);
  --cds-charts-diverge-2-11: #9ef0f0;
  --cds-charts-diverge-2-11-hovered: rgb(127.08125, 235.21875, 235.21875);
  --cds-charts-diverge-2-12: #3ddbd9;
  --cds-charts-diverge-2-12-hovered: rgb(38.2382608696, 206.0617391304, 203.9373913043);
  --cds-charts-diverge-2-13: #08bdba;
  --cds-charts-diverge-2-13-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-diverge-2-14: #009d9a;
  --cds-charts-diverge-2-14-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-diverge-2-15: #007d79;
  --cds-charts-diverge-2-15-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-diverge-2-16: #005d5d;
  --cds-charts-diverge-2-16-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-diverge-2-17: #004144;
  --cds-charts-diverge-2-17-hovered: rgb(0, 30.875, 32.3);
}

.cds--chart-holder[data-carbon-theme=g90],
.cds--chart-holder[data-carbon-theme=g100] {
  --cds-charts-1-1-1: #d4bbff;
  --cds-charts-1-1-1-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-1-2-1: #4589ff;
  --cds-charts-1-2-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-1-3-1: #33b1ff;
  --cds-charts-1-3-1-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-1-4-1: #08bdba;
  --cds-charts-1-4-1-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-2-1-1: #8a3ffc;
  --cds-charts-2-1-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-2-1-2: #08bdba;
  --cds-charts-2-1-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-2-2-1: #8a3ffc;
  --cds-charts-2-2-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-2-2-2: #ff7eb6;
  --cds-charts-2-2-2-hovered: rgb(255, 90.3, 161.7976744186);
  --cds-charts-2-3-1: #ff7eb6;
  --cds-charts-2-3-1-hovered: rgb(255, 90.3, 161.7976744186);
  --cds-charts-2-3-2: #fff1f1;
  --cds-charts-2-3-2-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-2-4-1: #4589ff;
  --cds-charts-2-4-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-2-4-2: #bae6ff;
  --cds-charts-2-4-2-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-2-5-1: #007d79;
  --cds-charts-2-5-1-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-2-5-2: #6fdc8c;
  --cds-charts-2-5-2-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-3-1-1: #8a3ffc;
  --cds-charts-3-1-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-3-1-2: #08bdba;
  --cds-charts-3-1-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-3-1-3: #bae6ff;
  --cds-charts-3-1-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-3-2-1: #8a3ffc;
  --cds-charts-3-2-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-3-2-2: #ff7eb6;
  --cds-charts-3-2-2-hovered: rgb(255, 90.3, 161.7976744186);
  --cds-charts-3-2-3: #fff1f1;
  --cds-charts-3-2-3-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-3-3-1: #4589ff;
  --cds-charts-3-3-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-3-3-2: #08bdba;
  --cds-charts-3-3-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-3-3-3: #d4bbff;
  --cds-charts-3-3-3-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-3-4-1: #4589ff;
  --cds-charts-3-4-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-3-4-2: #6fdc8c;
  --cds-charts-3-4-2-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-3-4-3: #fff1f1;
  --cds-charts-3-4-3-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-3-5-1: #007d79;
  --cds-charts-3-5-1-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-3-5-2: #6fdc8c;
  --cds-charts-3-5-2-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-3-5-3: #bae6ff;
  --cds-charts-3-5-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-4-1-1: #8a3ffc;
  --cds-charts-4-1-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-4-1-2: #08bdba;
  --cds-charts-4-1-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-4-1-3: #bae6ff;
  --cds-charts-4-1-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-4-1-4: #4589ff;
  --cds-charts-4-1-4-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-4-2-1: #4589ff;
  --cds-charts-4-2-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-4-2-2: #08bdba;
  --cds-charts-4-2-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-4-2-3: #d4bbff;
  --cds-charts-4-2-3-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-4-2-4: #fff1f1;
  --cds-charts-4-2-4-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-4-3-1: #007d79;
  --cds-charts-4-3-1-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-4-3-2: #fff1f1;
  --cds-charts-4-3-2-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-4-3-3: #33b1ff;
  --cds-charts-4-3-3-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-4-3-4: #6fdc8c;
  --cds-charts-4-3-4-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-5-1-1: #8a3ffc;
  --cds-charts-5-1-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-5-1-2: #08bdba;
  --cds-charts-5-1-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-5-1-3: #bae6ff;
  --cds-charts-5-1-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-5-1-4: #4589ff;
  --cds-charts-5-1-4-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-5-1-5: #ff7eb6;
  --cds-charts-5-1-5-hovered: rgb(255, 90.3, 161.7976744186);
  --cds-charts-5-2-1: #4589ff;
  --cds-charts-5-2-1-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-5-2-2: #08bdba;
  --cds-charts-5-2-2-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-5-2-3: #d4bbff;
  --cds-charts-5-2-3-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-5-2-4: #fff1f1;
  --cds-charts-5-2-4-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-5-2-5: #6fdc8c;
  --cds-charts-5-2-5-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-14-1-1: #8a3ffc;
  --cds-charts-14-1-1-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-14-1-2: #33b1ff;
  --cds-charts-14-1-2-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-14-1-3: #007d79;
  --cds-charts-14-1-3-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-14-1-4: #ff7eb6;
  --cds-charts-14-1-4-hovered: rgb(255, 90.3, 161.7976744186);
  --cds-charts-14-1-5: #fa4d56;
  --cds-charts-14-1-5-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-14-1-6: #fff1f1;
  --cds-charts-14-1-6-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-14-1-7: #6fdc8c;
  --cds-charts-14-1-7-hovered: rgb(82.2804469274, 213.0195530726, 117.0642458101);
  --cds-charts-14-1-8: #4589ff;
  --cds-charts-14-1-8-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-14-1-9: #d02670;
  --cds-charts-14-1-9-hovered: rgb(177.8146341463, 32.4853658537, 95.7463414634);
  --cds-charts-14-1-10: #d2a106;
  --cds-charts-14-1-10-hovered: rgb(175.2916666667, 134.3902777778, 5.0083333333);
  --cds-charts-14-1-11: #08bdba;
  --cds-charts-14-1-11-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-14-1-12: #bae6ff;
  --cds-charts-14-1-12-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-14-1-13: #ba4e00;
  --cds-charts-14-1-13-hovered: rgb(150.3, 63.0290322581, 0);
  --cds-charts-14-1-14: #d4bbff;
  --cds-charts-14-1-14-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-mono-1-1: #ffffff;
  --cds-charts-mono-1-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-1-2: #f6f2ff;
  --cds-charts-mono-1-2-hovered: rgb(221.2846153846, 206.3, 255);
  --cds-charts-mono-1-3: #e8daff;
  --cds-charts-mono-1-3-hovered: rgb(209.8081081081, 182.3, 255);
  --cds-charts-mono-1-4: #d4bbff;
  --cds-charts-mono-1-4-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-mono-1-5: #be95ff;
  --cds-charts-mono-1-5-hovered: rgb(168.108490566, 113.3, 255);
  --cds-charts-mono-1-6: #a56eff;
  --cds-charts-mono-1-6-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-mono-1-7: #8a3ffc;
  --cds-charts-mono-1-7-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-mono-1-8: #6929c4;
  --cds-charts-mono-1-8-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-mono-1-9: #491d8b;
  --cds-charts-mono-1-9-hovered: rgb(57.4875, 22.8375, 109.4625);
  --cds-charts-mono-1-10: #31135e;
  --cds-charts-mono-1-10-hovered: rgb(33.5194690265, 12.9973451327, 64.3026548673);
  --cds-charts-mono-1-11: #1c0f30;
  --cds-charts-mono-1-11-hovered: rgb(12.1333333333, 6.5, 20.8);
  --cds-charts-mono-2-1: #ffffff;
  --cds-charts-mono-2-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-2-2: #edf5ff;
  --cds-charts-mono-2-2-hovered: rgb(201.3, 225.1666666667, 255);
  --cds-charts-mono-2-3: #d0e2ff;
  --cds-charts-mono-2-3-hovered: rgb(172.3, 203.9723404255, 255);
  --cds-charts-mono-2-4: #a6c8ff;
  --cds-charts-mono-2-4-hovered: rgb(130.3, 177.9382022472, 255);
  --cds-charts-mono-2-5: #78a9ff;
  --cds-charts-mono-2-5-hovered: rgb(84.3, 146.2577777778, 255);
  --cds-charts-mono-2-6: #4589ff;
  --cds-charts-mono-2-6-hovered: rgb(33.3, 114.3516129032, 255);
  --cds-charts-mono-2-7: #0f62fe;
  --cds-charts-mono-2-7-hovered: rgb(0.9680497925, 81.3161825726, 232.3319502075);
  --cds-charts-mono-2-8: #0043ce;
  --cds-charts-mono-2-8-hovered: rgb(0, 55.3888349515, 170.3);
  --cds-charts-mono-2-9: #002d9c;
  --cds-charts-mono-2-9-hovered: rgb(0, 34.7019230769, 120.3);
  --cds-charts-mono-2-10: #001d6c;
  --cds-charts-mono-2-10-hovered: rgb(0, 19.4138888889, 72.3);
  --cds-charts-mono-2-11: #001141;
  --cds-charts-mono-2-11-hovered: rgb(0, 7.6630769231, 29.3);
  --cds-charts-mono-3-1: #ffffff;
  --cds-charts-mono-3-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-3-2: #e5f6ff;
  --cds-charts-mono-3-2-hovered: rgb(193.3, 233.6423076923, 255);
  --cds-charts-mono-3-3: #bae6ff;
  --cds-charts-mono-3-3-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-mono-3-4: #82cfff;
  --cds-charts-mono-3-4-hovered: rgb(94.3, 193.2912, 255);
  --cds-charts-mono-3-5: #33b1ff;
  --cds-charts-mono-3-5-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-mono-3-6: #1192e8;
  --cds-charts-mono-3-6-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-mono-3-7: #0072c3;
  --cds-charts-mono-3-7-hovered: rgb(0, 93.1292307692, 159.3);
  --cds-charts-mono-3-8: #00539a;
  --cds-charts-mono-3-8-hovered: rgb(0, 63.7590909091, 118.3);
  --cds-charts-mono-3-9: #003a6d;
  --cds-charts-mono-3-9-hovered: rgb(0, 39.0036697248, 73.3);
  --cds-charts-mono-3-10: #012749;
  --cds-charts-mono-3-10-hovered: rgb(0.5175675676, 20.1851351351, 37.7824324324);
  --cds-charts-mono-3-11: #061727;
  --cds-charts-mono-3-11-hovered: rgb(1.24, 4.7533333333, 8.06);
  --cds-charts-mono-4-1: #ffffff;
  --cds-charts-mono-4-1-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-mono-4-2: #d9fbfb;
  --cds-charts-mono-4-2-hovered: rgb(184.7, 247.6, 247.6);
  --cds-charts-mono-4-3: #9ef0f0;
  --cds-charts-mono-4-3-hovered: rgb(127.08125, 235.21875, 235.21875);
  --cds-charts-mono-4-4: #3ddbd9;
  --cds-charts-mono-4-4-hovered: rgb(38.2382608696, 206.0617391304, 203.9373913043);
  --cds-charts-mono-4-5: #08bdba;
  --cds-charts-mono-4-5-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-mono-4-6: #009d9a;
  --cds-charts-mono-4-6-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-mono-4-7: #007d79;
  --cds-charts-mono-4-7-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-mono-4-8: #005d5d;
  --cds-charts-mono-4-8-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-mono-4-9: #004144;
  --cds-charts-mono-4-9-hovered: rgb(0, 30.875, 32.3);
  --cds-charts-mono-4-10: #022b30;
  --cds-charts-mono-4-10-hovered: rgb(0.572, 12.298, 13.728);
  --cds-charts-mono-4-11: #081a1c;
  --cds-charts-mono-4-11-hovered: rgb(0.0666666667, 0.2166666667, 0.2333333333);
  --cds-charts-diverge-1-1: #750e13;
  --cds-charts-diverge-1-1-hovered: rgb(85.1152671756, 10.1847328244, 13.8221374046);
  --cds-charts-diverge-1-2: #a2191f;
  --cds-charts-diverge-1-2-hovered: rgb(131.0727272727, 20.2272727273, 25.0818181818);
  --cds-charts-diverge-1-3: #da1e28;
  --cds-charts-diverge-1-3-hovered: rgb(186.6185483871, 25.6814516129, 34.2419354839);
  --cds-charts-diverge-1-4: #fa4d56;
  --cds-charts-diverge-1-4-hovered: rgb(249.0245901639, 42.2754098361, 53.031147541);
  --cds-charts-diverge-1-5: #ff8389;
  --cds-charts-diverge-1-5-hovered: rgb(255, 95.3, 103.0274193548);
  --cds-charts-diverge-1-6: #ffb3b8;
  --cds-charts-diverge-1-6-hovered: rgb(255, 143.3, 150.6486842105);
  --cds-charts-diverge-1-7: #ffd7d9;
  --cds-charts-diverge-1-7-hovered: rgb(255, 179.3, 183.085);
  --cds-charts-diverge-1-8: #fff1f1;
  --cds-charts-diverge-1-8-hovered: rgb(255, 205.3, 205.3);
  --cds-charts-diverge-1-9: #ffffff;
  --cds-charts-diverge-1-9-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-diverge-1-10: #e5f6ff;
  --cds-charts-diverge-1-10-hovered: rgb(193.3, 233.6423076923, 255);
  --cds-charts-diverge-1-11: #bae6ff;
  --cds-charts-diverge-1-11-hovered: rgb(150.3, 217.0652173913, 255);
  --cds-charts-diverge-1-12: #82cfff;
  --cds-charts-diverge-1-12-hovered: rgb(94.3, 193.2912, 255);
  --cds-charts-diverge-1-13: #33b1ff;
  --cds-charts-diverge-1-13-hovered: rgb(15.3, 163.35, 255);
  --cds-charts-diverge-1-14: #1192e8;
  --cds-charts-diverge-1-14-hovered: rgb(14.5626506024, 125.0674698795, 198.7373493976);
  --cds-charts-diverge-1-15: #0072c3;
  --cds-charts-diverge-1-15-hovered: rgb(0, 93.1292307692, 159.3);
  --cds-charts-diverge-1-16: #00539a;
  --cds-charts-diverge-1-16-hovered: rgb(0, 63.7590909091, 118.3);
  --cds-charts-diverge-1-17: #003a6d;
  --cds-charts-diverge-1-17-hovered: rgb(0, 39.0036697248, 73.3);
  --cds-charts-diverge-2-1: #491d8b;
  --cds-charts-diverge-2-1-hovered: rgb(57.4875, 22.8375, 109.4625);
  --cds-charts-diverge-2-2: #6929c4;
  --cds-charts-diverge-2-2-hovered: rgb(89.1835443038, 34.8240506329, 166.4759493671);
  --cds-charts-diverge-2-3: #8a3ffc;
  --cds-charts-diverge-2-3-hovered: rgb(116.58, 27.8492307692, 251.4507692308);
  --cds-charts-diverge-2-4: #a56eff;
  --cds-charts-diverge-2-4-hovered: rgb(142.8413793103, 74.3, 255);
  --cds-charts-diverge-2-5: #be95ff;
  --cds-charts-diverge-2-5-hovered: rgb(168.108490566, 113.3, 255);
  --cds-charts-diverge-2-6: #d4bbff;
  --cds-charts-diverge-2-6-hovered: rgb(189.425, 151.3, 255);
  --cds-charts-diverge-2-7: #e8daff;
  --cds-charts-diverge-2-7-hovered: rgb(209.8081081081, 182.3, 255);
  --cds-charts-diverge-2-8: #f6f2ff;
  --cds-charts-diverge-2-8-hovered: rgb(221.2846153846, 206.3, 255);
  --cds-charts-diverge-2-9: #ffffff;
  --cds-charts-diverge-2-9-hovered: rgb(237.15, 237.15, 237.15);
  --cds-charts-diverge-2-10: #d9fbfb;
  --cds-charts-diverge-2-10-hovered: rgb(184.7, 247.6, 247.6);
  --cds-charts-diverge-2-11: #9ef0f0;
  --cds-charts-diverge-2-11-hovered: rgb(127.08125, 235.21875, 235.21875);
  --cds-charts-diverge-2-12: #3ddbd9;
  --cds-charts-diverge-2-12-hovered: rgb(38.2382608696, 206.0617391304, 203.9373913043);
  --cds-charts-diverge-2-13: #08bdba;
  --cds-charts-diverge-2-13-hovered: rgb(6.5502538071, 154.7497461929, 152.2934010152);
  --cds-charts-diverge-2-14: #009d9a;
  --cds-charts-diverge-2-14-hovered: rgb(0, 121.3, 118.9821656051);
  --cds-charts-diverge-2-15: #007d79;
  --cds-charts-diverge-2-15-hovered: rgb(0, 89.3, 86.4424);
  --cds-charts-diverge-2-16: #005d5d;
  --cds-charts-diverge-2-16-hovered: rgb(0, 57.3, 57.3);
  --cds-charts-diverge-2-17: #004144;
  --cds-charts-diverge-2-17-hovered: rgb(0, 30.875, 32.3);
}

.cds--cc--chart-wrapper .fill-1-1-1 {
  fill: var(--cds-charts-1-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-1-1-1.hovered {
  fill: var(--cds-charts-1-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-1-1-1 {
  background-color: var(--cds-charts-1-1-1, #6929c4);
}
.cds--cc--chart-wrapper .background-1-1-1.hovered {
  background-color: var(--cds-charts-1-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-1-1-1 {
  stroke: var(--cds-charts-1-1-1, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-1-1-1 {
  stop-color: var(--cds-charts-1-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-1-2-1 {
  fill: var(--cds-charts-1-2-1, #002d9c);
}
.cds--cc--chart-wrapper .fill-1-2-1.hovered {
  fill: var(--cds-charts-1-2-1-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-1-2-1 {
  background-color: var(--cds-charts-1-2-1, #002d9c);
}
.cds--cc--chart-wrapper .background-1-2-1.hovered {
  background-color: var(--cds-charts-1-2-1-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-1-2-1 {
  stroke: var(--cds-charts-1-2-1, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-1-2-1 {
  stop-color: var(--cds-charts-1-2-1, #002d9c);
}
.cds--cc--chart-wrapper .fill-1-3-1 {
  fill: var(--cds-charts-1-3-1, #1192e8);
}
.cds--cc--chart-wrapper .fill-1-3-1.hovered {
  fill: var(--cds-charts-1-3-1-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-1-3-1 {
  background-color: var(--cds-charts-1-3-1, #1192e8);
}
.cds--cc--chart-wrapper .background-1-3-1.hovered {
  background-color: var(--cds-charts-1-3-1-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-1-3-1 {
  stroke: var(--cds-charts-1-3-1, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-1-3-1 {
  stop-color: var(--cds-charts-1-3-1, #1192e8);
}
.cds--cc--chart-wrapper .fill-1-4-1 {
  fill: var(--cds-charts-1-4-1, #007d79);
}
.cds--cc--chart-wrapper .fill-1-4-1.hovered {
  fill: var(--cds-charts-1-4-1-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-1-4-1 {
  background-color: var(--cds-charts-1-4-1, #007d79);
}
.cds--cc--chart-wrapper .background-1-4-1.hovered {
  background-color: var(--cds-charts-1-4-1-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-1-4-1 {
  stroke: var(--cds-charts-1-4-1, #007d79);
}
.cds--cc--chart-wrapper .stop-color-1-4-1 {
  stop-color: var(--cds-charts-1-4-1, #007d79);
}
.cds--cc--chart-wrapper .fill-2-1-1 {
  fill: var(--cds-charts-2-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-2-1-1.hovered {
  fill: var(--cds-charts-2-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-1-1 {
  background-color: var(--cds-charts-2-1-1, #6929c4);
}
.cds--cc--chart-wrapper .background-2-1-1.hovered {
  background-color: var(--cds-charts-2-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-1-1 {
  stroke: var(--cds-charts-2-1-1, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-2-1-1 {
  stop-color: var(--cds-charts-2-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-2-1-2 {
  fill: var(--cds-charts-2-1-2, #009d9a);
}
.cds--cc--chart-wrapper .fill-2-1-2.hovered {
  fill: var(--cds-charts-2-1-2-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-1-2 {
  background-color: var(--cds-charts-2-1-2, #009d9a);
}
.cds--cc--chart-wrapper .background-2-1-2.hovered {
  background-color: var(--cds-charts-2-1-2-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-1-2 {
  stroke: var(--cds-charts-2-1-2, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-2-1-2 {
  stop-color: var(--cds-charts-2-1-2, #009d9a);
}
.cds--cc--chart-wrapper .fill-2-2-1 {
  fill: var(--cds-charts-2-2-1, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-2-2-1.hovered {
  fill: var(--cds-charts-2-2-1-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-2-1 {
  background-color: var(--cds-charts-2-2-1, #8a3ffc);
}
.cds--cc--chart-wrapper .background-2-2-1.hovered {
  background-color: var(--cds-charts-2-2-1-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-2-1 {
  stroke: var(--cds-charts-2-2-1, #8a3ffc);
}
.cds--cc--chart-wrapper .stop-color-2-2-1 {
  stop-color: var(--cds-charts-2-2-1, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-2-2-2 {
  fill: var(--cds-charts-2-2-2, #520408);
}
.cds--cc--chart-wrapper .fill-2-2-2.hovered {
  fill: var(--cds-charts-2-2-2-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-2-2 {
  background-color: var(--cds-charts-2-2-2, #520408);
}
.cds--cc--chart-wrapper .background-2-2-2.hovered {
  background-color: var(--cds-charts-2-2-2-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-2-2 {
  stroke: var(--cds-charts-2-2-2, #520408);
}
.cds--cc--chart-wrapper .stop-color-2-2-2 {
  stop-color: var(--cds-charts-2-2-2, #520408);
}
.cds--cc--chart-wrapper .fill-2-3-1 {
  fill: var(--cds-charts-2-3-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-2-3-1.hovered {
  fill: var(--cds-charts-2-3-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-3-1 {
  background-color: var(--cds-charts-2-3-1, #9f1853);
}
.cds--cc--chart-wrapper .background-2-3-1.hovered {
  background-color: var(--cds-charts-2-3-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-3-1 {
  stroke: var(--cds-charts-2-3-1, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-2-3-1 {
  stop-color: var(--cds-charts-2-3-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-2-3-2 {
  fill: var(--cds-charts-2-3-2, #520408);
}
.cds--cc--chart-wrapper .fill-2-3-2.hovered {
  fill: var(--cds-charts-2-3-2-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-3-2 {
  background-color: var(--cds-charts-2-3-2, #520408);
}
.cds--cc--chart-wrapper .background-2-3-2.hovered {
  background-color: var(--cds-charts-2-3-2-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-3-2 {
  stroke: var(--cds-charts-2-3-2, #520408);
}
.cds--cc--chart-wrapper .stop-color-2-3-2 {
  stop-color: var(--cds-charts-2-3-2, #520408);
}
.cds--cc--chart-wrapper .fill-2-4-1 {
  fill: var(--cds-charts-2-4-1, #1192e8);
}
.cds--cc--chart-wrapper .fill-2-4-1.hovered {
  fill: var(--cds-charts-2-4-1-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-4-1 {
  background-color: var(--cds-charts-2-4-1, #1192e8);
}
.cds--cc--chart-wrapper .background-2-4-1.hovered {
  background-color: var(--cds-charts-2-4-1-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-4-1 {
  stroke: var(--cds-charts-2-4-1, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-2-4-1 {
  stop-color: var(--cds-charts-2-4-1, #1192e8);
}
.cds--cc--chart-wrapper .fill-2-4-2 {
  fill: var(--cds-charts-2-4-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-2-4-2.hovered {
  fill: var(--cds-charts-2-4-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-4-2 {
  background-color: var(--cds-charts-2-4-2, #005d5d);
}
.cds--cc--chart-wrapper .background-2-4-2.hovered {
  background-color: var(--cds-charts-2-4-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-4-2 {
  stroke: var(--cds-charts-2-4-2, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-2-4-2 {
  stop-color: var(--cds-charts-2-4-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-2-5-1 {
  fill: var(--cds-charts-2-5-1, #009d9a);
}
.cds--cc--chart-wrapper .fill-2-5-1.hovered {
  fill: var(--cds-charts-2-5-1-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-5-1 {
  background-color: var(--cds-charts-2-5-1, #009d9a);
}
.cds--cc--chart-wrapper .background-2-5-1.hovered {
  background-color: var(--cds-charts-2-5-1-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-5-1 {
  stroke: var(--cds-charts-2-5-1, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-2-5-1 {
  stop-color: var(--cds-charts-2-5-1, #009d9a);
}
.cds--cc--chart-wrapper .fill-2-5-2 {
  fill: var(--cds-charts-2-5-2, #002d9c);
}
.cds--cc--chart-wrapper .fill-2-5-2.hovered {
  fill: var(--cds-charts-2-5-2-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-2-5-2 {
  background-color: var(--cds-charts-2-5-2, #002d9c);
}
.cds--cc--chart-wrapper .background-2-5-2.hovered {
  background-color: var(--cds-charts-2-5-2-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-2-5-2 {
  stroke: var(--cds-charts-2-5-2, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-2-5-2 {
  stop-color: var(--cds-charts-2-5-2, #002d9c);
}
.cds--cc--chart-wrapper .fill-3-1-1 {
  fill: var(--cds-charts-3-1-1, #ee5396);
}
.cds--cc--chart-wrapper .fill-3-1-1.hovered {
  fill: var(--cds-charts-3-1-1-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-1-1 {
  background-color: var(--cds-charts-3-1-1, #ee5396);
}
.cds--cc--chart-wrapper .background-3-1-1.hovered {
  background-color: var(--cds-charts-3-1-1-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-1-1 {
  stroke: var(--cds-charts-3-1-1, #ee5396);
}
.cds--cc--chart-wrapper .stop-color-3-1-1 {
  stop-color: var(--cds-charts-3-1-1, #ee5396);
}
.cds--cc--chart-wrapper .fill-3-1-2 {
  fill: var(--cds-charts-3-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-3-1-2.hovered {
  fill: var(--cds-charts-3-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-1-2 {
  background-color: var(--cds-charts-3-1-2, #1192e8);
}
.cds--cc--chart-wrapper .background-3-1-2.hovered {
  background-color: var(--cds-charts-3-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-1-2 {
  stroke: var(--cds-charts-3-1-2, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-3-1-2 {
  stop-color: var(--cds-charts-3-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-3-1-3 {
  fill: var(--cds-charts-3-1-3, #6929c4);
}
.cds--cc--chart-wrapper .fill-3-1-3.hovered {
  fill: var(--cds-charts-3-1-3-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-1-3 {
  background-color: var(--cds-charts-3-1-3, #6929c4);
}
.cds--cc--chart-wrapper .background-3-1-3.hovered {
  background-color: var(--cds-charts-3-1-3-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-1-3 {
  stroke: var(--cds-charts-3-1-3, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-3-1-3 {
  stop-color: var(--cds-charts-3-1-3, #6929c4);
}
.cds--cc--chart-wrapper .fill-3-2-1 {
  fill: var(--cds-charts-3-2-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-3-2-1.hovered {
  fill: var(--cds-charts-3-2-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-2-1 {
  background-color: var(--cds-charts-3-2-1, #9f1853);
}
.cds--cc--chart-wrapper .background-3-2-1.hovered {
  background-color: var(--cds-charts-3-2-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-2-1 {
  stroke: var(--cds-charts-3-2-1, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-3-2-1 {
  stop-color: var(--cds-charts-3-2-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-3-2-2 {
  fill: var(--cds-charts-3-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .fill-3-2-2.hovered {
  fill: var(--cds-charts-3-2-2-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-2-2 {
  background-color: var(--cds-charts-3-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .background-3-2-2.hovered {
  background-color: var(--cds-charts-3-2-2-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-2-2 {
  stroke: var(--cds-charts-3-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .stop-color-3-2-2 {
  stop-color: var(--cds-charts-3-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .fill-3-2-3 {
  fill: var(--cds-charts-3-2-3, #520408);
}
.cds--cc--chart-wrapper .fill-3-2-3.hovered {
  fill: var(--cds-charts-3-2-3-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-2-3 {
  background-color: var(--cds-charts-3-2-3, #520408);
}
.cds--cc--chart-wrapper .background-3-2-3.hovered {
  background-color: var(--cds-charts-3-2-3-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-2-3 {
  stroke: var(--cds-charts-3-2-3, #520408);
}
.cds--cc--chart-wrapper .stop-color-3-2-3 {
  stop-color: var(--cds-charts-3-2-3, #520408);
}
.cds--cc--chart-wrapper .fill-3-3-1 {
  fill: var(--cds-charts-3-3-1, #a56eff);
}
.cds--cc--chart-wrapper .fill-3-3-1.hovered {
  fill: var(--cds-charts-3-3-1-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-3-1 {
  background-color: var(--cds-charts-3-3-1, #a56eff);
}
.cds--cc--chart-wrapper .background-3-3-1.hovered {
  background-color: var(--cds-charts-3-3-1-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-3-1 {
  stroke: var(--cds-charts-3-3-1, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-3-3-1 {
  stop-color: var(--cds-charts-3-3-1, #a56eff);
}
.cds--cc--chart-wrapper .fill-3-3-2 {
  fill: var(--cds-charts-3-3-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-3-3-2.hovered {
  fill: var(--cds-charts-3-3-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-3-2 {
  background-color: var(--cds-charts-3-3-2, #005d5d);
}
.cds--cc--chart-wrapper .background-3-3-2.hovered {
  background-color: var(--cds-charts-3-3-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-3-2 {
  stroke: var(--cds-charts-3-3-2, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-3-3-2 {
  stop-color: var(--cds-charts-3-3-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-3-3-3 {
  fill: var(--cds-charts-3-3-3, #002d9c);
}
.cds--cc--chart-wrapper .fill-3-3-3.hovered {
  fill: var(--cds-charts-3-3-3-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-3-3 {
  background-color: var(--cds-charts-3-3-3, #002d9c);
}
.cds--cc--chart-wrapper .background-3-3-3.hovered {
  background-color: var(--cds-charts-3-3-3-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-3-3 {
  stroke: var(--cds-charts-3-3-3, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-3-3-3 {
  stop-color: var(--cds-charts-3-3-3, #002d9c);
}
.cds--cc--chart-wrapper .fill-3-4-1 {
  fill: var(--cds-charts-3-4-1, #a56eff);
}
.cds--cc--chart-wrapper .fill-3-4-1.hovered {
  fill: var(--cds-charts-3-4-1-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-4-1 {
  background-color: var(--cds-charts-3-4-1, #a56eff);
}
.cds--cc--chart-wrapper .background-3-4-1.hovered {
  background-color: var(--cds-charts-3-4-1-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-4-1 {
  stroke: var(--cds-charts-3-4-1, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-3-4-1 {
  stop-color: var(--cds-charts-3-4-1, #a56eff);
}
.cds--cc--chart-wrapper .fill-3-4-2 {
  fill: var(--cds-charts-3-4-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-3-4-2.hovered {
  fill: var(--cds-charts-3-4-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-4-2 {
  background-color: var(--cds-charts-3-4-2, #005d5d);
}
.cds--cc--chart-wrapper .background-3-4-2.hovered {
  background-color: var(--cds-charts-3-4-2-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-4-2 {
  stroke: var(--cds-charts-3-4-2, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-3-4-2 {
  stop-color: var(--cds-charts-3-4-2, #005d5d);
}
.cds--cc--chart-wrapper .fill-3-4-3 {
  fill: var(--cds-charts-3-4-3, #9f1853);
}
.cds--cc--chart-wrapper .fill-3-4-3.hovered {
  fill: var(--cds-charts-3-4-3-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-4-3 {
  background-color: var(--cds-charts-3-4-3, #9f1853);
}
.cds--cc--chart-wrapper .background-3-4-3.hovered {
  background-color: var(--cds-charts-3-4-3-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-4-3 {
  stroke: var(--cds-charts-3-4-3, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-3-4-3 {
  stop-color: var(--cds-charts-3-4-3, #9f1853);
}
.cds--cc--chart-wrapper .fill-3-5-1 {
  fill: var(--cds-charts-3-5-1, #012749);
}
.cds--cc--chart-wrapper .fill-3-5-1.hovered {
  fill: var(--cds-charts-3-5-1-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-5-1 {
  background-color: var(--cds-charts-3-5-1, #012749);
}
.cds--cc--chart-wrapper .background-3-5-1.hovered {
  background-color: var(--cds-charts-3-5-1-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-5-1 {
  stroke: var(--cds-charts-3-5-1, #012749);
}
.cds--cc--chart-wrapper .stop-color-3-5-1 {
  stop-color: var(--cds-charts-3-5-1, #012749);
}
.cds--cc--chart-wrapper .fill-3-5-2 {
  fill: var(--cds-charts-3-5-2, #6929c4);
}
.cds--cc--chart-wrapper .fill-3-5-2.hovered {
  fill: var(--cds-charts-3-5-2-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-5-2 {
  background-color: var(--cds-charts-3-5-2, #6929c4);
}
.cds--cc--chart-wrapper .background-3-5-2.hovered {
  background-color: var(--cds-charts-3-5-2-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-5-2 {
  stroke: var(--cds-charts-3-5-2, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-3-5-2 {
  stop-color: var(--cds-charts-3-5-2, #6929c4);
}
.cds--cc--chart-wrapper .fill-3-5-3 {
  fill: var(--cds-charts-3-5-3, #009d9a);
}
.cds--cc--chart-wrapper .fill-3-5-3.hovered {
  fill: var(--cds-charts-3-5-3-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-3-5-3 {
  background-color: var(--cds-charts-3-5-3, #009d9a);
}
.cds--cc--chart-wrapper .background-3-5-3.hovered {
  background-color: var(--cds-charts-3-5-3-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-3-5-3 {
  stroke: var(--cds-charts-3-5-3, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-3-5-3 {
  stop-color: var(--cds-charts-3-5-3, #009d9a);
}
.cds--cc--chart-wrapper .fill-4-1-1 {
  fill: var(--cds-charts-4-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-4-1-1.hovered {
  fill: var(--cds-charts-4-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-1-1 {
  background-color: var(--cds-charts-4-1-1, #6929c4);
}
.cds--cc--chart-wrapper .background-4-1-1.hovered {
  background-color: var(--cds-charts-4-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-1-1 {
  stroke: var(--cds-charts-4-1-1, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-4-1-1 {
  stop-color: var(--cds-charts-4-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-4-1-2 {
  fill: var(--cds-charts-4-1-2, #012749);
}
.cds--cc--chart-wrapper .fill-4-1-2.hovered {
  fill: var(--cds-charts-4-1-2-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-1-2 {
  background-color: var(--cds-charts-4-1-2, #012749);
}
.cds--cc--chart-wrapper .background-4-1-2.hovered {
  background-color: var(--cds-charts-4-1-2-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-1-2 {
  stroke: var(--cds-charts-4-1-2, #012749);
}
.cds--cc--chart-wrapper .stop-color-4-1-2 {
  stop-color: var(--cds-charts-4-1-2, #012749);
}
.cds--cc--chart-wrapper .fill-4-1-3 {
  fill: var(--cds-charts-4-1-3, #009d9a);
}
.cds--cc--chart-wrapper .fill-4-1-3.hovered {
  fill: var(--cds-charts-4-1-3-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-1-3 {
  background-color: var(--cds-charts-4-1-3, #009d9a);
}
.cds--cc--chart-wrapper .background-4-1-3.hovered {
  background-color: var(--cds-charts-4-1-3-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-1-3 {
  stroke: var(--cds-charts-4-1-3, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-4-1-3 {
  stop-color: var(--cds-charts-4-1-3, #009d9a);
}
.cds--cc--chart-wrapper .fill-4-1-4 {
  fill: var(--cds-charts-4-1-4, #ee5396);
}
.cds--cc--chart-wrapper .fill-4-1-4.hovered {
  fill: var(--cds-charts-4-1-4-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-1-4 {
  background-color: var(--cds-charts-4-1-4, #ee5396);
}
.cds--cc--chart-wrapper .background-4-1-4.hovered {
  background-color: var(--cds-charts-4-1-4-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-1-4 {
  stroke: var(--cds-charts-4-1-4, #ee5396);
}
.cds--cc--chart-wrapper .stop-color-4-1-4 {
  stop-color: var(--cds-charts-4-1-4, #ee5396);
}
.cds--cc--chart-wrapper .fill-4-2-1 {
  fill: var(--cds-charts-4-2-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-4-2-1.hovered {
  fill: var(--cds-charts-4-2-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-2-1 {
  background-color: var(--cds-charts-4-2-1, #9f1853);
}
.cds--cc--chart-wrapper .background-4-2-1.hovered {
  background-color: var(--cds-charts-4-2-1-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-2-1 {
  stroke: var(--cds-charts-4-2-1, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-4-2-1 {
  stop-color: var(--cds-charts-4-2-1, #9f1853);
}
.cds--cc--chart-wrapper .fill-4-2-2 {
  fill: var(--cds-charts-4-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .fill-4-2-2.hovered {
  fill: var(--cds-charts-4-2-2-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-2-2 {
  background-color: var(--cds-charts-4-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .background-4-2-2.hovered {
  background-color: var(--cds-charts-4-2-2-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-2-2 {
  stroke: var(--cds-charts-4-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .stop-color-4-2-2 {
  stop-color: var(--cds-charts-4-2-2, #fa4d56);
}
.cds--cc--chart-wrapper .fill-4-2-3 {
  fill: var(--cds-charts-4-2-3, #520408);
}
.cds--cc--chart-wrapper .fill-4-2-3.hovered {
  fill: var(--cds-charts-4-2-3-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-2-3 {
  background-color: var(--cds-charts-4-2-3, #520408);
}
.cds--cc--chart-wrapper .background-4-2-3.hovered {
  background-color: var(--cds-charts-4-2-3-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-2-3 {
  stroke: var(--cds-charts-4-2-3, #520408);
}
.cds--cc--chart-wrapper .stop-color-4-2-3 {
  stop-color: var(--cds-charts-4-2-3, #520408);
}
.cds--cc--chart-wrapper .fill-4-2-4 {
  fill: var(--cds-charts-4-2-4, #a56eff);
}
.cds--cc--chart-wrapper .fill-4-2-4.hovered {
  fill: var(--cds-charts-4-2-4-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-2-4 {
  background-color: var(--cds-charts-4-2-4, #a56eff);
}
.cds--cc--chart-wrapper .background-4-2-4.hovered {
  background-color: var(--cds-charts-4-2-4-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-2-4 {
  stroke: var(--cds-charts-4-2-4, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-4-2-4 {
  stop-color: var(--cds-charts-4-2-4, #a56eff);
}
.cds--cc--chart-wrapper .fill-4-3-1 {
  fill: var(--cds-charts-4-3-1, #009d9a);
}
.cds--cc--chart-wrapper .fill-4-3-1.hovered {
  fill: var(--cds-charts-4-3-1-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-3-1 {
  background-color: var(--cds-charts-4-3-1, #009d9a);
}
.cds--cc--chart-wrapper .background-4-3-1.hovered {
  background-color: var(--cds-charts-4-3-1-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-3-1 {
  stroke: var(--cds-charts-4-3-1, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-4-3-1 {
  stop-color: var(--cds-charts-4-3-1, #009d9a);
}
.cds--cc--chart-wrapper .fill-4-3-2 {
  fill: var(--cds-charts-4-3-2, #002d9c);
}
.cds--cc--chart-wrapper .fill-4-3-2.hovered {
  fill: var(--cds-charts-4-3-2-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-3-2 {
  background-color: var(--cds-charts-4-3-2, #002d9c);
}
.cds--cc--chart-wrapper .background-4-3-2.hovered {
  background-color: var(--cds-charts-4-3-2-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-3-2 {
  stroke: var(--cds-charts-4-3-2, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-4-3-2 {
  stop-color: var(--cds-charts-4-3-2, #002d9c);
}
.cds--cc--chart-wrapper .fill-4-3-3 {
  fill: var(--cds-charts-4-3-3, #a56eff);
}
.cds--cc--chart-wrapper .fill-4-3-3.hovered {
  fill: var(--cds-charts-4-3-3-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-3-3 {
  background-color: var(--cds-charts-4-3-3, #a56eff);
}
.cds--cc--chart-wrapper .background-4-3-3.hovered {
  background-color: var(--cds-charts-4-3-3-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-3-3 {
  stroke: var(--cds-charts-4-3-3, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-4-3-3 {
  stop-color: var(--cds-charts-4-3-3, #a56eff);
}
.cds--cc--chart-wrapper .fill-4-3-4 {
  fill: var(--cds-charts-4-3-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-4-3-4.hovered {
  fill: var(--cds-charts-4-3-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-4-3-4 {
  background-color: var(--cds-charts-4-3-4, #9f1853);
}
.cds--cc--chart-wrapper .background-4-3-4.hovered {
  background-color: var(--cds-charts-4-3-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-4-3-4 {
  stroke: var(--cds-charts-4-3-4, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-4-3-4 {
  stop-color: var(--cds-charts-4-3-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-5-1-1 {
  fill: var(--cds-charts-5-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-5-1-1.hovered {
  fill: var(--cds-charts-5-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-1-1 {
  background-color: var(--cds-charts-5-1-1, #6929c4);
}
.cds--cc--chart-wrapper .background-5-1-1.hovered {
  background-color: var(--cds-charts-5-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-1-1 {
  stroke: var(--cds-charts-5-1-1, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-5-1-1 {
  stop-color: var(--cds-charts-5-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-5-1-2 {
  fill: var(--cds-charts-5-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-5-1-2.hovered {
  fill: var(--cds-charts-5-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-1-2 {
  background-color: var(--cds-charts-5-1-2, #1192e8);
}
.cds--cc--chart-wrapper .background-5-1-2.hovered {
  background-color: var(--cds-charts-5-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-1-2 {
  stroke: var(--cds-charts-5-1-2, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-5-1-2 {
  stop-color: var(--cds-charts-5-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-5-1-3 {
  fill: var(--cds-charts-5-1-3, #005d5d);
}
.cds--cc--chart-wrapper .fill-5-1-3.hovered {
  fill: var(--cds-charts-5-1-3-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-1-3 {
  background-color: var(--cds-charts-5-1-3, #005d5d);
}
.cds--cc--chart-wrapper .background-5-1-3.hovered {
  background-color: var(--cds-charts-5-1-3-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-1-3 {
  stroke: var(--cds-charts-5-1-3, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-5-1-3 {
  stop-color: var(--cds-charts-5-1-3, #005d5d);
}
.cds--cc--chart-wrapper .fill-5-1-4 {
  fill: var(--cds-charts-5-1-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-5-1-4.hovered {
  fill: var(--cds-charts-5-1-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-1-4 {
  background-color: var(--cds-charts-5-1-4, #9f1853);
}
.cds--cc--chart-wrapper .background-5-1-4.hovered {
  background-color: var(--cds-charts-5-1-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-1-4 {
  stroke: var(--cds-charts-5-1-4, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-5-1-4 {
  stop-color: var(--cds-charts-5-1-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-5-1-5 {
  fill: var(--cds-charts-5-1-5, #520408);
}
.cds--cc--chart-wrapper .fill-5-1-5.hovered {
  fill: var(--cds-charts-5-1-5-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-1-5 {
  background-color: var(--cds-charts-5-1-5, #520408);
}
.cds--cc--chart-wrapper .background-5-1-5.hovered {
  background-color: var(--cds-charts-5-1-5-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-1-5 {
  stroke: var(--cds-charts-5-1-5, #520408);
}
.cds--cc--chart-wrapper .stop-color-5-1-5 {
  stop-color: var(--cds-charts-5-1-5, #520408);
}
.cds--cc--chart-wrapper .fill-5-2-1 {
  fill: var(--cds-charts-5-2-1, #002d9c);
}
.cds--cc--chart-wrapper .fill-5-2-1.hovered {
  fill: var(--cds-charts-5-2-1-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-2-1 {
  background-color: var(--cds-charts-5-2-1, #002d9c);
}
.cds--cc--chart-wrapper .background-5-2-1.hovered {
  background-color: var(--cds-charts-5-2-1-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-2-1 {
  stroke: var(--cds-charts-5-2-1, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-5-2-1 {
  stop-color: var(--cds-charts-5-2-1, #002d9c);
}
.cds--cc--chart-wrapper .fill-5-2-2 {
  fill: var(--cds-charts-5-2-2, #009d9a);
}
.cds--cc--chart-wrapper .fill-5-2-2.hovered {
  fill: var(--cds-charts-5-2-2-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-2-2 {
  background-color: var(--cds-charts-5-2-2, #009d9a);
}
.cds--cc--chart-wrapper .background-5-2-2.hovered {
  background-color: var(--cds-charts-5-2-2-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-2-2 {
  stroke: var(--cds-charts-5-2-2, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-5-2-2 {
  stop-color: var(--cds-charts-5-2-2, #009d9a);
}
.cds--cc--chart-wrapper .fill-5-2-3 {
  fill: var(--cds-charts-5-2-3, #9f1853);
}
.cds--cc--chart-wrapper .fill-5-2-3.hovered {
  fill: var(--cds-charts-5-2-3-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-2-3 {
  background-color: var(--cds-charts-5-2-3, #9f1853);
}
.cds--cc--chart-wrapper .background-5-2-3.hovered {
  background-color: var(--cds-charts-5-2-3-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-2-3 {
  stroke: var(--cds-charts-5-2-3, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-5-2-3 {
  stop-color: var(--cds-charts-5-2-3, #9f1853);
}
.cds--cc--chart-wrapper .fill-5-2-4 {
  fill: var(--cds-charts-5-2-4, #520408);
}
.cds--cc--chart-wrapper .fill-5-2-4.hovered {
  fill: var(--cds-charts-5-2-4-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-2-4 {
  background-color: var(--cds-charts-5-2-4, #520408);
}
.cds--cc--chart-wrapper .background-5-2-4.hovered {
  background-color: var(--cds-charts-5-2-4-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-2-4 {
  stroke: var(--cds-charts-5-2-4, #520408);
}
.cds--cc--chart-wrapper .stop-color-5-2-4 {
  stop-color: var(--cds-charts-5-2-4, #520408);
}
.cds--cc--chart-wrapper .fill-5-2-5 {
  fill: var(--cds-charts-5-2-5, #a56eff);
}
.cds--cc--chart-wrapper .fill-5-2-5.hovered {
  fill: var(--cds-charts-5-2-5-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-5-2-5 {
  background-color: var(--cds-charts-5-2-5, #a56eff);
}
.cds--cc--chart-wrapper .background-5-2-5.hovered {
  background-color: var(--cds-charts-5-2-5-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-5-2-5 {
  stroke: var(--cds-charts-5-2-5, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-5-2-5 {
  stop-color: var(--cds-charts-5-2-5, #a56eff);
}
.cds--cc--chart-wrapper .fill-14-1-1 {
  fill: var(--cds-charts-14-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-14-1-1.hovered {
  fill: var(--cds-charts-14-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-1 {
  background-color: var(--cds-charts-14-1-1, #6929c4);
}
.cds--cc--chart-wrapper .background-14-1-1.hovered {
  background-color: var(--cds-charts-14-1-1-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-1 {
  stroke: var(--cds-charts-14-1-1, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-14-1-1 {
  stop-color: var(--cds-charts-14-1-1, #6929c4);
}
.cds--cc--chart-wrapper .fill-14-1-2 {
  fill: var(--cds-charts-14-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-14-1-2.hovered {
  fill: var(--cds-charts-14-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-2 {
  background-color: var(--cds-charts-14-1-2, #1192e8);
}
.cds--cc--chart-wrapper .background-14-1-2.hovered {
  background-color: var(--cds-charts-14-1-2-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-2 {
  stroke: var(--cds-charts-14-1-2, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-14-1-2 {
  stop-color: var(--cds-charts-14-1-2, #1192e8);
}
.cds--cc--chart-wrapper .fill-14-1-3 {
  fill: var(--cds-charts-14-1-3, #005d5d);
}
.cds--cc--chart-wrapper .fill-14-1-3.hovered {
  fill: var(--cds-charts-14-1-3-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-3 {
  background-color: var(--cds-charts-14-1-3, #005d5d);
}
.cds--cc--chart-wrapper .background-14-1-3.hovered {
  background-color: var(--cds-charts-14-1-3-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-3 {
  stroke: var(--cds-charts-14-1-3, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-14-1-3 {
  stop-color: var(--cds-charts-14-1-3, #005d5d);
}
.cds--cc--chart-wrapper .fill-14-1-4 {
  fill: var(--cds-charts-14-1-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-14-1-4.hovered {
  fill: var(--cds-charts-14-1-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-4 {
  background-color: var(--cds-charts-14-1-4, #9f1853);
}
.cds--cc--chart-wrapper .background-14-1-4.hovered {
  background-color: var(--cds-charts-14-1-4-hovered, #9f1853);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-4 {
  stroke: var(--cds-charts-14-1-4, #9f1853);
}
.cds--cc--chart-wrapper .stop-color-14-1-4 {
  stop-color: var(--cds-charts-14-1-4, #9f1853);
}
.cds--cc--chart-wrapper .fill-14-1-5 {
  fill: var(--cds-charts-14-1-5, #fa4d56);
}
.cds--cc--chart-wrapper .fill-14-1-5.hovered {
  fill: var(--cds-charts-14-1-5-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-5 {
  background-color: var(--cds-charts-14-1-5, #fa4d56);
}
.cds--cc--chart-wrapper .background-14-1-5.hovered {
  background-color: var(--cds-charts-14-1-5-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-5 {
  stroke: var(--cds-charts-14-1-5, #fa4d56);
}
.cds--cc--chart-wrapper .stop-color-14-1-5 {
  stop-color: var(--cds-charts-14-1-5, #fa4d56);
}
.cds--cc--chart-wrapper .fill-14-1-6 {
  fill: var(--cds-charts-14-1-6, #520408);
}
.cds--cc--chart-wrapper .fill-14-1-6.hovered {
  fill: var(--cds-charts-14-1-6-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-6 {
  background-color: var(--cds-charts-14-1-6, #520408);
}
.cds--cc--chart-wrapper .background-14-1-6.hovered {
  background-color: var(--cds-charts-14-1-6-hovered, #520408);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-6 {
  stroke: var(--cds-charts-14-1-6, #520408);
}
.cds--cc--chart-wrapper .stop-color-14-1-6 {
  stop-color: var(--cds-charts-14-1-6, #520408);
}
.cds--cc--chart-wrapper .fill-14-1-7 {
  fill: var(--cds-charts-14-1-7, #198038);
}
.cds--cc--chart-wrapper .fill-14-1-7.hovered {
  fill: var(--cds-charts-14-1-7-hovered, #198038);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-7 {
  background-color: var(--cds-charts-14-1-7, #198038);
}
.cds--cc--chart-wrapper .background-14-1-7.hovered {
  background-color: var(--cds-charts-14-1-7-hovered, #198038);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-7 {
  stroke: var(--cds-charts-14-1-7, #198038);
}
.cds--cc--chart-wrapper .stop-color-14-1-7 {
  stop-color: var(--cds-charts-14-1-7, #198038);
}
.cds--cc--chart-wrapper .fill-14-1-8 {
  fill: var(--cds-charts-14-1-8, #002d9c);
}
.cds--cc--chart-wrapper .fill-14-1-8.hovered {
  fill: var(--cds-charts-14-1-8-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-8 {
  background-color: var(--cds-charts-14-1-8, #002d9c);
}
.cds--cc--chart-wrapper .background-14-1-8.hovered {
  background-color: var(--cds-charts-14-1-8-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-8 {
  stroke: var(--cds-charts-14-1-8, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-14-1-8 {
  stop-color: var(--cds-charts-14-1-8, #002d9c);
}
.cds--cc--chart-wrapper .fill-14-1-9 {
  fill: var(--cds-charts-14-1-9, #ee5396);
}
.cds--cc--chart-wrapper .fill-14-1-9.hovered {
  fill: var(--cds-charts-14-1-9-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-9 {
  background-color: var(--cds-charts-14-1-9, #ee5396);
}
.cds--cc--chart-wrapper .background-14-1-9.hovered {
  background-color: var(--cds-charts-14-1-9-hovered, #ee5396);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-9 {
  stroke: var(--cds-charts-14-1-9, #ee5396);
}
.cds--cc--chart-wrapper .stop-color-14-1-9 {
  stop-color: var(--cds-charts-14-1-9, #ee5396);
}
.cds--cc--chart-wrapper .fill-14-1-10 {
  fill: var(--cds-charts-14-1-10, #b28600);
}
.cds--cc--chart-wrapper .fill-14-1-10.hovered {
  fill: var(--cds-charts-14-1-10-hovered, #b28600);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-10 {
  background-color: var(--cds-charts-14-1-10, #b28600);
}
.cds--cc--chart-wrapper .background-14-1-10.hovered {
  background-color: var(--cds-charts-14-1-10-hovered, #b28600);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-10 {
  stroke: var(--cds-charts-14-1-10, #b28600);
}
.cds--cc--chart-wrapper .stop-color-14-1-10 {
  stop-color: var(--cds-charts-14-1-10, #b28600);
}
.cds--cc--chart-wrapper .fill-14-1-11 {
  fill: var(--cds-charts-14-1-11, #009d9a);
}
.cds--cc--chart-wrapper .fill-14-1-11.hovered {
  fill: var(--cds-charts-14-1-11-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-11 {
  background-color: var(--cds-charts-14-1-11, #009d9a);
}
.cds--cc--chart-wrapper .background-14-1-11.hovered {
  background-color: var(--cds-charts-14-1-11-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-11 {
  stroke: var(--cds-charts-14-1-11, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-14-1-11 {
  stop-color: var(--cds-charts-14-1-11, #009d9a);
}
.cds--cc--chart-wrapper .fill-14-1-12 {
  fill: var(--cds-charts-14-1-12, #012749);
}
.cds--cc--chart-wrapper .fill-14-1-12.hovered {
  fill: var(--cds-charts-14-1-12-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-12 {
  background-color: var(--cds-charts-14-1-12, #012749);
}
.cds--cc--chart-wrapper .background-14-1-12.hovered {
  background-color: var(--cds-charts-14-1-12-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-12 {
  stroke: var(--cds-charts-14-1-12, #012749);
}
.cds--cc--chart-wrapper .stop-color-14-1-12 {
  stop-color: var(--cds-charts-14-1-12, #012749);
}
.cds--cc--chart-wrapper .fill-14-1-13 {
  fill: var(--cds-charts-14-1-13, #8a3800);
}
.cds--cc--chart-wrapper .fill-14-1-13.hovered {
  fill: var(--cds-charts-14-1-13-hovered, #8a3800);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-13 {
  background-color: var(--cds-charts-14-1-13, #8a3800);
}
.cds--cc--chart-wrapper .background-14-1-13.hovered {
  background-color: var(--cds-charts-14-1-13-hovered, #8a3800);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-13 {
  stroke: var(--cds-charts-14-1-13, #8a3800);
}
.cds--cc--chart-wrapper .stop-color-14-1-13 {
  stop-color: var(--cds-charts-14-1-13, #8a3800);
}
.cds--cc--chart-wrapper .fill-14-1-14 {
  fill: var(--cds-charts-14-1-14, #a56eff);
}
.cds--cc--chart-wrapper .fill-14-1-14.hovered {
  fill: var(--cds-charts-14-1-14-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-14-1-14 {
  background-color: var(--cds-charts-14-1-14, #a56eff);
}
.cds--cc--chart-wrapper .background-14-1-14.hovered {
  background-color: var(--cds-charts-14-1-14-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-14-1-14 {
  stroke: var(--cds-charts-14-1-14, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-14-1-14 {
  stop-color: var(--cds-charts-14-1-14, #a56eff);
}
.cds--cc--chart-wrapper .fill-mono-1-1 {
  fill: var(--cds-charts-mono-1-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-1-1.hovered {
  fill: var(--cds-charts-mono-1-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-1 {
  background-color: var(--cds-charts-mono-1-1, #ffffff);
}
.cds--cc--chart-wrapper .background-mono-1-1.hovered {
  background-color: var(--cds-charts-mono-1-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-1 {
  stroke: var(--cds-charts-mono-1-1, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-1 {
  stop-color: var(--cds-charts-mono-1-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-1-2 {
  fill: var(--cds-charts-mono-1-2, #f6f2ff);
}
.cds--cc--chart-wrapper .fill-mono-1-2.hovered {
  fill: var(--cds-charts-mono-1-2-hovered, #f6f2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-2 {
  background-color: var(--cds-charts-mono-1-2, #f6f2ff);
}
.cds--cc--chart-wrapper .background-mono-1-2.hovered {
  background-color: var(--cds-charts-mono-1-2-hovered, #f6f2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-2 {
  stroke: var(--cds-charts-mono-1-2, #f6f2ff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-2 {
  stop-color: var(--cds-charts-mono-1-2, #f6f2ff);
}
.cds--cc--chart-wrapper .fill-mono-1-3 {
  fill: var(--cds-charts-mono-1-3, #e8daff);
}
.cds--cc--chart-wrapper .fill-mono-1-3.hovered {
  fill: var(--cds-charts-mono-1-3-hovered, #e8daff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-3 {
  background-color: var(--cds-charts-mono-1-3, #e8daff);
}
.cds--cc--chart-wrapper .background-mono-1-3.hovered {
  background-color: var(--cds-charts-mono-1-3-hovered, #e8daff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-3 {
  stroke: var(--cds-charts-mono-1-3, #e8daff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-3 {
  stop-color: var(--cds-charts-mono-1-3, #e8daff);
}
.cds--cc--chart-wrapper .fill-mono-1-4 {
  fill: var(--cds-charts-mono-1-4, #d4bbff);
}
.cds--cc--chart-wrapper .fill-mono-1-4.hovered {
  fill: var(--cds-charts-mono-1-4-hovered, #d4bbff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-4 {
  background-color: var(--cds-charts-mono-1-4, #d4bbff);
}
.cds--cc--chart-wrapper .background-mono-1-4.hovered {
  background-color: var(--cds-charts-mono-1-4-hovered, #d4bbff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-4 {
  stroke: var(--cds-charts-mono-1-4, #d4bbff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-4 {
  stop-color: var(--cds-charts-mono-1-4, #d4bbff);
}
.cds--cc--chart-wrapper .fill-mono-1-5 {
  fill: var(--cds-charts-mono-1-5, #be95ff);
}
.cds--cc--chart-wrapper .fill-mono-1-5.hovered {
  fill: var(--cds-charts-mono-1-5-hovered, #be95ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-5 {
  background-color: var(--cds-charts-mono-1-5, #be95ff);
}
.cds--cc--chart-wrapper .background-mono-1-5.hovered {
  background-color: var(--cds-charts-mono-1-5-hovered, #be95ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-5 {
  stroke: var(--cds-charts-mono-1-5, #be95ff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-5 {
  stop-color: var(--cds-charts-mono-1-5, #be95ff);
}
.cds--cc--chart-wrapper .fill-mono-1-6 {
  fill: var(--cds-charts-mono-1-6, #a56eff);
}
.cds--cc--chart-wrapper .fill-mono-1-6.hovered {
  fill: var(--cds-charts-mono-1-6-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-6 {
  background-color: var(--cds-charts-mono-1-6, #a56eff);
}
.cds--cc--chart-wrapper .background-mono-1-6.hovered {
  background-color: var(--cds-charts-mono-1-6-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-6 {
  stroke: var(--cds-charts-mono-1-6, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-mono-1-6 {
  stop-color: var(--cds-charts-mono-1-6, #a56eff);
}
.cds--cc--chart-wrapper .fill-mono-1-7 {
  fill: var(--cds-charts-mono-1-7, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-mono-1-7.hovered {
  fill: var(--cds-charts-mono-1-7-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-7 {
  background-color: var(--cds-charts-mono-1-7, #8a3ffc);
}
.cds--cc--chart-wrapper .background-mono-1-7.hovered {
  background-color: var(--cds-charts-mono-1-7-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-7 {
  stroke: var(--cds-charts-mono-1-7, #8a3ffc);
}
.cds--cc--chart-wrapper .stop-color-mono-1-7 {
  stop-color: var(--cds-charts-mono-1-7, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-mono-1-8 {
  fill: var(--cds-charts-mono-1-8, #6929c4);
}
.cds--cc--chart-wrapper .fill-mono-1-8.hovered {
  fill: var(--cds-charts-mono-1-8-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-8 {
  background-color: var(--cds-charts-mono-1-8, #6929c4);
}
.cds--cc--chart-wrapper .background-mono-1-8.hovered {
  background-color: var(--cds-charts-mono-1-8-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-8 {
  stroke: var(--cds-charts-mono-1-8, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-mono-1-8 {
  stop-color: var(--cds-charts-mono-1-8, #6929c4);
}
.cds--cc--chart-wrapper .fill-mono-1-9 {
  fill: var(--cds-charts-mono-1-9, #491d8b);
}
.cds--cc--chart-wrapper .fill-mono-1-9.hovered {
  fill: var(--cds-charts-mono-1-9-hovered, #491d8b);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-9 {
  background-color: var(--cds-charts-mono-1-9, #491d8b);
}
.cds--cc--chart-wrapper .background-mono-1-9.hovered {
  background-color: var(--cds-charts-mono-1-9-hovered, #491d8b);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-9 {
  stroke: var(--cds-charts-mono-1-9, #491d8b);
}
.cds--cc--chart-wrapper .stop-color-mono-1-9 {
  stop-color: var(--cds-charts-mono-1-9, #491d8b);
}
.cds--cc--chart-wrapper .fill-mono-1-10 {
  fill: var(--cds-charts-mono-1-10, #31135e);
}
.cds--cc--chart-wrapper .fill-mono-1-10.hovered {
  fill: var(--cds-charts-mono-1-10-hovered, #31135e);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-10 {
  background-color: var(--cds-charts-mono-1-10, #31135e);
}
.cds--cc--chart-wrapper .background-mono-1-10.hovered {
  background-color: var(--cds-charts-mono-1-10-hovered, #31135e);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-10 {
  stroke: var(--cds-charts-mono-1-10, #31135e);
}
.cds--cc--chart-wrapper .stop-color-mono-1-10 {
  stop-color: var(--cds-charts-mono-1-10, #31135e);
}
.cds--cc--chart-wrapper .fill-mono-1-11 {
  fill: var(--cds-charts-mono-1-11, #1c0f30);
}
.cds--cc--chart-wrapper .fill-mono-1-11.hovered {
  fill: var(--cds-charts-mono-1-11-hovered, #1c0f30);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-1-11 {
  background-color: var(--cds-charts-mono-1-11, #1c0f30);
}
.cds--cc--chart-wrapper .background-mono-1-11.hovered {
  background-color: var(--cds-charts-mono-1-11-hovered, #1c0f30);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-1-11 {
  stroke: var(--cds-charts-mono-1-11, #1c0f30);
}
.cds--cc--chart-wrapper .stop-color-mono-1-11 {
  stop-color: var(--cds-charts-mono-1-11, #1c0f30);
}
.cds--cc--chart-wrapper .fill-mono-2-1 {
  fill: var(--cds-charts-mono-2-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-2-1.hovered {
  fill: var(--cds-charts-mono-2-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-1 {
  background-color: var(--cds-charts-mono-2-1, #ffffff);
}
.cds--cc--chart-wrapper .background-mono-2-1.hovered {
  background-color: var(--cds-charts-mono-2-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-1 {
  stroke: var(--cds-charts-mono-2-1, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-1 {
  stop-color: var(--cds-charts-mono-2-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-2-2 {
  fill: var(--cds-charts-mono-2-2, #edf5ff);
}
.cds--cc--chart-wrapper .fill-mono-2-2.hovered {
  fill: var(--cds-charts-mono-2-2-hovered, #edf5ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-2 {
  background-color: var(--cds-charts-mono-2-2, #edf5ff);
}
.cds--cc--chart-wrapper .background-mono-2-2.hovered {
  background-color: var(--cds-charts-mono-2-2-hovered, #edf5ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-2 {
  stroke: var(--cds-charts-mono-2-2, #edf5ff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-2 {
  stop-color: var(--cds-charts-mono-2-2, #edf5ff);
}
.cds--cc--chart-wrapper .fill-mono-2-3 {
  fill: var(--cds-charts-mono-2-3, #d0e2ff);
}
.cds--cc--chart-wrapper .fill-mono-2-3.hovered {
  fill: var(--cds-charts-mono-2-3-hovered, #d0e2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-3 {
  background-color: var(--cds-charts-mono-2-3, #d0e2ff);
}
.cds--cc--chart-wrapper .background-mono-2-3.hovered {
  background-color: var(--cds-charts-mono-2-3-hovered, #d0e2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-3 {
  stroke: var(--cds-charts-mono-2-3, #d0e2ff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-3 {
  stop-color: var(--cds-charts-mono-2-3, #d0e2ff);
}
.cds--cc--chart-wrapper .fill-mono-2-4 {
  fill: var(--cds-charts-mono-2-4, #a6c8ff);
}
.cds--cc--chart-wrapper .fill-mono-2-4.hovered {
  fill: var(--cds-charts-mono-2-4-hovered, #a6c8ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-4 {
  background-color: var(--cds-charts-mono-2-4, #a6c8ff);
}
.cds--cc--chart-wrapper .background-mono-2-4.hovered {
  background-color: var(--cds-charts-mono-2-4-hovered, #a6c8ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-4 {
  stroke: var(--cds-charts-mono-2-4, #a6c8ff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-4 {
  stop-color: var(--cds-charts-mono-2-4, #a6c8ff);
}
.cds--cc--chart-wrapper .fill-mono-2-5 {
  fill: var(--cds-charts-mono-2-5, #78a9ff);
}
.cds--cc--chart-wrapper .fill-mono-2-5.hovered {
  fill: var(--cds-charts-mono-2-5-hovered, #78a9ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-5 {
  background-color: var(--cds-charts-mono-2-5, #78a9ff);
}
.cds--cc--chart-wrapper .background-mono-2-5.hovered {
  background-color: var(--cds-charts-mono-2-5-hovered, #78a9ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-5 {
  stroke: var(--cds-charts-mono-2-5, #78a9ff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-5 {
  stop-color: var(--cds-charts-mono-2-5, #78a9ff);
}
.cds--cc--chart-wrapper .fill-mono-2-6 {
  fill: var(--cds-charts-mono-2-6, #4589ff);
}
.cds--cc--chart-wrapper .fill-mono-2-6.hovered {
  fill: var(--cds-charts-mono-2-6-hovered, #4589ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-6 {
  background-color: var(--cds-charts-mono-2-6, #4589ff);
}
.cds--cc--chart-wrapper .background-mono-2-6.hovered {
  background-color: var(--cds-charts-mono-2-6-hovered, #4589ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-6 {
  stroke: var(--cds-charts-mono-2-6, #4589ff);
}
.cds--cc--chart-wrapper .stop-color-mono-2-6 {
  stop-color: var(--cds-charts-mono-2-6, #4589ff);
}
.cds--cc--chart-wrapper .fill-mono-2-7 {
  fill: var(--cds-charts-mono-2-7, #0f62fe);
}
.cds--cc--chart-wrapper .fill-mono-2-7.hovered {
  fill: var(--cds-charts-mono-2-7-hovered, #0f62fe);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-7 {
  background-color: var(--cds-charts-mono-2-7, #0f62fe);
}
.cds--cc--chart-wrapper .background-mono-2-7.hovered {
  background-color: var(--cds-charts-mono-2-7-hovered, #0f62fe);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-7 {
  stroke: var(--cds-charts-mono-2-7, #0f62fe);
}
.cds--cc--chart-wrapper .stop-color-mono-2-7 {
  stop-color: var(--cds-charts-mono-2-7, #0f62fe);
}
.cds--cc--chart-wrapper .fill-mono-2-8 {
  fill: var(--cds-charts-mono-2-8, #0043ce);
}
.cds--cc--chart-wrapper .fill-mono-2-8.hovered {
  fill: var(--cds-charts-mono-2-8-hovered, #0043ce);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-8 {
  background-color: var(--cds-charts-mono-2-8, #0043ce);
}
.cds--cc--chart-wrapper .background-mono-2-8.hovered {
  background-color: var(--cds-charts-mono-2-8-hovered, #0043ce);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-8 {
  stroke: var(--cds-charts-mono-2-8, #0043ce);
}
.cds--cc--chart-wrapper .stop-color-mono-2-8 {
  stop-color: var(--cds-charts-mono-2-8, #0043ce);
}
.cds--cc--chart-wrapper .fill-mono-2-9 {
  fill: var(--cds-charts-mono-2-9, #002d9c);
}
.cds--cc--chart-wrapper .fill-mono-2-9.hovered {
  fill: var(--cds-charts-mono-2-9-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-9 {
  background-color: var(--cds-charts-mono-2-9, #002d9c);
}
.cds--cc--chart-wrapper .background-mono-2-9.hovered {
  background-color: var(--cds-charts-mono-2-9-hovered, #002d9c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-9 {
  stroke: var(--cds-charts-mono-2-9, #002d9c);
}
.cds--cc--chart-wrapper .stop-color-mono-2-9 {
  stop-color: var(--cds-charts-mono-2-9, #002d9c);
}
.cds--cc--chart-wrapper .fill-mono-2-10 {
  fill: var(--cds-charts-mono-2-10, #001d6c);
}
.cds--cc--chart-wrapper .fill-mono-2-10.hovered {
  fill: var(--cds-charts-mono-2-10-hovered, #001d6c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-10 {
  background-color: var(--cds-charts-mono-2-10, #001d6c);
}
.cds--cc--chart-wrapper .background-mono-2-10.hovered {
  background-color: var(--cds-charts-mono-2-10-hovered, #001d6c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-10 {
  stroke: var(--cds-charts-mono-2-10, #001d6c);
}
.cds--cc--chart-wrapper .stop-color-mono-2-10 {
  stop-color: var(--cds-charts-mono-2-10, #001d6c);
}
.cds--cc--chart-wrapper .fill-mono-2-11 {
  fill: var(--cds-charts-mono-2-11, #001141);
}
.cds--cc--chart-wrapper .fill-mono-2-11.hovered {
  fill: var(--cds-charts-mono-2-11-hovered, #001141);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-2-11 {
  background-color: var(--cds-charts-mono-2-11, #001141);
}
.cds--cc--chart-wrapper .background-mono-2-11.hovered {
  background-color: var(--cds-charts-mono-2-11-hovered, #001141);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-2-11 {
  stroke: var(--cds-charts-mono-2-11, #001141);
}
.cds--cc--chart-wrapper .stop-color-mono-2-11 {
  stop-color: var(--cds-charts-mono-2-11, #001141);
}
.cds--cc--chart-wrapper .fill-mono-3-1 {
  fill: var(--cds-charts-mono-3-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-3-1.hovered {
  fill: var(--cds-charts-mono-3-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-1 {
  background-color: var(--cds-charts-mono-3-1, #ffffff);
}
.cds--cc--chart-wrapper .background-mono-3-1.hovered {
  background-color: var(--cds-charts-mono-3-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-1 {
  stroke: var(--cds-charts-mono-3-1, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-mono-3-1 {
  stop-color: var(--cds-charts-mono-3-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-3-2 {
  fill: var(--cds-charts-mono-3-2, #e5f6ff);
}
.cds--cc--chart-wrapper .fill-mono-3-2.hovered {
  fill: var(--cds-charts-mono-3-2-hovered, #e5f6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-2 {
  background-color: var(--cds-charts-mono-3-2, #e5f6ff);
}
.cds--cc--chart-wrapper .background-mono-3-2.hovered {
  background-color: var(--cds-charts-mono-3-2-hovered, #e5f6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-2 {
  stroke: var(--cds-charts-mono-3-2, #e5f6ff);
}
.cds--cc--chart-wrapper .stop-color-mono-3-2 {
  stop-color: var(--cds-charts-mono-3-2, #e5f6ff);
}
.cds--cc--chart-wrapper .fill-mono-3-3 {
  fill: var(--cds-charts-mono-3-3, #bae6ff);
}
.cds--cc--chart-wrapper .fill-mono-3-3.hovered {
  fill: var(--cds-charts-mono-3-3-hovered, #bae6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-3 {
  background-color: var(--cds-charts-mono-3-3, #bae6ff);
}
.cds--cc--chart-wrapper .background-mono-3-3.hovered {
  background-color: var(--cds-charts-mono-3-3-hovered, #bae6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-3 {
  stroke: var(--cds-charts-mono-3-3, #bae6ff);
}
.cds--cc--chart-wrapper .stop-color-mono-3-3 {
  stop-color: var(--cds-charts-mono-3-3, #bae6ff);
}
.cds--cc--chart-wrapper .fill-mono-3-4 {
  fill: var(--cds-charts-mono-3-4, #82cfff);
}
.cds--cc--chart-wrapper .fill-mono-3-4.hovered {
  fill: var(--cds-charts-mono-3-4-hovered, #82cfff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-4 {
  background-color: var(--cds-charts-mono-3-4, #82cfff);
}
.cds--cc--chart-wrapper .background-mono-3-4.hovered {
  background-color: var(--cds-charts-mono-3-4-hovered, #82cfff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-4 {
  stroke: var(--cds-charts-mono-3-4, #82cfff);
}
.cds--cc--chart-wrapper .stop-color-mono-3-4 {
  stop-color: var(--cds-charts-mono-3-4, #82cfff);
}
.cds--cc--chart-wrapper .fill-mono-3-5 {
  fill: var(--cds-charts-mono-3-5, #33b1ff);
}
.cds--cc--chart-wrapper .fill-mono-3-5.hovered {
  fill: var(--cds-charts-mono-3-5-hovered, #33b1ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-5 {
  background-color: var(--cds-charts-mono-3-5, #33b1ff);
}
.cds--cc--chart-wrapper .background-mono-3-5.hovered {
  background-color: var(--cds-charts-mono-3-5-hovered, #33b1ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-5 {
  stroke: var(--cds-charts-mono-3-5, #33b1ff);
}
.cds--cc--chart-wrapper .stop-color-mono-3-5 {
  stop-color: var(--cds-charts-mono-3-5, #33b1ff);
}
.cds--cc--chart-wrapper .fill-mono-3-6 {
  fill: var(--cds-charts-mono-3-6, #1192e8);
}
.cds--cc--chart-wrapper .fill-mono-3-6.hovered {
  fill: var(--cds-charts-mono-3-6-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-6 {
  background-color: var(--cds-charts-mono-3-6, #1192e8);
}
.cds--cc--chart-wrapper .background-mono-3-6.hovered {
  background-color: var(--cds-charts-mono-3-6-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-6 {
  stroke: var(--cds-charts-mono-3-6, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-mono-3-6 {
  stop-color: var(--cds-charts-mono-3-6, #1192e8);
}
.cds--cc--chart-wrapper .fill-mono-3-7 {
  fill: var(--cds-charts-mono-3-7, #0072c3);
}
.cds--cc--chart-wrapper .fill-mono-3-7.hovered {
  fill: var(--cds-charts-mono-3-7-hovered, #0072c3);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-7 {
  background-color: var(--cds-charts-mono-3-7, #0072c3);
}
.cds--cc--chart-wrapper .background-mono-3-7.hovered {
  background-color: var(--cds-charts-mono-3-7-hovered, #0072c3);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-7 {
  stroke: var(--cds-charts-mono-3-7, #0072c3);
}
.cds--cc--chart-wrapper .stop-color-mono-3-7 {
  stop-color: var(--cds-charts-mono-3-7, #0072c3);
}
.cds--cc--chart-wrapper .fill-mono-3-8 {
  fill: var(--cds-charts-mono-3-8, #00539a);
}
.cds--cc--chart-wrapper .fill-mono-3-8.hovered {
  fill: var(--cds-charts-mono-3-8-hovered, #00539a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-8 {
  background-color: var(--cds-charts-mono-3-8, #00539a);
}
.cds--cc--chart-wrapper .background-mono-3-8.hovered {
  background-color: var(--cds-charts-mono-3-8-hovered, #00539a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-8 {
  stroke: var(--cds-charts-mono-3-8, #00539a);
}
.cds--cc--chart-wrapper .stop-color-mono-3-8 {
  stop-color: var(--cds-charts-mono-3-8, #00539a);
}
.cds--cc--chart-wrapper .fill-mono-3-9 {
  fill: var(--cds-charts-mono-3-9, #003a6d);
}
.cds--cc--chart-wrapper .fill-mono-3-9.hovered {
  fill: var(--cds-charts-mono-3-9-hovered, #003a6d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-9 {
  background-color: var(--cds-charts-mono-3-9, #003a6d);
}
.cds--cc--chart-wrapper .background-mono-3-9.hovered {
  background-color: var(--cds-charts-mono-3-9-hovered, #003a6d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-9 {
  stroke: var(--cds-charts-mono-3-9, #003a6d);
}
.cds--cc--chart-wrapper .stop-color-mono-3-9 {
  stop-color: var(--cds-charts-mono-3-9, #003a6d);
}
.cds--cc--chart-wrapper .fill-mono-3-10 {
  fill: var(--cds-charts-mono-3-10, #012749);
}
.cds--cc--chart-wrapper .fill-mono-3-10.hovered {
  fill: var(--cds-charts-mono-3-10-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-10 {
  background-color: var(--cds-charts-mono-3-10, #012749);
}
.cds--cc--chart-wrapper .background-mono-3-10.hovered {
  background-color: var(--cds-charts-mono-3-10-hovered, #012749);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-10 {
  stroke: var(--cds-charts-mono-3-10, #012749);
}
.cds--cc--chart-wrapper .stop-color-mono-3-10 {
  stop-color: var(--cds-charts-mono-3-10, #012749);
}
.cds--cc--chart-wrapper .fill-mono-3-11 {
  fill: var(--cds-charts-mono-3-11, #061727);
}
.cds--cc--chart-wrapper .fill-mono-3-11.hovered {
  fill: var(--cds-charts-mono-3-11-hovered, #061727);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-3-11 {
  background-color: var(--cds-charts-mono-3-11, #061727);
}
.cds--cc--chart-wrapper .background-mono-3-11.hovered {
  background-color: var(--cds-charts-mono-3-11-hovered, #061727);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-3-11 {
  stroke: var(--cds-charts-mono-3-11, #061727);
}
.cds--cc--chart-wrapper .stop-color-mono-3-11 {
  stop-color: var(--cds-charts-mono-3-11, #061727);
}
.cds--cc--chart-wrapper .fill-mono-4-1 {
  fill: var(--cds-charts-mono-4-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-4-1.hovered {
  fill: var(--cds-charts-mono-4-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-1 {
  background-color: var(--cds-charts-mono-4-1, #ffffff);
}
.cds--cc--chart-wrapper .background-mono-4-1.hovered {
  background-color: var(--cds-charts-mono-4-1-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-1 {
  stroke: var(--cds-charts-mono-4-1, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-mono-4-1 {
  stop-color: var(--cds-charts-mono-4-1, #ffffff);
}
.cds--cc--chart-wrapper .fill-mono-4-2 {
  fill: var(--cds-charts-mono-4-2, #d9fbfb);
}
.cds--cc--chart-wrapper .fill-mono-4-2.hovered {
  fill: var(--cds-charts-mono-4-2-hovered, #d9fbfb);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-2 {
  background-color: var(--cds-charts-mono-4-2, #d9fbfb);
}
.cds--cc--chart-wrapper .background-mono-4-2.hovered {
  background-color: var(--cds-charts-mono-4-2-hovered, #d9fbfb);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-2 {
  stroke: var(--cds-charts-mono-4-2, #d9fbfb);
}
.cds--cc--chart-wrapper .stop-color-mono-4-2 {
  stop-color: var(--cds-charts-mono-4-2, #d9fbfb);
}
.cds--cc--chart-wrapper .fill-mono-4-3 {
  fill: var(--cds-charts-mono-4-3, #9ef0f0);
}
.cds--cc--chart-wrapper .fill-mono-4-3.hovered {
  fill: var(--cds-charts-mono-4-3-hovered, #9ef0f0);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-3 {
  background-color: var(--cds-charts-mono-4-3, #9ef0f0);
}
.cds--cc--chart-wrapper .background-mono-4-3.hovered {
  background-color: var(--cds-charts-mono-4-3-hovered, #9ef0f0);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-3 {
  stroke: var(--cds-charts-mono-4-3, #9ef0f0);
}
.cds--cc--chart-wrapper .stop-color-mono-4-3 {
  stop-color: var(--cds-charts-mono-4-3, #9ef0f0);
}
.cds--cc--chart-wrapper .fill-mono-4-4 {
  fill: var(--cds-charts-mono-4-4, #3ddbd9);
}
.cds--cc--chart-wrapper .fill-mono-4-4.hovered {
  fill: var(--cds-charts-mono-4-4-hovered, #3ddbd9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-4 {
  background-color: var(--cds-charts-mono-4-4, #3ddbd9);
}
.cds--cc--chart-wrapper .background-mono-4-4.hovered {
  background-color: var(--cds-charts-mono-4-4-hovered, #3ddbd9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-4 {
  stroke: var(--cds-charts-mono-4-4, #3ddbd9);
}
.cds--cc--chart-wrapper .stop-color-mono-4-4 {
  stop-color: var(--cds-charts-mono-4-4, #3ddbd9);
}
.cds--cc--chart-wrapper .fill-mono-4-5 {
  fill: var(--cds-charts-mono-4-5, #08bdba);
}
.cds--cc--chart-wrapper .fill-mono-4-5.hovered {
  fill: var(--cds-charts-mono-4-5-hovered, #08bdba);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-5 {
  background-color: var(--cds-charts-mono-4-5, #08bdba);
}
.cds--cc--chart-wrapper .background-mono-4-5.hovered {
  background-color: var(--cds-charts-mono-4-5-hovered, #08bdba);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-5 {
  stroke: var(--cds-charts-mono-4-5, #08bdba);
}
.cds--cc--chart-wrapper .stop-color-mono-4-5 {
  stop-color: var(--cds-charts-mono-4-5, #08bdba);
}
.cds--cc--chart-wrapper .fill-mono-4-6 {
  fill: var(--cds-charts-mono-4-6, #009d9a);
}
.cds--cc--chart-wrapper .fill-mono-4-6.hovered {
  fill: var(--cds-charts-mono-4-6-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-6 {
  background-color: var(--cds-charts-mono-4-6, #009d9a);
}
.cds--cc--chart-wrapper .background-mono-4-6.hovered {
  background-color: var(--cds-charts-mono-4-6-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-6 {
  stroke: var(--cds-charts-mono-4-6, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-mono-4-6 {
  stop-color: var(--cds-charts-mono-4-6, #009d9a);
}
.cds--cc--chart-wrapper .fill-mono-4-7 {
  fill: var(--cds-charts-mono-4-7, #007d79);
}
.cds--cc--chart-wrapper .fill-mono-4-7.hovered {
  fill: var(--cds-charts-mono-4-7-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-7 {
  background-color: var(--cds-charts-mono-4-7, #007d79);
}
.cds--cc--chart-wrapper .background-mono-4-7.hovered {
  background-color: var(--cds-charts-mono-4-7-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-7 {
  stroke: var(--cds-charts-mono-4-7, #007d79);
}
.cds--cc--chart-wrapper .stop-color-mono-4-7 {
  stop-color: var(--cds-charts-mono-4-7, #007d79);
}
.cds--cc--chart-wrapper .fill-mono-4-8 {
  fill: var(--cds-charts-mono-4-8, #005d5d);
}
.cds--cc--chart-wrapper .fill-mono-4-8.hovered {
  fill: var(--cds-charts-mono-4-8-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-8 {
  background-color: var(--cds-charts-mono-4-8, #005d5d);
}
.cds--cc--chart-wrapper .background-mono-4-8.hovered {
  background-color: var(--cds-charts-mono-4-8-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-8 {
  stroke: var(--cds-charts-mono-4-8, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-mono-4-8 {
  stop-color: var(--cds-charts-mono-4-8, #005d5d);
}
.cds--cc--chart-wrapper .fill-mono-4-9 {
  fill: var(--cds-charts-mono-4-9, #004144);
}
.cds--cc--chart-wrapper .fill-mono-4-9.hovered {
  fill: var(--cds-charts-mono-4-9-hovered, #004144);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-9 {
  background-color: var(--cds-charts-mono-4-9, #004144);
}
.cds--cc--chart-wrapper .background-mono-4-9.hovered {
  background-color: var(--cds-charts-mono-4-9-hovered, #004144);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-9 {
  stroke: var(--cds-charts-mono-4-9, #004144);
}
.cds--cc--chart-wrapper .stop-color-mono-4-9 {
  stop-color: var(--cds-charts-mono-4-9, #004144);
}
.cds--cc--chart-wrapper .fill-mono-4-10 {
  fill: var(--cds-charts-mono-4-10, #022b30);
}
.cds--cc--chart-wrapper .fill-mono-4-10.hovered {
  fill: var(--cds-charts-mono-4-10-hovered, #022b30);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-10 {
  background-color: var(--cds-charts-mono-4-10, #022b30);
}
.cds--cc--chart-wrapper .background-mono-4-10.hovered {
  background-color: var(--cds-charts-mono-4-10-hovered, #022b30);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-10 {
  stroke: var(--cds-charts-mono-4-10, #022b30);
}
.cds--cc--chart-wrapper .stop-color-mono-4-10 {
  stop-color: var(--cds-charts-mono-4-10, #022b30);
}
.cds--cc--chart-wrapper .fill-mono-4-11 {
  fill: var(--cds-charts-mono-4-11, #081a1c);
}
.cds--cc--chart-wrapper .fill-mono-4-11.hovered {
  fill: var(--cds-charts-mono-4-11-hovered, #081a1c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-mono-4-11 {
  background-color: var(--cds-charts-mono-4-11, #081a1c);
}
.cds--cc--chart-wrapper .background-mono-4-11.hovered {
  background-color: var(--cds-charts-mono-4-11-hovered, #081a1c);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-mono-4-11 {
  stroke: var(--cds-charts-mono-4-11, #081a1c);
}
.cds--cc--chart-wrapper .stop-color-mono-4-11 {
  stop-color: var(--cds-charts-mono-4-11, #081a1c);
}
.cds--cc--chart-wrapper .fill-diverge-1-1 {
  fill: var(--cds-charts-diverge-1-1, #750e13);
}
.cds--cc--chart-wrapper .fill-diverge-1-1.hovered {
  fill: var(--cds-charts-diverge-1-1-hovered, #750e13);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-1 {
  background-color: var(--cds-charts-diverge-1-1, #750e13);
}
.cds--cc--chart-wrapper .background-diverge-1-1.hovered {
  background-color: var(--cds-charts-diverge-1-1-hovered, #750e13);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-1 {
  stroke: var(--cds-charts-diverge-1-1, #750e13);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-1 {
  stop-color: var(--cds-charts-diverge-1-1, #750e13);
}
.cds--cc--chart-wrapper .fill-diverge-1-2 {
  fill: var(--cds-charts-diverge-1-2, #a2191f);
}
.cds--cc--chart-wrapper .fill-diverge-1-2.hovered {
  fill: var(--cds-charts-diverge-1-2-hovered, #a2191f);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-2 {
  background-color: var(--cds-charts-diverge-1-2, #a2191f);
}
.cds--cc--chart-wrapper .background-diverge-1-2.hovered {
  background-color: var(--cds-charts-diverge-1-2-hovered, #a2191f);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-2 {
  stroke: var(--cds-charts-diverge-1-2, #a2191f);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-2 {
  stop-color: var(--cds-charts-diverge-1-2, #a2191f);
}
.cds--cc--chart-wrapper .fill-diverge-1-3 {
  fill: var(--cds-charts-diverge-1-3, #da1e28);
}
.cds--cc--chart-wrapper .fill-diverge-1-3.hovered {
  fill: var(--cds-charts-diverge-1-3-hovered, #da1e28);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-3 {
  background-color: var(--cds-charts-diverge-1-3, #da1e28);
}
.cds--cc--chart-wrapper .background-diverge-1-3.hovered {
  background-color: var(--cds-charts-diverge-1-3-hovered, #da1e28);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-3 {
  stroke: var(--cds-charts-diverge-1-3, #da1e28);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-3 {
  stop-color: var(--cds-charts-diverge-1-3, #da1e28);
}
.cds--cc--chart-wrapper .fill-diverge-1-4 {
  fill: var(--cds-charts-diverge-1-4, #fa4d56);
}
.cds--cc--chart-wrapper .fill-diverge-1-4.hovered {
  fill: var(--cds-charts-diverge-1-4-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-4 {
  background-color: var(--cds-charts-diverge-1-4, #fa4d56);
}
.cds--cc--chart-wrapper .background-diverge-1-4.hovered {
  background-color: var(--cds-charts-diverge-1-4-hovered, #fa4d56);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-4 {
  stroke: var(--cds-charts-diverge-1-4, #fa4d56);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-4 {
  stop-color: var(--cds-charts-diverge-1-4, #fa4d56);
}
.cds--cc--chart-wrapper .fill-diverge-1-5 {
  fill: var(--cds-charts-diverge-1-5, #ff8389);
}
.cds--cc--chart-wrapper .fill-diverge-1-5.hovered {
  fill: var(--cds-charts-diverge-1-5-hovered, #ff8389);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-5 {
  background-color: var(--cds-charts-diverge-1-5, #ff8389);
}
.cds--cc--chart-wrapper .background-diverge-1-5.hovered {
  background-color: var(--cds-charts-diverge-1-5-hovered, #ff8389);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-5 {
  stroke: var(--cds-charts-diverge-1-5, #ff8389);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-5 {
  stop-color: var(--cds-charts-diverge-1-5, #ff8389);
}
.cds--cc--chart-wrapper .fill-diverge-1-6 {
  fill: var(--cds-charts-diverge-1-6, #ffb3b8);
}
.cds--cc--chart-wrapper .fill-diverge-1-6.hovered {
  fill: var(--cds-charts-diverge-1-6-hovered, #ffb3b8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-6 {
  background-color: var(--cds-charts-diverge-1-6, #ffb3b8);
}
.cds--cc--chart-wrapper .background-diverge-1-6.hovered {
  background-color: var(--cds-charts-diverge-1-6-hovered, #ffb3b8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-6 {
  stroke: var(--cds-charts-diverge-1-6, #ffb3b8);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-6 {
  stop-color: var(--cds-charts-diverge-1-6, #ffb3b8);
}
.cds--cc--chart-wrapper .fill-diverge-1-7 {
  fill: var(--cds-charts-diverge-1-7, #ffd7d9);
}
.cds--cc--chart-wrapper .fill-diverge-1-7.hovered {
  fill: var(--cds-charts-diverge-1-7-hovered, #ffd7d9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-7 {
  background-color: var(--cds-charts-diverge-1-7, #ffd7d9);
}
.cds--cc--chart-wrapper .background-diverge-1-7.hovered {
  background-color: var(--cds-charts-diverge-1-7-hovered, #ffd7d9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-7 {
  stroke: var(--cds-charts-diverge-1-7, #ffd7d9);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-7 {
  stop-color: var(--cds-charts-diverge-1-7, #ffd7d9);
}
.cds--cc--chart-wrapper .fill-diverge-1-8 {
  fill: var(--cds-charts-diverge-1-8, #fff1f1);
}
.cds--cc--chart-wrapper .fill-diverge-1-8.hovered {
  fill: var(--cds-charts-diverge-1-8-hovered, #fff1f1);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-8 {
  background-color: var(--cds-charts-diverge-1-8, #fff1f1);
}
.cds--cc--chart-wrapper .background-diverge-1-8.hovered {
  background-color: var(--cds-charts-diverge-1-8-hovered, #fff1f1);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-8 {
  stroke: var(--cds-charts-diverge-1-8, #fff1f1);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-8 {
  stop-color: var(--cds-charts-diverge-1-8, #fff1f1);
}
.cds--cc--chart-wrapper .fill-diverge-1-9 {
  fill: var(--cds-charts-diverge-1-9, #ffffff);
}
.cds--cc--chart-wrapper .fill-diverge-1-9.hovered {
  fill: var(--cds-charts-diverge-1-9-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-9 {
  background-color: var(--cds-charts-diverge-1-9, #ffffff);
}
.cds--cc--chart-wrapper .background-diverge-1-9.hovered {
  background-color: var(--cds-charts-diverge-1-9-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-9 {
  stroke: var(--cds-charts-diverge-1-9, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-9 {
  stop-color: var(--cds-charts-diverge-1-9, #ffffff);
}
.cds--cc--chart-wrapper .fill-diverge-1-10 {
  fill: var(--cds-charts-diverge-1-10, #e5f6ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-10.hovered {
  fill: var(--cds-charts-diverge-1-10-hovered, #e5f6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-10 {
  background-color: var(--cds-charts-diverge-1-10, #e5f6ff);
}
.cds--cc--chart-wrapper .background-diverge-1-10.hovered {
  background-color: var(--cds-charts-diverge-1-10-hovered, #e5f6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-10 {
  stroke: var(--cds-charts-diverge-1-10, #e5f6ff);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-10 {
  stop-color: var(--cds-charts-diverge-1-10, #e5f6ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-11 {
  fill: var(--cds-charts-diverge-1-11, #bae6ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-11.hovered {
  fill: var(--cds-charts-diverge-1-11-hovered, #bae6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-11 {
  background-color: var(--cds-charts-diverge-1-11, #bae6ff);
}
.cds--cc--chart-wrapper .background-diverge-1-11.hovered {
  background-color: var(--cds-charts-diverge-1-11-hovered, #bae6ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-11 {
  stroke: var(--cds-charts-diverge-1-11, #bae6ff);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-11 {
  stop-color: var(--cds-charts-diverge-1-11, #bae6ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-12 {
  fill: var(--cds-charts-diverge-1-12, #82cfff);
}
.cds--cc--chart-wrapper .fill-diverge-1-12.hovered {
  fill: var(--cds-charts-diverge-1-12-hovered, #82cfff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-12 {
  background-color: var(--cds-charts-diverge-1-12, #82cfff);
}
.cds--cc--chart-wrapper .background-diverge-1-12.hovered {
  background-color: var(--cds-charts-diverge-1-12-hovered, #82cfff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-12 {
  stroke: var(--cds-charts-diverge-1-12, #82cfff);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-12 {
  stop-color: var(--cds-charts-diverge-1-12, #82cfff);
}
.cds--cc--chart-wrapper .fill-diverge-1-13 {
  fill: var(--cds-charts-diverge-1-13, #33b1ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-13.hovered {
  fill: var(--cds-charts-diverge-1-13-hovered, #33b1ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-13 {
  background-color: var(--cds-charts-diverge-1-13, #33b1ff);
}
.cds--cc--chart-wrapper .background-diverge-1-13.hovered {
  background-color: var(--cds-charts-diverge-1-13-hovered, #33b1ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-13 {
  stroke: var(--cds-charts-diverge-1-13, #33b1ff);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-13 {
  stop-color: var(--cds-charts-diverge-1-13, #33b1ff);
}
.cds--cc--chart-wrapper .fill-diverge-1-14 {
  fill: var(--cds-charts-diverge-1-14, #1192e8);
}
.cds--cc--chart-wrapper .fill-diverge-1-14.hovered {
  fill: var(--cds-charts-diverge-1-14-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-14 {
  background-color: var(--cds-charts-diverge-1-14, #1192e8);
}
.cds--cc--chart-wrapper .background-diverge-1-14.hovered {
  background-color: var(--cds-charts-diverge-1-14-hovered, #1192e8);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-14 {
  stroke: var(--cds-charts-diverge-1-14, #1192e8);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-14 {
  stop-color: var(--cds-charts-diverge-1-14, #1192e8);
}
.cds--cc--chart-wrapper .fill-diverge-1-15 {
  fill: var(--cds-charts-diverge-1-15, #0072c3);
}
.cds--cc--chart-wrapper .fill-diverge-1-15.hovered {
  fill: var(--cds-charts-diverge-1-15-hovered, #0072c3);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-15 {
  background-color: var(--cds-charts-diverge-1-15, #0072c3);
}
.cds--cc--chart-wrapper .background-diverge-1-15.hovered {
  background-color: var(--cds-charts-diverge-1-15-hovered, #0072c3);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-15 {
  stroke: var(--cds-charts-diverge-1-15, #0072c3);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-15 {
  stop-color: var(--cds-charts-diverge-1-15, #0072c3);
}
.cds--cc--chart-wrapper .fill-diverge-1-16 {
  fill: var(--cds-charts-diverge-1-16, #00539a);
}
.cds--cc--chart-wrapper .fill-diverge-1-16.hovered {
  fill: var(--cds-charts-diverge-1-16-hovered, #00539a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-16 {
  background-color: var(--cds-charts-diverge-1-16, #00539a);
}
.cds--cc--chart-wrapper .background-diverge-1-16.hovered {
  background-color: var(--cds-charts-diverge-1-16-hovered, #00539a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-16 {
  stroke: var(--cds-charts-diverge-1-16, #00539a);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-16 {
  stop-color: var(--cds-charts-diverge-1-16, #00539a);
}
.cds--cc--chart-wrapper .fill-diverge-1-17 {
  fill: var(--cds-charts-diverge-1-17, #003a6d);
}
.cds--cc--chart-wrapper .fill-diverge-1-17.hovered {
  fill: var(--cds-charts-diverge-1-17-hovered, #003a6d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-1-17 {
  background-color: var(--cds-charts-diverge-1-17, #003a6d);
}
.cds--cc--chart-wrapper .background-diverge-1-17.hovered {
  background-color: var(--cds-charts-diverge-1-17-hovered, #003a6d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-1-17 {
  stroke: var(--cds-charts-diverge-1-17, #003a6d);
}
.cds--cc--chart-wrapper .stop-color-diverge-1-17 {
  stop-color: var(--cds-charts-diverge-1-17, #003a6d);
}
.cds--cc--chart-wrapper .fill-diverge-2-1 {
  fill: var(--cds-charts-diverge-2-1, #491d8b);
}
.cds--cc--chart-wrapper .fill-diverge-2-1.hovered {
  fill: var(--cds-charts-diverge-2-1-hovered, #491d8b);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-1 {
  background-color: var(--cds-charts-diverge-2-1, #491d8b);
}
.cds--cc--chart-wrapper .background-diverge-2-1.hovered {
  background-color: var(--cds-charts-diverge-2-1-hovered, #491d8b);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-1 {
  stroke: var(--cds-charts-diverge-2-1, #491d8b);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-1 {
  stop-color: var(--cds-charts-diverge-2-1, #491d8b);
}
.cds--cc--chart-wrapper .fill-diverge-2-2 {
  fill: var(--cds-charts-diverge-2-2, #6929c4);
}
.cds--cc--chart-wrapper .fill-diverge-2-2.hovered {
  fill: var(--cds-charts-diverge-2-2-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-2 {
  background-color: var(--cds-charts-diverge-2-2, #6929c4);
}
.cds--cc--chart-wrapper .background-diverge-2-2.hovered {
  background-color: var(--cds-charts-diverge-2-2-hovered, #6929c4);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-2 {
  stroke: var(--cds-charts-diverge-2-2, #6929c4);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-2 {
  stop-color: var(--cds-charts-diverge-2-2, #6929c4);
}
.cds--cc--chart-wrapper .fill-diverge-2-3 {
  fill: var(--cds-charts-diverge-2-3, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-diverge-2-3.hovered {
  fill: var(--cds-charts-diverge-2-3-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-3 {
  background-color: var(--cds-charts-diverge-2-3, #8a3ffc);
}
.cds--cc--chart-wrapper .background-diverge-2-3.hovered {
  background-color: var(--cds-charts-diverge-2-3-hovered, #8a3ffc);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-3 {
  stroke: var(--cds-charts-diverge-2-3, #8a3ffc);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-3 {
  stop-color: var(--cds-charts-diverge-2-3, #8a3ffc);
}
.cds--cc--chart-wrapper .fill-diverge-2-4 {
  fill: var(--cds-charts-diverge-2-4, #a56eff);
}
.cds--cc--chart-wrapper .fill-diverge-2-4.hovered {
  fill: var(--cds-charts-diverge-2-4-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-4 {
  background-color: var(--cds-charts-diverge-2-4, #a56eff);
}
.cds--cc--chart-wrapper .background-diverge-2-4.hovered {
  background-color: var(--cds-charts-diverge-2-4-hovered, #a56eff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-4 {
  stroke: var(--cds-charts-diverge-2-4, #a56eff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-4 {
  stop-color: var(--cds-charts-diverge-2-4, #a56eff);
}
.cds--cc--chart-wrapper .fill-diverge-2-5 {
  fill: var(--cds-charts-diverge-2-5, #be95ff);
}
.cds--cc--chart-wrapper .fill-diverge-2-5.hovered {
  fill: var(--cds-charts-diverge-2-5-hovered, #be95ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-5 {
  background-color: var(--cds-charts-diverge-2-5, #be95ff);
}
.cds--cc--chart-wrapper .background-diverge-2-5.hovered {
  background-color: var(--cds-charts-diverge-2-5-hovered, #be95ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-5 {
  stroke: var(--cds-charts-diverge-2-5, #be95ff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-5 {
  stop-color: var(--cds-charts-diverge-2-5, #be95ff);
}
.cds--cc--chart-wrapper .fill-diverge-2-6 {
  fill: var(--cds-charts-diverge-2-6, #d4bbff);
}
.cds--cc--chart-wrapper .fill-diverge-2-6.hovered {
  fill: var(--cds-charts-diverge-2-6-hovered, #d4bbff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-6 {
  background-color: var(--cds-charts-diverge-2-6, #d4bbff);
}
.cds--cc--chart-wrapper .background-diverge-2-6.hovered {
  background-color: var(--cds-charts-diverge-2-6-hovered, #d4bbff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-6 {
  stroke: var(--cds-charts-diverge-2-6, #d4bbff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-6 {
  stop-color: var(--cds-charts-diverge-2-6, #d4bbff);
}
.cds--cc--chart-wrapper .fill-diverge-2-7 {
  fill: var(--cds-charts-diverge-2-7, #e8daff);
}
.cds--cc--chart-wrapper .fill-diverge-2-7.hovered {
  fill: var(--cds-charts-diverge-2-7-hovered, #e8daff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-7 {
  background-color: var(--cds-charts-diverge-2-7, #e8daff);
}
.cds--cc--chart-wrapper .background-diverge-2-7.hovered {
  background-color: var(--cds-charts-diverge-2-7-hovered, #e8daff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-7 {
  stroke: var(--cds-charts-diverge-2-7, #e8daff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-7 {
  stop-color: var(--cds-charts-diverge-2-7, #e8daff);
}
.cds--cc--chart-wrapper .fill-diverge-2-8 {
  fill: var(--cds-charts-diverge-2-8, #f6f2ff);
}
.cds--cc--chart-wrapper .fill-diverge-2-8.hovered {
  fill: var(--cds-charts-diverge-2-8-hovered, #f6f2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-8 {
  background-color: var(--cds-charts-diverge-2-8, #f6f2ff);
}
.cds--cc--chart-wrapper .background-diverge-2-8.hovered {
  background-color: var(--cds-charts-diverge-2-8-hovered, #f6f2ff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-8 {
  stroke: var(--cds-charts-diverge-2-8, #f6f2ff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-8 {
  stop-color: var(--cds-charts-diverge-2-8, #f6f2ff);
}
.cds--cc--chart-wrapper .fill-diverge-2-9 {
  fill: var(--cds-charts-diverge-2-9, #ffffff);
}
.cds--cc--chart-wrapper .fill-diverge-2-9.hovered {
  fill: var(--cds-charts-diverge-2-9-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-9 {
  background-color: var(--cds-charts-diverge-2-9, #ffffff);
}
.cds--cc--chart-wrapper .background-diverge-2-9.hovered {
  background-color: var(--cds-charts-diverge-2-9-hovered, #ffffff);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-9 {
  stroke: var(--cds-charts-diverge-2-9, #ffffff);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-9 {
  stop-color: var(--cds-charts-diverge-2-9, #ffffff);
}
.cds--cc--chart-wrapper .fill-diverge-2-10 {
  fill: var(--cds-charts-diverge-2-10, #d9fbfb);
}
.cds--cc--chart-wrapper .fill-diverge-2-10.hovered {
  fill: var(--cds-charts-diverge-2-10-hovered, #d9fbfb);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-10 {
  background-color: var(--cds-charts-diverge-2-10, #d9fbfb);
}
.cds--cc--chart-wrapper .background-diverge-2-10.hovered {
  background-color: var(--cds-charts-diverge-2-10-hovered, #d9fbfb);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-10 {
  stroke: var(--cds-charts-diverge-2-10, #d9fbfb);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-10 {
  stop-color: var(--cds-charts-diverge-2-10, #d9fbfb);
}
.cds--cc--chart-wrapper .fill-diverge-2-11 {
  fill: var(--cds-charts-diverge-2-11, #9ef0f0);
}
.cds--cc--chart-wrapper .fill-diverge-2-11.hovered {
  fill: var(--cds-charts-diverge-2-11-hovered, #9ef0f0);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-11 {
  background-color: var(--cds-charts-diverge-2-11, #9ef0f0);
}
.cds--cc--chart-wrapper .background-diverge-2-11.hovered {
  background-color: var(--cds-charts-diverge-2-11-hovered, #9ef0f0);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-11 {
  stroke: var(--cds-charts-diverge-2-11, #9ef0f0);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-11 {
  stop-color: var(--cds-charts-diverge-2-11, #9ef0f0);
}
.cds--cc--chart-wrapper .fill-diverge-2-12 {
  fill: var(--cds-charts-diverge-2-12, #3ddbd9);
}
.cds--cc--chart-wrapper .fill-diverge-2-12.hovered {
  fill: var(--cds-charts-diverge-2-12-hovered, #3ddbd9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-12 {
  background-color: var(--cds-charts-diverge-2-12, #3ddbd9);
}
.cds--cc--chart-wrapper .background-diverge-2-12.hovered {
  background-color: var(--cds-charts-diverge-2-12-hovered, #3ddbd9);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-12 {
  stroke: var(--cds-charts-diverge-2-12, #3ddbd9);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-12 {
  stop-color: var(--cds-charts-diverge-2-12, #3ddbd9);
}
.cds--cc--chart-wrapper .fill-diverge-2-13 {
  fill: var(--cds-charts-diverge-2-13, #08bdba);
}
.cds--cc--chart-wrapper .fill-diverge-2-13.hovered {
  fill: var(--cds-charts-diverge-2-13-hovered, #08bdba);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-13 {
  background-color: var(--cds-charts-diverge-2-13, #08bdba);
}
.cds--cc--chart-wrapper .background-diverge-2-13.hovered {
  background-color: var(--cds-charts-diverge-2-13-hovered, #08bdba);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-13 {
  stroke: var(--cds-charts-diverge-2-13, #08bdba);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-13 {
  stop-color: var(--cds-charts-diverge-2-13, #08bdba);
}
.cds--cc--chart-wrapper .fill-diverge-2-14 {
  fill: var(--cds-charts-diverge-2-14, #009d9a);
}
.cds--cc--chart-wrapper .fill-diverge-2-14.hovered {
  fill: var(--cds-charts-diverge-2-14-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-14 {
  background-color: var(--cds-charts-diverge-2-14, #009d9a);
}
.cds--cc--chart-wrapper .background-diverge-2-14.hovered {
  background-color: var(--cds-charts-diverge-2-14-hovered, #009d9a);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-14 {
  stroke: var(--cds-charts-diverge-2-14, #009d9a);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-14 {
  stop-color: var(--cds-charts-diverge-2-14, #009d9a);
}
.cds--cc--chart-wrapper .fill-diverge-2-15 {
  fill: var(--cds-charts-diverge-2-15, #007d79);
}
.cds--cc--chart-wrapper .fill-diverge-2-15.hovered {
  fill: var(--cds-charts-diverge-2-15-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-15 {
  background-color: var(--cds-charts-diverge-2-15, #007d79);
}
.cds--cc--chart-wrapper .background-diverge-2-15.hovered {
  background-color: var(--cds-charts-diverge-2-15-hovered, #007d79);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-15 {
  stroke: var(--cds-charts-diverge-2-15, #007d79);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-15 {
  stop-color: var(--cds-charts-diverge-2-15, #007d79);
}
.cds--cc--chart-wrapper .fill-diverge-2-16 {
  fill: var(--cds-charts-diverge-2-16, #005d5d);
}
.cds--cc--chart-wrapper .fill-diverge-2-16.hovered {
  fill: var(--cds-charts-diverge-2-16-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-16 {
  background-color: var(--cds-charts-diverge-2-16, #005d5d);
}
.cds--cc--chart-wrapper .background-diverge-2-16.hovered {
  background-color: var(--cds-charts-diverge-2-16-hovered, #005d5d);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-16 {
  stroke: var(--cds-charts-diverge-2-16, #005d5d);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-16 {
  stop-color: var(--cds-charts-diverge-2-16, #005d5d);
}
.cds--cc--chart-wrapper .fill-diverge-2-17 {
  fill: var(--cds-charts-diverge-2-17, #004144);
}
.cds--cc--chart-wrapper .fill-diverge-2-17.hovered {
  fill: var(--cds-charts-diverge-2-17-hovered, #004144);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .background-diverge-2-17 {
  background-color: var(--cds-charts-diverge-2-17, #004144);
}
.cds--cc--chart-wrapper .background-diverge-2-17.hovered {
  background-color: var(--cds-charts-diverge-2-17-hovered, #004144);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .stroke-diverge-2-17 {
  stroke: var(--cds-charts-diverge-2-17, #004144);
}
.cds--cc--chart-wrapper .stop-color-diverge-2-17 {
  stop-color: var(--cds-charts-diverge-2-17, #004144);
}

.cds--cc--tooltip .tooltip-1-1-1 {
  background-color: var(--cds-charts-1-1-1, #6929c4);
}
.cds--cc--tooltip .tooltip-1-2-1 {
  background-color: var(--cds-charts-1-2-1, #002d9c);
}
.cds--cc--tooltip .tooltip-1-3-1 {
  background-color: var(--cds-charts-1-3-1, #1192e8);
}
.cds--cc--tooltip .tooltip-1-4-1 {
  background-color: var(--cds-charts-1-4-1, #007d79);
}
.cds--cc--tooltip .tooltip-2-1-1 {
  background-color: var(--cds-charts-2-1-1, #6929c4);
}
.cds--cc--tooltip .tooltip-2-1-2 {
  background-color: var(--cds-charts-2-1-2, #009d9a);
}
.cds--cc--tooltip .tooltip-2-2-1 {
  background-color: var(--cds-charts-2-2-1, #8a3ffc);
}
.cds--cc--tooltip .tooltip-2-2-2 {
  background-color: var(--cds-charts-2-2-2, #520408);
}
.cds--cc--tooltip .tooltip-2-3-1 {
  background-color: var(--cds-charts-2-3-1, #9f1853);
}
.cds--cc--tooltip .tooltip-2-3-2 {
  background-color: var(--cds-charts-2-3-2, #520408);
}
.cds--cc--tooltip .tooltip-2-4-1 {
  background-color: var(--cds-charts-2-4-1, #1192e8);
}
.cds--cc--tooltip .tooltip-2-4-2 {
  background-color: var(--cds-charts-2-4-2, #005d5d);
}
.cds--cc--tooltip .tooltip-2-5-1 {
  background-color: var(--cds-charts-2-5-1, #009d9a);
}
.cds--cc--tooltip .tooltip-2-5-2 {
  background-color: var(--cds-charts-2-5-2, #002d9c);
}
.cds--cc--tooltip .tooltip-3-1-1 {
  background-color: var(--cds-charts-3-1-1, #ee5396);
}
.cds--cc--tooltip .tooltip-3-1-2 {
  background-color: var(--cds-charts-3-1-2, #1192e8);
}
.cds--cc--tooltip .tooltip-3-1-3 {
  background-color: var(--cds-charts-3-1-3, #6929c4);
}
.cds--cc--tooltip .tooltip-3-2-1 {
  background-color: var(--cds-charts-3-2-1, #9f1853);
}
.cds--cc--tooltip .tooltip-3-2-2 {
  background-color: var(--cds-charts-3-2-2, #fa4d56);
}
.cds--cc--tooltip .tooltip-3-2-3 {
  background-color: var(--cds-charts-3-2-3, #520408);
}
.cds--cc--tooltip .tooltip-3-3-1 {
  background-color: var(--cds-charts-3-3-1, #a56eff);
}
.cds--cc--tooltip .tooltip-3-3-2 {
  background-color: var(--cds-charts-3-3-2, #005d5d);
}
.cds--cc--tooltip .tooltip-3-3-3 {
  background-color: var(--cds-charts-3-3-3, #002d9c);
}
.cds--cc--tooltip .tooltip-3-4-1 {
  background-color: var(--cds-charts-3-4-1, #a56eff);
}
.cds--cc--tooltip .tooltip-3-4-2 {
  background-color: var(--cds-charts-3-4-2, #005d5d);
}
.cds--cc--tooltip .tooltip-3-4-3 {
  background-color: var(--cds-charts-3-4-3, #9f1853);
}
.cds--cc--tooltip .tooltip-3-5-1 {
  background-color: var(--cds-charts-3-5-1, #012749);
}
.cds--cc--tooltip .tooltip-3-5-2 {
  background-color: var(--cds-charts-3-5-2, #6929c4);
}
.cds--cc--tooltip .tooltip-3-5-3 {
  background-color: var(--cds-charts-3-5-3, #009d9a);
}
.cds--cc--tooltip .tooltip-4-1-1 {
  background-color: var(--cds-charts-4-1-1, #6929c4);
}
.cds--cc--tooltip .tooltip-4-1-2 {
  background-color: var(--cds-charts-4-1-2, #012749);
}
.cds--cc--tooltip .tooltip-4-1-3 {
  background-color: var(--cds-charts-4-1-3, #009d9a);
}
.cds--cc--tooltip .tooltip-4-1-4 {
  background-color: var(--cds-charts-4-1-4, #ee5396);
}
.cds--cc--tooltip .tooltip-4-2-1 {
  background-color: var(--cds-charts-4-2-1, #9f1853);
}
.cds--cc--tooltip .tooltip-4-2-2 {
  background-color: var(--cds-charts-4-2-2, #fa4d56);
}
.cds--cc--tooltip .tooltip-4-2-3 {
  background-color: var(--cds-charts-4-2-3, #520408);
}
.cds--cc--tooltip .tooltip-4-2-4 {
  background-color: var(--cds-charts-4-2-4, #a56eff);
}
.cds--cc--tooltip .tooltip-4-3-1 {
  background-color: var(--cds-charts-4-3-1, #009d9a);
}
.cds--cc--tooltip .tooltip-4-3-2 {
  background-color: var(--cds-charts-4-3-2, #002d9c);
}
.cds--cc--tooltip .tooltip-4-3-3 {
  background-color: var(--cds-charts-4-3-3, #a56eff);
}
.cds--cc--tooltip .tooltip-4-3-4 {
  background-color: var(--cds-charts-4-3-4, #9f1853);
}
.cds--cc--tooltip .tooltip-5-1-1 {
  background-color: var(--cds-charts-5-1-1, #6929c4);
}
.cds--cc--tooltip .tooltip-5-1-2 {
  background-color: var(--cds-charts-5-1-2, #1192e8);
}
.cds--cc--tooltip .tooltip-5-1-3 {
  background-color: var(--cds-charts-5-1-3, #005d5d);
}
.cds--cc--tooltip .tooltip-5-1-4 {
  background-color: var(--cds-charts-5-1-4, #9f1853);
}
.cds--cc--tooltip .tooltip-5-1-5 {
  background-color: var(--cds-charts-5-1-5, #520408);
}
.cds--cc--tooltip .tooltip-5-2-1 {
  background-color: var(--cds-charts-5-2-1, #002d9c);
}
.cds--cc--tooltip .tooltip-5-2-2 {
  background-color: var(--cds-charts-5-2-2, #009d9a);
}
.cds--cc--tooltip .tooltip-5-2-3 {
  background-color: var(--cds-charts-5-2-3, #9f1853);
}
.cds--cc--tooltip .tooltip-5-2-4 {
  background-color: var(--cds-charts-5-2-4, #520408);
}
.cds--cc--tooltip .tooltip-5-2-5 {
  background-color: var(--cds-charts-5-2-5, #a56eff);
}
.cds--cc--tooltip .tooltip-14-1-1 {
  background-color: var(--cds-charts-14-1-1, #6929c4);
}
.cds--cc--tooltip .tooltip-14-1-2 {
  background-color: var(--cds-charts-14-1-2, #1192e8);
}
.cds--cc--tooltip .tooltip-14-1-3 {
  background-color: var(--cds-charts-14-1-3, #005d5d);
}
.cds--cc--tooltip .tooltip-14-1-4 {
  background-color: var(--cds-charts-14-1-4, #9f1853);
}
.cds--cc--tooltip .tooltip-14-1-5 {
  background-color: var(--cds-charts-14-1-5, #fa4d56);
}
.cds--cc--tooltip .tooltip-14-1-6 {
  background-color: var(--cds-charts-14-1-6, #520408);
}
.cds--cc--tooltip .tooltip-14-1-7 {
  background-color: var(--cds-charts-14-1-7, #198038);
}
.cds--cc--tooltip .tooltip-14-1-8 {
  background-color: var(--cds-charts-14-1-8, #002d9c);
}
.cds--cc--tooltip .tooltip-14-1-9 {
  background-color: var(--cds-charts-14-1-9, #ee5396);
}
.cds--cc--tooltip .tooltip-14-1-10 {
  background-color: var(--cds-charts-14-1-10, #b28600);
}
.cds--cc--tooltip .tooltip-14-1-11 {
  background-color: var(--cds-charts-14-1-11, #009d9a);
}
.cds--cc--tooltip .tooltip-14-1-12 {
  background-color: var(--cds-charts-14-1-12, #012749);
}
.cds--cc--tooltip .tooltip-14-1-13 {
  background-color: var(--cds-charts-14-1-13, #8a3800);
}
.cds--cc--tooltip .tooltip-14-1-14 {
  background-color: var(--cds-charts-14-1-14, #a56eff);
}

.cds--cc--legend .additional > .icon .area-1 {
  fill: var(--cds-zone-fill-01, #f4f4f4);
  stroke: var(--cds-zone-stroke-01, #8d8d8d);
}
.cds--cc--legend .additional > .icon .area-2 {
  fill: var(--cds-zone-fill-02, #e0e0e0);
  stroke: var(--cds-zone-stroke-02, #8d8d8d);
}
.cds--cc--legend .additional > .icon .area-3 {
  fill: var(--cds-zone-fill-03, #c6c6c6);
  stroke: var(--cds-zone-stroke-03, #8d8d8d);
}
.cds--cc--legend .additional > .icon .quartile-wrapper {
  fill: var(--cds-zone-fill-02, #e0e0e0);
  stroke: var(--cds-zone-stroke-01, #8d8d8d);
}
.cds--cc--legend .additional > .icon .quartile-line {
  fill: var(--cds-layer-inverse-absolute, #000000);
}

.cds--cc--axes {
  font-family: var(--cds-charts-font-family-condensed);
  overflow: visible;
}
.cds--cc--axes g.axis g.ticks.invisible {
  visibility: hidden;
}
.cds--cc--axes g.axis g.tick-hover rect.axis-holder {
  fill: transparent;
  stroke: transparent;
  stroke-width: 2px;
}
.cds--cc--axes g.axis g.tick-hover:hover rect.axis-holder,
.cds--cc--axes g.axis g.tick-hover:focus rect.axis-holder {
  fill: var(--cds-layer-selected-inverse, #161616);
  stroke: var(--cds-layer-selected-inverse, #161616);
  stroke-width: 2px;
}
.cds--cc--axes g.axis g.tick-hover:hover text,
.cds--cc--axes g.axis g.tick-hover:focus text {
  fill: var(--cds-layer-selected);
}
.cds--cc--axes g.axis g.tick text {
  fill: var(--cds-text-secondary, #525252);
  font-family: var(--cds-charts-font-family-condensed);
}
.cds--cc--axes g.axis g.tick text.tick-label--primary {
  font-weight: bold;
}
.cds--cc--axes g.axis g.tick text.tick-label {
  font-weight: normal;
}
.cds--cc--axes g.axis g.tick line {
  display: none;
}
.cds--cc--axes g.axis path.domain {
  stroke: var(--cds-border-strong-01, #8d8d8d);
}
.cds--cc--axes g.axis .axis-title {
  font-family: var(--cds-charts-font-family);
  font-weight: 600;
  fill: var(--cds-text-primary, #161616);
}

.cds--cc--chart-wrapper g.callouts {
  stroke: var(--cds-text-secondary, #525252);
}

svg.cds--cc--color-legend {
  display: flex;
  user-select: none;
}
svg.cds--cc--color-legend g.legend-title text {
  fill: var(--cds-layer-inverse-absolute, #000000);
}

.cds--cc--card-node {
  display: flex;
  position: relative;
  background-color: var(--cds-layer-01, #f4f4f4);
  z-index: 1;
  box-sizing: border-box;
  font-family: var(--cds-charts-font-family);
  width: 100%;
  height: 100%;
  padding: 1rem 0.5rem;
  border-left: 0.25rem solid var(--cds-border-inverse, #161616);
}

.cds--cc--card-node--a,
.cds--cc--card-node--button {
  border-top: none;
  border-right: none;
  border-bottom: none;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.cds--cc--card-node--button {
  font-family: var(--cds-charts-font-family);
  text-align: left;
  width: 100%;
}

.cds--cc--card-node--a:focus,
.cds--cc--card-node--a:hover,
.cds--cc--card-node--button:focus,
.cds--cc--card-node--button:hover {
  background-color: var(--cds-network-diagrams-background-hover, #f1f1f1);
}

.cds--cc--card-node--a:focus,
.cds--cc--card-node--button:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--cc--card-node--a:focus,
  .cds--cc--card-node--button:focus {
    outline-style: dotted;
  }
}

.cds--cc--card-node--stacked::before {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 0;
  border-top: 0.125rem solid var(--cds-layer-accent-01, #e0e0e0);
  border-right: 0.125rem solid var(--cds-layer-accent-01, #e0e0e0);
  pointer-events: none;
  left: 0.3125rem;
  bottom: 0.3125rem;
}
.cds--cc--card-node--stacked::after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 0;
  border-top: 0.125rem solid var(--cds-layer-accent-01, #e0e0e0);
  border-right: 0.125rem solid var(--cds-layer-accent-01, #e0e0e0);
  pointer-events: none;
  left: 0.6875rem;
  bottom: 0.6875rem;
}

.cds--cc--card-node__column {
  padding: 0 0.5rem;
}

.cds--cc--card-node__column--farside {
  margin-left: auto;
}

.cds--cc--card-node__title {
  font-size: var(--cds-productive-heading-01-font-size, 0.875rem);
  font-weight: var(--cds-productive-heading-01-font-weight, 600);
  line-height: var(--cds-productive-heading-01-line-height, 1.28572);
  letter-spacing: var(--cds-productive-heading-01-letter-spacing, 0.16px);
  margin: 0;
}

.cds--cc--card-node__subtitle {
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  margin: 0;
}

.cds--cc--card-node__label {
  display: block;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  color: var(--cds-text-secondary, #525252);
  padding-top: 1.5rem;
}

.cds--cc--shape-node {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--cds-layer-01, #f4f4f4);
  box-sizing: border-box;
  font-family: var(--cds-charts-font-family);
  width: 100%;
  height: 100%;
  position: relative;
}

.cds--cc--shape-node--circle {
  border-radius: 100%;
}

.cds--cc--shape-node--square {
  border-radius: 0;
}

.cds--cc--shape-node--rounded-square {
  border-radius: 0.5rem;
}

.cds--cc--shape-node--a,
.cds--cc--shape-node--button {
  border: none;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.cds--cc--shape-node--button {
  font-family: var(--cds-charts-font-family);
  text-align: left;
  width: 100%;
}

.cds--cc--shape-node--a:focus,
.cds--cc--shape-node--a:hover,
.cds--cc--shape-node--button:focus,
.cds--cc--shape-node--button:hover {
  background-color: var(--cds-network-diagrams-background-hover, #f1f1f1);
}
.cds--cc--shape-node--a:focus .cds--cc--shape-node__title,
.cds--cc--shape-node--a:focus .cds--cc--shape-node__subtitle,
.cds--cc--shape-node--a:hover .cds--cc--shape-node__title,
.cds--cc--shape-node--a:hover .cds--cc--shape-node__subtitle,
.cds--cc--shape-node--button:focus .cds--cc--shape-node__title,
.cds--cc--shape-node--button:focus .cds--cc--shape-node__subtitle,
.cds--cc--shape-node--button:hover .cds--cc--shape-node__title,
.cds--cc--shape-node--button:hover .cds--cc--shape-node__subtitle {
  font-weight: 600;
}

.cds--cc--shape-node--a:focus:focus,
.cds--cc--shape-node--button:focus:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--cds-focus, #0f62fe);
}

.cds--cc--shape-node__body {
  position: absolute;
  top: calc(100% + 0.125rem);
  text-align: center;
}

.cds--cc--shape-node__subtitle {
  padding-bottom: 0.125rem;
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  color: var(--cds-text-primary, #161616);
}

.cds--cc--shape-node__icon {
  display: flex;
}

.cds--cc--shape-node__title {
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  color: var(--cds-text-primary, #161616);
  padding-top: 0.125rem;
  margin-bottom: 1px;
}

.cds--cc--edge {
  fill: transparent;
}

.cds--cc--edge__container {
  stroke-width: 1.5rem;
  stroke: transparent;
  stroke-dasharray: none;
}

.cds--cc--edge__inner {
  stroke-width: 0.0625rem;
  stroke: var(--cds-border-strong-01, #8d8d8d);
}

.cds--cc--edge__outer {
  stroke-width: 0.15625rem;
  stroke: transparent;
}

.cds--cc--edge:hover .cds--cc--edge__inner {
  stroke-width: 0.15625rem;
}

.cds--cc--edge--dash-sm {
  stroke-dasharray: 2 4;
}

.cds--cc--edge--dash-md {
  stroke-dasharray: 4 4;
}

.cds--cc--edge--dash-lg {
  stroke-dasharray: 8 4;
}

.cds--cc--edge--dash-xl {
  stroke-dasharray: 16 4;
}

.cds--cc--edge--tunnel .cds--cc--edge__outer {
  stroke: var(--cds-layer-accent-01, #e0e0e0);
  stroke-width: 0.375rem;
}

.cds--cc--edge--double .cds--cc--edge__inner {
  stroke: var(--cds-background, #ffffff);
}
.cds--cc--edge--double .cds--cc--edge__outer {
  stroke: var(--cds-border-inverse, #161616);
  stroke-width: 0.28125rem;
}

.cds--cc--marker {
  fill: var(--cds-border-inverse, #161616);
}

.cds--cc--grid rect.chart-grid-backdrop {
  fill: var(--cds-grid-bg, #ffffff);
}
.cds--cc--grid rect.chart-grid-backdrop.stroked {
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--grid rect.stroke {
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--grid g.x.grid g.tick line,
.cds--cc--grid g.y.grid g.tick line {
  pointer-events: none;
  stroke-width: 1px;
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--grid g.x.grid g.tick.active line,
.cds--cc--grid g.y.grid g.tick.active line {
  stroke-dasharray: 2px;
  stroke: var(--cds-focus, #0f62fe);
}

.cds--cc--grid-brush g.grid-brush rect.selection {
  fill: none;
  fill-opacity: 0;
  stroke: none;
}

.cds--cc--grid-brush rect.frontSelection {
  fill: var(--cds-layer-accent-01, #e0e0e0);
  fill-opacity: 0.3;
  stroke: var(--cds-button-tertiary, #0f62fe);
}

.cds--cc--highlight rect.highlight-bar {
  pointer-events: none;
  fill: #ee5396;
  stroke: #ee5396;
}

.cds--cc--layout-row {
  display: flex;
  flex-direction: row;
}
.cds--cc--layout-column {
  display: flex;
  flex-direction: column;
}
.cds--cc--layout-row-reverse {
  display: flex;
  flex-direction: row-reverse;
}
.cds--cc--layout-column-reverse {
  display: flex;
  flex-direction: column-reverse;
}
.cds--cc--layout-alignitems-center {
  align-items: center;
}

.cds--cc--chart-wrapper .layout-child {
  overflow: visible;
}

.cds--cc--chart-wrapper svg.layout-svg-wrapper {
  height: inherit;
  width: inherit;
  overflow: visible;
}

div.cds--cc--legend {
  font-family: var(--cds-charts-font-family-condensed);
  display: flex;
  user-select: none;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
div.cds--cc--legend[data-name=legend-items] {
  margin: -5px;
}
div.cds--cc--legend[data-name=legend-items].horizontal {
  width: 100%;
}
div.cds--cc--legend div.legend-item {
  display: flex;
  align-items: center;
  margin: 5px;
}
div.cds--cc--legend div.legend-item div.checkbox {
  width: 13px;
  height: 13px;
  margin-right: 4px;
  border-radius: 2px;
  border: solid 1px var(--cds-background, #ffffff);
  box-shadow: 0 0 0 2px transparent;
}
@media (forced-colors: active) {
  div.cds--cc--legend div.legend-item div.checkbox {
    forced-color-adjust: none;
  }
}
div.cds--cc--legend div.legend-item div.checkbox:not(.active) {
  border-color: var(--cds-text-secondary, #525252);
  background: var(--cds-background, #ffffff);
}
div.cds--cc--legend div.legend-item div.checkbox svg {
  display: none;
  vertical-align: text-top;
  fill: var(--cds-background, #ffffff);
  stroke: var(--cds-background, #ffffff);
}
div.cds--cc--legend div.legend-item.additional svg.icon {
  margin-right: 4px;
}
div.cds--cc--legend div.legend-item p {
  font-size: 12px;
  fill: var(--cds-text-secondary, #525252);
  line-height: 1rem;
}
div.cds--cc--legend.center-aligned {
  justify-content: center;
}
div.cds--cc--legend.right-aligned {
  justify-content: flex-end;
}
div.cds--cc--legend.has-deactivated-items div.legend-item div.checkbox svg {
  display: block;
}
div.cds--cc--legend.vertical {
  margin: -5px;
  flex-direction: column;
}
div.cds--cc--legend.vertical div.legend-item {
  margin-right: 0;
  margin-bottom: 10px;
  white-space: nowrap;
}
div.cds--cc--legend.clickable div.legend-item:not(.additional):hover {
  cursor: pointer;
}
div.cds--cc--legend.clickable div.legend-item:not(.additional):hover div.checkbox {
  border: solid 1px var(--cds-background, #ffffff);
  box-shadow: 0 0 0 2px #0f62fe;
}
div.cds--cc--legend.clickable div.legend-item:not(.additional):hover div.checkbox:not(.active) {
  border-color: var(--cds-text-secondary, #525252);
}

.cds--cc--meter-title {
  overflow: visible;
}
.cds--cc--meter-title text.meter-title,
.cds--cc--meter-title text.proportional-meter-title,
.cds--cc--meter-title text.proportional-meter-total,
.cds--cc--meter-title text.percent-value {
  fill: var(--cds-text-primary, #161616);
}
.cds--cc--meter-title g.status-indicator.status--danger circle.status {
  fill: var(--cds-support-error, #da1e28);
}
.cds--cc--meter-title g.status-indicator.status--warning circle.status {
  fill: var(--cds-support-warning, #f1c21b);
}
.cds--cc--meter-title g.status-indicator.status--warning path.innerFill {
  fill: #000000;
}
.cds--cc--meter-title g.status-indicator.status--success circle.status {
  fill: var(--cds-support-success, #24a148);
}
.cds--cc--meter-title g.status-indicator path.innerFill {
  fill: var(--cds-layer-01-absolute, #ffffff);
}

.cds--cc--ruler line.ruler-line,
.cds--cc--ruler-binned line.ruler-line {
  stroke: var(--cds-layer-inverse-absolute, #000000);
  stroke-width: 1px;
  stroke-dasharray: 2;
  pointer-events: none;
}

.cds--cc--skeleton rect.chart-skeleton-backdrop {
  fill: var(--cds-grid-bg, #ffffff);
}
.cds--cc--skeleton .shimmer-effect-lines {
  stroke-width: 1px;
}
.cds--cc--skeleton .shimmer-effect-sparkline {
  stroke-width: 0px;
}
.cds--cc--skeleton .empty-state-lines {
  stroke-width: 1px;
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--skeleton .shimmer-lines .stop-bg-shimmer {
  stop-color: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--skeleton .shimmer-lines .stop-shimmer {
  stop-color: #ffffff;
}
.cds--cc--skeleton .empty-state-areas {
  fill: rgba(127, 127, 127, 0.1);
}
.cds--cc--skeleton .shimmer-areas .stop-bg-shimmer {
  stop-color: rgba(127, 127, 127, 0.1);
}
.cds--cc--skeleton .shimmer-areas .stop-shimmer {
  stop-color: rgba(255, 255, 255, 0.15);
}

.cds--cc--skeleton-lines rect.chart-skeleton-backdrop {
  fill: var(--cds-grid-bg, #ffffff);
}
.cds--cc--skeleton-lines .shimmer-effect-lines {
  stroke-width: 1px;
}
.cds--cc--skeleton-lines .shimmer-effect-sparkline {
  stroke-width: 0px;
}
.cds--cc--skeleton-lines .empty-state-lines {
  stroke-width: 1px;
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--skeleton-lines .shimmer-lines .stop-bg-shimmer {
  stop-color: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--skeleton-lines .shimmer-lines .stop-shimmer {
  stop-color: #ffffff;
}

.cds--cc--threshold line.threshold-line {
  stroke: #fa4d56;
  stroke-width: 1;
  stroke-dasharray: 4;
  cursor: pointer;
  pointer-events: none;
}
.cds--cc--threshold line.threshold-line.active {
  stroke-width: 2;
}
.cds--cc--threshold rect.threshold-hoverable-area {
  height: 20px;
  transform: translate(0, -10px);
  cursor: pointer;
  fill: transparent;
}
.cds--cc--threshold rect.threshold-hoverable-area.rotate {
  transform: rotate(90deg) translate(0, -10px);
}

.cds--cc--threshold--label {
  background-color: #fa4d56;
  pointer-events: none;
  transition: opacity 0.1s;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
  display: inline;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  word-wrap: break-word;
  z-index: 1059;
  font-family: var(--cds-charts-font-family-condensed);
  color: var(--cds-text-primary, #161616);
  line-height: 16px;
  font-size: 12px;
  padding: 4px;
  min-width: 20px;
}
.cds--cc--threshold--label.hidden {
  opacity: 0;
  transition: opacity 0.1s;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
}

.cds--cc--title p.title {
  color: var(--cds-text-primary, #161616);
  font-size: 16px;
  font-family: var(--cds-charts-font-family);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 15px;
}

.cds--chart-holder .layout-child.title {
  height: unset !important;
  overflow: hidden;
}

.cds--chart-holder .cds--cc--toolbar {
  display: flex;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  position: absolute;
  z-index: 6000;
  display: none;
  background-color: var(--cds-layer);
  width: 10rem;
  flex-direction: column;
  align-items: flex-start;
  top: 32px;
  inset-inline-start: 0;
  list-style: none;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options *,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options ::before,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options ::after {
  box-sizing: inherit;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option {
  box-sizing: border-box;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
  display: flex;
  align-items: center;
  padding: 0;
  background-color: transparent;
  block-size: 2.5rem;
  inline-size: 100%;
  transition: background-color 0.11s cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option:hover {
  background-color: var(--cds-layer-hover);
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option .cds--overflow-menu-options__btn {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: inline-flex;
  align-items: center;
  padding: 0 1rem;
  border: none;
  background-color: transparent;
  block-size: 100%;
  color: var(--cds-text-secondary, #525252);
  cursor: pointer;
  font-family: inherit;
  font-weight: 400;
  inline-size: 100%;
  max-inline-size: 11.25rem;
  text-align: start;
  transition: outline 0.11s cubic-bezier(0, 0, 0.38, 0.9), background-color 0.11s cubic-bezier(0, 0, 0.38, 0.9), color 0.11s cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option .cds--overflow-menu-options__btn:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option *,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option ::before,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu-options .cds--overflow-menu-options__option ::after {
  box-sizing: inherit;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu--flip {
  right: 0;
  left: unset;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu--flip.is-open {
  display: table;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu--flip ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger {
  width: 2rem;
  height: 2rem;
  appearance: none;
  background: none;
  block-size: 2.5rem;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 100%;
  inline-size: 2.5rem;
  align-items: center;
  justify-content: center;
  margin: 0;
  min-height: 2.5rem;
  outline: 2px solid transparent;
  outline-offset: -2px;
  padding: 0;
  position: relative;
  text-align: start;
  transition: outline 110ms cubic-bezier(0, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
  vertical-align: baseline;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu:hover,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger:hover {
  background-color: var(--cds-layer-hover);
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu:focus,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu *,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu ::before,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu ::after,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger *,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger ::before,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger ::after {
  box-sizing: inherit;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu > :first-child,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger > :first-child {
  margin-block-start: 0;
}
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu .cds--overflow-menu__icon,
.cds--chart-holder .cds--cc--toolbar .cds--overflow-menu__trigger .cds--overflow-menu__icon {
  block-size: 1rem;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1rem;
}

.cds--chart-holder {
  --cds-layout-size-height-min: 0px;
  --cds-layout-size-height-lg: 3rem;
  --cds-layout-size-height-max: 999999999px;
  --cds-layout-density-padding-inline-min: 0px;
  --cds-layout-density-padding-inline-normal: 1rem;
  --cds-layout-density-padding-inline-max: 999999999px;
  --cds-layout-size-height-lg: 3rem;
}
.cds--chart-holder .cds--modal {
  position: fixed;
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cds-overlay, rgba(22, 22, 22, 0.5));
  block-size: 100vh;
  content: "";
  inline-size: 100vw;
  inset-block-start: 0;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 0.24s cubic-bezier(0.4, 0.14, 1, 1), visibility 0ms linear 0.24s;
  visibility: hidden;
}
.cds--chart-holder .cds--modal.is-visible {
  z-index: 99999;
  opacity: 1;
  transition: opacity 0.24s cubic-bezier(0, 0, 0.3, 1), visibility 0ms linear;
  visibility: inherit;
}
.cds--chart-holder .cds--modal.is-visible .cds--modal-container {
  transform: translateZ(0);
  transition: transform 0.24s cubic-bezier(0, 0, 0.3, 1);
}
.cds--chart-holder .cds--modal .cds--modal-container {
  position: fixed;
  top: 0;
  display: grid;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-height: 100%;
  background-color: var(--cds-layer);
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr auto;
  outline: 3px solid transparent;
  outline-offset: -3px;
  transform: translate3d(0, -24px, 0);
  transform-origin: top center;
  transition: transform 0.24s cubic-bezier(0.4, 0.14, 1, 1);
}
@media (max-width: 671px) {
  .cds--chart-holder .cds--modal .cds--modal-container {
    transform: none;
  }
}
@media (min-width: 42rem) {
  .cds--chart-holder .cds--modal .cds--modal-container {
    position: static;
    width: 84%;
    height: auto;
    max-height: 90%;
  }
}
@media (min-width: 66rem) {
  .cds--chart-holder .cds--modal .cds--modal-container {
    width: 60%;
    max-height: 84%;
  }
}
@media (min-width: 82rem) {
  .cds--chart-holder .cds--modal .cds--modal-container {
    width: 48%;
  }
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header {
  padding-top: 1rem;
  padding-right: 3rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
  grid-column: 1/-1;
  grid-row: 1/1;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header__label {
  margin-top: 0;
  margin-bottom: 0;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  vertical-align: baseline;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  color: var(--cds-text-secondary, #525252);
  --docs-content-width: 75%;
  width: var(--docs-content-width);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header__heading {
  margin-top: 0.5rem !important;
  margin-bottom: 1rem !important;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  vertical-align: baseline;
  font-size: var(--cds-heading-03-font-size, 1.25rem);
  font-weight: var(--cds-heading-03-font-weight, 400);
  line-height: var(--cds-heading-03-line-height, 1.4);
  letter-spacing: var(--cds-heading-03-letter-spacing, 0);
  padding-right: calc(20% - 3rem);
  color: var(--cds-text-primary, #161616);
  --docs-content-width: 75%;
  width: var(--docs-content-width);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header .cds--modal-close {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  overflow: hidden;
  width: 3rem;
  height: 3rem;
  padding: 0.75rem;
  border: 2px solid transparent;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.11s cubic-bezier(0.2, 0, 0.38, 0.9);
  margin: 0;
  border-radius: 0;
  font-family: inherit;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header .cds--modal-close:hover {
  background-color: var(--cds-layer-hover);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header .cds--modal-close:focus {
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-header .cds--modal-close__icon {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--cds-icon-primary, #161616);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content {
  padding: 0 !important;
  margin-bottom: 0;
  color-scheme: var(--cds-color-scheme, light);
  font-size: var(--cds-body-01-font-size, 0.875rem);
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  position: relative;
  color: var(--cds-text-primary, #161616);
  font-weight: 400;
  grid-column: 1/-1;
  grid-row: 2/-2;
  overflow-y: auto;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table {
  position: relative;
  border-collapse: collapse;
  width: 100%;
  border-spacing: 0;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table thead {
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  background-color: var(--cds-layer-accent);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table thead tr {
  width: 100%;
  height: 3rem;
  border: none;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table thead tr th {
  position: sticky;
  top: 0;
  padding-right: 1rem;
  padding-left: 1rem;
  background-color: var(--cds-layer-accent);
  color: var(--cds-text-primary, #161616);
  text-align: start;
  vertical-align: middle;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table thead tr th .cds--table-header-label {
  text-align: left;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table tbody {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  background-color: var(--cds-layer);
  width: 100%;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table tbody tr {
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
  width: 100;
  height: 3rem;
  border: none;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table tbody tr:hover {
  background: var(--cds-layer-hover) !important;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-content .cds--data-table tbody tr td {
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
  padding-right: 1rem;
  padding-left: 1rem;
  border-top: 1px solid var(--cds-layer);
  border-bottom: 1px solid var(--cds-border-subtle);
  color: var(--cds-text-secondary, #525252);
  text-align: left;
  vertical-align: middle;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer {
  background-color: transparent;
  display: flex;
  height: 4rem;
  justify-content: flex-end;
  margin-top: auto;
  grid-column: 1/-1;
  grid-row: -1/-1;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer .cds--cc-modal-footer-spacer {
  width: 50%;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer .cds--btn {
  max-width: none;
  height: 4rem;
  flex: 0 1 50%;
  align-items: baseline;
  padding-top: 0.875rem;
  padding-bottom: 2rem;
  margin: 0;
  --cds-layout-size-height-local: clamp(
  	var(--cds-layout-size-height-min),
  	var(
  		--cds-layout-size-height,
  		var(--cds-layout-size-height-lg)
  	),
  	var(--cds-layout-size-height-max)
  );
  --cds-layout-density-padding-inline-local: clamp(
  	var(--cds-layout-density-padding-inline-min),
  	var(
  		--cds-layout-density-padding-inline,
  		var(--cds-layout-density-padding-inline-normal)
  	),
  	var(--cds-layout-density-padding-inline-max)
  );
  --temp-1lh: (var(--cds-body-compact-01-line-height, 1.28572) * 1em);
  --temp-expressive-1lh: (
  	var(--cds-body-compact-02-line-height, 1.375) * 1em
  );
  --temp-padding-block-max: calc(
  	(var(--cds-layout-size-height-lg) - var(--temp-1lh)) / 2 - 0.0625rem
  );
  box-sizing: border-box;
  padding: 0;
  border: 0;
  font-family: inherit;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: inline-flex;
  width: max-content;
  max-width: 20rem;
  min-height: var(--cds-layout-size-height-local);
  justify-content: space-between;
  border-radius: 0;
  cursor: pointer;
  outline: none;
  padding-block: min((var(--cds-layout-size-height-local) - var(--temp-1lh)) / 2 - 0.0625rem, var(--temp-padding-block-max));
  padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) * 3 + 1rem - 0.0625rem);
  padding-inline-start: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
  text-align: left;
  text-decoration: none;
  transition: background 70ms cubic-bezier(0, 0, 0.38, 0.9), box-shadow 70ms cubic-bezier(0, 0, 0.38, 0.9), border-color 70ms cubic-bezier(0, 0, 0.38, 0.9), outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
  vertical-align: top;
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer .cds--btn--primary {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: var(--cds-button-primary, #0f62fe);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer .cds--btn--primary:hover {
  color: var(--cds-text-on-color, #ffffff);
  background-color: var(--cds-button-primary-hover, #0050e6);
}
.cds--chart-holder .cds--modal .cds--modal-container .cds--modal-footer .cds--btn--primary:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}

@supports (-moz-appearance: none) {
  .cds--data-table td {
    background-clip: padding-box;
  }
}
.cds--cc--tooltip {
  background-color: var(--cds-layer-02, #ffffff);
  pointer-events: none;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
  display: inline;
  visibility: visible;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  word-wrap: break-word;
  z-index: 1059;
  font-family: var(--cds-charts-font-family-condensed);
  transition: visibility 0s linear 0.1s, opacity 0.1s;
}
.cds--cc--tooltip.hidden {
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s linear 0s, opacity 0.1s;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
}
.cds--cc--tooltip .content-box {
  color: var(--cds-text-primary, #161616);
}
.cds--cc--tooltip .content-box .title-tooltip.title-tooltip-nowrap {
  width: max-content;
}
.cds--cc--tooltip .content-box .title-tooltip {
  width: auto;
  padding: 4px;
  min-width: 20px;
  max-width: 270px;
}
.cds--cc--tooltip .content-box .title-tooltip p {
  margin: 2px;
  font-size: 12px;
  line-height: 1rem;
}
.cds--cc--tooltip .content-box .datapoint-tooltip {
  display: flex;
  padding: 4px;
  flex-flow: row nowrap;
  width: auto;
  min-width: 20px;
  justify-content: flex-start;
  align-items: center;
}
.cds--cc--tooltip .content-box .datapoint-tooltip div.label {
  display: flex;
  flex: 1;
}
.cds--cc--tooltip .content-box .datapoint-tooltip div.label p {
  flex: 1;
  padding-right: 8px;
}
.cds--cc--tooltip .content-box .datapoint-tooltip div.label span.label-icon svg {
  height: 12px;
  padding-top: 3px;
  vertical-align: top;
  padding-left: 4px;
  width: auto;
  fill: var(--cds-layer-inverse-absolute, #000000);
}
.cds--cc--tooltip .content-box .datapoint-tooltip.bold div.label p {
  font-weight: 600;
}
.cds--cc--tooltip .content-box .datapoint-tooltip p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 16px;
  font-size: 12px;
  display: inline-block;
  margin: 0;
  padding: 0;
  border: 0;
}
.cds--cc--tooltip .content-box .datapoint-tooltip p.value {
  width: auto;
  margin-left: 6px;
}
.cds--cc--tooltip .content-box ul.multi-tooltip {
  margin: 0;
  padding: 0;
}
.cds--cc--tooltip .content-box ul.multi-tooltip li {
  list-style: none;
  position: relative;
}
.cds--cc--tooltip .content-box ul.multi-tooltip li:not(:last-child) {
  border-bottom: 1px solid var(--cds-tooltip-line-border, #e0e0e0);
}
.cds--cc--tooltip .content-box svg.arrow-right rect {
  fill: none;
}
.cds--cc--tooltip .tooltip-color {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
}
@media (forced-colors: active) {
  .cds--cc--tooltip .tooltip-color {
    forced-color-adjust: none;
  }
}
.cds--cc--tooltip .tooltip-color + div.label p {
  margin-left: 4px;
}

.cds--cc--zero-line line.domain {
  stroke: var(--cds-border-strong-01, #8d8d8d);
}

.cds--cc--zoom-bar rect.zoom-bg {
  fill: var(--cds-background, #ffffff);
  stroke: var(--cds-layer-01, #f4f4f4);
}
.cds--cc--zoom-bar rect.zoom-slider-bg {
  fill: var(--cds-layer-01, #f4f4f4);
}
.cds--cc--zoom-bar rect.zoom-slider-selected-area {
  fill: var(--cds-icon-secondary, #525252);
}
.cds--cc--zoom-bar path.zoom-bg-baseline {
  stroke: var(--cds-border-strong-01, #8d8d8d);
  stroke-width: 2;
}
.cds--cc--zoom-bar path.zoom-graph-area {
  fill: var(--cds-layer-accent-01, #e0e0e0);
  stroke: var(--cds-border-strong-01, #8d8d8d);
  stroke-width: 1;
}
.cds--cc--zoom-bar path.zoom-graph-area-unselected {
  fill: var(--cds-layer-01, #f4f4f4);
  stroke: none;
}
.cds--cc--zoom-bar g.zoom-bar-brush rect.handle {
  fill: var(--cds-icon-secondary, #525252);
}
.cds--cc--zoom-bar g.zoom-bar-brush rect.handle-bar {
  fill: var(--cds-layer-02, #ffffff);
}
.cds--cc--zoom-bar g.zoom-bar-brush rect.selection {
  fill: none;
  stroke: none;
}
.cds--cc--zoom-bar rect[class^=highlight-] {
  fill: #ee5396;
  stroke: #ee5396;
}

.cds--cc--alluvial rect.node,
.cds--cc--alluvial rect.node-text-bg {
  fill: var(--cds-layer-inverse-absolute, #000000);
}
.cds--cc--alluvial text.node-text {
  fill: var(--cds-layer-01-absolute, #ffffff);
}
.cds--cc--alluvial polygon.arrow-down {
  fill: var(--cds-layer-01, #f4f4f4);
}

.cds--cc--area path.area,
.cds--cc--area-stacked path.area {
  pointer-events: none;
}

.cds--cc--bubble circle.dot.hovered {
  fill-opacity: 1;
  transition: all 0.1s;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
}
.cds--cc--bubble circle.dot.unfilled {
  fill: var(--cds-layer-01, #f4f4f4);
}
.cds--cc--bubble g.lines path.line {
  mix-blend-mode: multiply;
}

.cds--cc--bullet path.range-box {
  pointer-events: none;
}
.cds--cc--bullet path.range-box.order-1 {
  fill: var(--cds-zone-fill-01, #f4f4f4);
  stroke: var(--cds-zone-stroke-01, #8d8d8d);
}
.cds--cc--bullet path.range-box.order-2 {
  fill: var(--cds-zone-fill-02, #e0e0e0);
  stroke: var(--cds-zone-stroke-02, #8d8d8d);
}
.cds--cc--bullet path.range-box.order-3 {
  fill: var(--cds-zone-fill-03, #c6c6c6);
  stroke: var(--cds-zone-stroke-03, #8d8d8d);
}
.cds--cc--bullet path.marker,
.cds--cc--bullet path.quartile {
  pointer-events: none;
  stroke-width: 1.5px;
  stroke: var(--cds-layer-inverse-absolute, #000000);
}
.cds--cc--bullet path.quartile.over-bar {
  stroke: var(--cds-layer-01-absolute, #ffffff);
}

.cds--cc--choropleth path.border {
  stroke: var(--cds-border-subtle-selected-01, #c6c6c6);
}
.cds--cc--choropleth g.missing-data path {
  stroke: var(--cds-border-subtle-selected-01, #c6c6c6);
  fill: var(--cds-background, #ffffff);
}
.cds--cc--choropleth pattern path.pattern-fill {
  stroke: var(--cds-border-strong-01, #8d8d8d);
  stroke-width: 0.5px;
}

.cds--cc--circle-pack circle.node {
  stroke-width: 1.5px;
}
.cds--cc--circle-pack circle.node.hovered {
  fill-opacity: 1;
}
.cds--cc--circle-pack circle.node.non-focal {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
  fill-opacity: 30%;
  stroke: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--cc--circle-pack circle.node.clickable {
  cursor: zoom-in;
}

.cds--cc--chart-wrapper.zoomed-in {
  cursor: zoom-out;
}
.cds--cc--chart-wrapper.zoomed-in .cds--cc--circle-pack circle.node.hovered-child {
  stroke: 1.5px solid initial;
}
.cds--cc--chart-wrapper.zoomed-in .cds--cc--circle-pack circle.node.clickable {
  cursor: zoom-out;
}

.cds--cc--donut {
  overflow: visible;
}

.cds--cc--gauge {
  overflow: visible;
}
.cds--cc--gauge path.arc-background {
  fill: var(--cds-layer-01, #f4f4f4);
}
.cds--cc--gauge .gauge-delta-arrow.status--danger {
  fill: var(--cds-support-error, #da1e28);
}
.cds--cc--gauge .gauge-delta-arrow.status--warning {
  fill: var(--cds-support-warning, #f1c21b);
}
.cds--cc--gauge .gauge-delta-arrow.status--success {
  fill: var(--cds-support-success, #24a148);
}

.cds--cc--heatmap g.highlighter-hidden {
  visibility: hidden;
}
.cds--cc--heatmap g.cell-highlight line {
  stroke: white;
  stroke-width: 1px;
}
.cds--cc--heatmap g.cell-2 line {
  stroke: white;
  stroke-width: 2px !important;
}
.cds--cc--heatmap g.multi-cell line {
  stroke: white;
  stroke-width: 2px;
}
.cds--cc--heatmap rect.pattern-fill {
  fill: var(--cds-border-strong-01, #8d8d8d);
}
.cds--cc--heatmap g.shadows line.top {
  filter: drop-shadow(0px -3px 2px black);
}
.cds--cc--heatmap g.shadows line.down {
  filter: drop-shadow(0px 3px 2px black);
}
.cds--cc--heatmap g.shadows line.left {
  filter: drop-shadow(-3px 0px 2px black);
}
.cds--cc--heatmap g.shadows line.right {
  filter: drop-shadow(3px 0px 2px black);
}
.cds--cc--heatmap rect.heat {
  stroke-width: 0px;
  stroke: var(--cds-background, #ffffff);
}
.cds--cc--heatmap rect.null-state {
  fill: var(--cds-icon-inverse, #ffffff);
}

.cds--cc--line path.line {
  pointer-events: none;
  fill: none;
  stroke-width: 1.5;
}
.cds--cc--line path.line.sparkline-loading {
  animation: shimmer 2.5s infinite linear;
}
@keyframes shimmer {
  0% {
    stroke: var(--cds-layer-accent-01, #e0e0e0);
  }
  20% {
    stroke: #ffffff;
    opacity: 0.5;
  }
  100% {
    stroke: var(--cds-layer-accent-01, #e0e0e0);
  }
}

.cds--cc--lollipop line.line {
  pointer-events: none;
}
.cds--cc--lollipop circle.dot {
  stroke-width: 1.5;
}

.cds--cc--meter rect.container {
  fill: var(--cds-layer-01, #f4f4f4);
}
.cds--cc--meter line.rangeIndicator {
  stroke: var(--cds-meter-range-indicator, #a8a8a8);
  stroke-width: 1px;
}
.cds--cc--meter rect.value.status--danger {
  fill: var(--cds-support-error, #da1e28);
}
.cds--cc--meter rect.value.status--warning {
  fill: var(--cds-support-warning, #f1c21b);
  stroke-width: 1px;
  stroke: var(--cds-alert-stroke, #b28600);
}
.cds--cc--meter rect.value.status--success {
  fill: var(--cds-support-success, #24a148);
}
.cds--cc--meter line.peak {
  stroke: var(--cds-border-inverse, #161616);
  stroke-width: 2px;
}

.cds--cc--pie {
  overflow: visible;
}

.cds--cc--radar .blobs path {
  stroke-width: 1.5px;
}
.cds--cc--radar .y-axes path,
.cds--cc--radar .x-axes line {
  stroke-width: 1px;
  stroke: var(--cds-layer-accent-01, #e0e0e0);
}
.cds--cc--radar .x-axes line.hovered {
  stroke: var(--cds-layer-inverse-absolute, #000000);
}

.cds--cc--scatter circle.dot.hovered {
  fill-opacity: 1;
  transition: all 0.1s;
  transition-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
}
.cds--cc--scatter circle.dot.unfilled {
  fill: var(--cds-layer-01, #f4f4f4);
  stroke-width: 1.5;
}
.cds--cc--scatter circle.dot.threshold-anomaly {
  stroke-width: 3;
}
.cds--cc--scatter g.lines path.line {
  mix-blend-mode: multiply;
}

.cds--cc--scatter-stacked circle.dot.unfilled {
  fill: var(--cds-layer-01, #f4f4f4);
  stroke-width: 1.5;
}
.cds--cc--scatter-stacked circle.dot.threshold-anomaly {
  stroke-width: 3;
}

.cds--cc--chart-wrapper .cds--cc--tree g.links {
  fill: none;
  stroke: var(--cds-border-strong-01, #8d8d8d);
  stroke-opacity: 0.4;
  stroke-width: 1.5;
}
.cds--cc--chart-wrapper .cds--cc--tree g.clickable {
  cursor: pointer;
}
.cds--cc--chart-wrapper .cds--cc--tree g.clickable:hover text {
  font-weight: 600;
}
.cds--cc--chart-wrapper .cds--cc--tree g.clickable:hover circle {
  fill: var(--cds-text-primary, #161616);
  transition: all 0.1s ease-out;
}
.cds--cc--chart-wrapper .cds--cc--tree circle.parent {
  fill: var(--cds-text-secondary, #525252);
}
.cds--cc--chart-wrapper .cds--cc--tree circle.child {
  fill: var(--cds-border-strong-01, #8d8d8d);
}
.cds--cc--chart-wrapper .cds--cc--tree text {
  fill: var(--cds-text-primary, #161616);
}
.cds--cc--chart-wrapper .cds--cc--tree text.text-stroke {
  stroke: var(--cds-text-inverse, #ffffff);
  stroke-width: 2px;
}

.cds--cc--treemap text {
  pointer-events: none;
}

.cds--cc--wordcloud text.word.light {
  font-weight: 300;
}

.cds--chart-holder {
  --cds-charts-font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  --cds-charts-font-family-condensed: 'IBM Plex Sans Condensed', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  font-family: var(--cds-charts-font-family);
}

.cds--cc--chart-wrapper p {
  padding: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--cds-text-secondary, #525252);
}
.cds--cc--chart-wrapper text {
  font-size: 12px;
  font-weight: 400;
  fill: var(--cds-text-secondary, #525252);
}
.cds--cc--chart-wrapper g.gauge-numbers text.gauge-value-number {
  font-family: var(--cds-charts-font-family);
  font-weight: 300;
}
.cds--cc--chart-wrapper text.meter-title,
.cds--cc--chart-wrapper text.percent-value {
  font-size: 16px;
  font-family: var(--cds-charts-font-family);
}
.cds--cc--chart-wrapper text.meter-title {
  font-weight: 600;
}

.cds--chart-holder {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.cds--chart-holder.filled, .cds--chart-holder.fullscreen {
  background-color: var(--cds-background, #ffffff);
}
.cds--chart-holder.filled .cds--cc--chart-wrapper, .cds--chart-holder.fullscreen .cds--cc--chart-wrapper {
  background-color: var(--cds-background, #ffffff);
}
.cds--chart-holder .DONT_STYLE_ME_css_styles_verifier {
  overflow: hidden;
  opacity: 0;
}

.cds--chart-holder {
  --cds-ai-aura-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-background: #edf5ff;
  --cds-ai-aura-hover-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.32);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #78a9ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.64);
  --cds-ai-border-strong: #4589ff;
  --cds-ai-drop-shadow: rgba(15, 98, 254, 0.1);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.1);
  --cds-ai-overlay: rgba(0, 17, 65, 0.5);
  --cds-ai-popover-background: #ffffff;
  --cds-ai-popover-caret-bottom: #78a9ff;
  --cds-ai-popover-caret-bottom-background: #eaf1ff;
  --cds-ai-popover-caret-bottom-background-actions: #e9effa;
  --cds-ai-popover-caret-center: #a0c3ff;
  --cds-ai-popover-shadow-outer-01: rgba(0, 67, 206, 0.06);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.04);
  --cds-ai-skeleton-background: #d0e2ff;
  --cds-ai-skeleton-element-background: #4589ff;
  --cds-background: #ffffff;
  --cds-background-active: rgba(141, 141, 141, 0.5);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.12);
  --cds-background-inverse: #393939;
  --cds-background-inverse-hover: #474747;
  --cds-background-selected: rgba(141, 141, 141, 0.2);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: #c6c6c6;
  --cds-border-interactive: #0f62fe;
  --cds-border-inverse: #161616;
  --cds-border-strong-01: #8d8d8d;
  --cds-border-strong-02: #8d8d8d;
  --cds-border-strong-03: #8d8d8d;
  --cds-border-subtle-00: #e0e0e0;
  --cds-border-subtle-01: #c6c6c6;
  --cds-border-subtle-02: #e0e0e0;
  --cds-border-subtle-03: #c6c6c6;
  --cds-border-subtle-selected-01: #c6c6c6;
  --cds-border-subtle-selected-02: #c6c6c6;
  --cds-border-subtle-selected-03: #c6c6c6;
  --cds-border-tile-01: #c6c6c6;
  --cds-border-tile-02: #a8a8a8;
  --cds-border-tile-03: #c6c6c6;
  --cds-chat-avatar-agent: #393939;
  --cds-chat-avatar-bot: #6f6f6f;
  --cds-chat-avatar-user: #0f62fe;
  --cds-chat-bubble-agent: #ffffff;
  --cds-chat-bubble-border: #e0e0e0;
  --cds-chat-bubble-user: #e0e0e0;
  --cds-chat-button: #0f62fe;
  --cds-chat-button-active: rgba(141, 141, 141, 0.5);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.12);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.2);
  --cds-chat-button-text-hover: #0043ce;
  --cds-chat-button-text-selected: #525252;
  --cds-chat-header-background: #ffffff;
  --cds-chat-prompt-background: #ffffff;
  --cds-chat-prompt-border-end: rgba(244, 244, 244, 0);
  --cds-chat-prompt-border-start: #f4f4f4;
  --cds-chat-shell-background: #ffffff;
  --cds-field-01: #f4f4f4;
  --cds-field-02: #ffffff;
  --cds-field-03: #f4f4f4;
  --cds-field-hover-01: #e8e8e8;
  --cds-field-hover-02: #e8e8e8;
  --cds-field-hover-03: #e8e8e8;
  --cds-focus: #0f62fe;
  --cds-focus-inset: #ffffff;
  --cds-focus-inverse: #ffffff;
  --cds-highlight: #d0e2ff;
  --cds-icon-disabled: rgba(22, 22, 22, 0.25);
  --cds-icon-interactive: #0f62fe;
  --cds-icon-inverse: #ffffff;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: #8d8d8d;
  --cds-icon-primary: #161616;
  --cds-icon-secondary: #525252;
  --cds-interactive: #0f62fe;
  --cds-layer-01: #f4f4f4;
  --cds-layer-02: #ffffff;
  --cds-layer-03: #f4f4f4;
  --cds-layer-accent-01: #e0e0e0;
  --cds-layer-accent-02: #e0e0e0;
  --cds-layer-accent-03: #e0e0e0;
  --cds-layer-accent-active-01: #a8a8a8;
  --cds-layer-accent-active-02: #a8a8a8;
  --cds-layer-accent-active-03: #a8a8a8;
  --cds-layer-accent-hover-01: #d1d1d1;
  --cds-layer-accent-hover-02: #d1d1d1;
  --cds-layer-accent-hover-03: #d1d1d1;
  --cds-layer-active-01: #c6c6c6;
  --cds-layer-active-02: #c6c6c6;
  --cds-layer-active-03: #c6c6c6;
  --cds-layer-background-01: #ffffff;
  --cds-layer-background-02: #f4f4f4;
  --cds-layer-background-03: #ffffff;
  --cds-layer-hover-01: #e8e8e8;
  --cds-layer-hover-02: #e8e8e8;
  --cds-layer-hover-03: #e8e8e8;
  --cds-layer-selected-01: #e0e0e0;
  --cds-layer-selected-02: #e0e0e0;
  --cds-layer-selected-03: #e0e0e0;
  --cds-layer-selected-disabled: #8d8d8d;
  --cds-layer-selected-hover-01: #d1d1d1;
  --cds-layer-selected-hover-02: #d1d1d1;
  --cds-layer-selected-hover-03: #d1d1d1;
  --cds-layer-selected-inverse: #161616;
  --cds-link-inverse: #78a9ff;
  --cds-link-inverse-active: #f4f4f4;
  --cds-link-inverse-hover: #a6c8ff;
  --cds-link-inverse-visited: #be95ff;
  --cds-link-primary: #0f62fe;
  --cds-link-primary-hover: #0043ce;
  --cds-link-secondary: #0043ce;
  --cds-link-visited: #8a3ffc;
  --cds-overlay: rgba(22, 22, 22, 0.5);
  --cds-shadow: rgba(0, 0, 0, 0.3);
  --cds-skeleton-background: #e8e8e8;
  --cds-skeleton-element: #c6c6c6;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #8a3ffc;
  --cds-support-error: #da1e28;
  --cds-support-error-inverse: #fa4d56;
  --cds-support-info: #0043ce;
  --cds-support-info-inverse: #4589ff;
  --cds-support-success: #24a148;
  --cds-support-success-inverse: #42be65;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-text-disabled: rgba(22, 22, 22, 0.25);
  --cds-text-error: #da1e28;
  --cds-text-helper: #6f6f6f;
  --cds-text-inverse: #ffffff;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: #8d8d8d;
  --cds-text-placeholder: rgba(22, 22, 22, 0.4);
  --cds-text-primary: #161616;
  --cds-text-secondary: #525252;
  --cds-toggle-off: #8d8d8d;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-color-scheme: light;
  --cds-alert-stroke: #b28600;
  --cds-layer-01-absolute: #ffffff;
  --cds-layer-inverse-absolute: #000000;
  --cds-null-state: none;
  --cds-grid-bg: #ffffff;
  --cds-meter-range-indicator: #a8a8a8;
  --cds-network-diagrams-background-hover: #f1f1f1;
  --cds-tooltip-line-border: #e0e0e0;
  --cds-zone-fill-01: #f4f4f4;
  --cds-zone-stroke-01: #8d8d8d;
  --cds-zone-fill-02: #e0e0e0;
  --cds-zone-stroke-02: #8d8d8d;
  --cds-zone-fill-03: #c6c6c6;
  --cds-zone-stroke-03: #8d8d8d;
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--chart-holder[data-carbon-theme=g10] {
  --cds-ai-aura-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-background: #edf5ff;
  --cds-ai-aura-hover-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.32);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #78a9ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.64);
  --cds-ai-border-strong: #4589ff;
  --cds-ai-drop-shadow: rgba(15, 98, 254, 0.1);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.1);
  --cds-ai-overlay: rgba(0, 17, 65, 0.5);
  --cds-ai-popover-background: #ffffff;
  --cds-ai-popover-caret-bottom: #78a9ff;
  --cds-ai-popover-caret-bottom-background: #eaf1ff;
  --cds-ai-popover-caret-bottom-background-actions: #e9effa;
  --cds-ai-popover-caret-center: #a0c3ff;
  --cds-ai-popover-shadow-outer-01: rgba(0, 67, 206, 0.06);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.04);
  --cds-ai-skeleton-background: #d0e2ff;
  --cds-ai-skeleton-element-background: #4589ff;
  --cds-background: #f4f4f4;
  --cds-background-active: rgba(141, 141, 141, 0.5);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.12);
  --cds-background-inverse: #393939;
  --cds-background-inverse-hover: #474747;
  --cds-background-selected: rgba(141, 141, 141, 0.2);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: #c6c6c6;
  --cds-border-interactive: #0f62fe;
  --cds-border-inverse: #161616;
  --cds-border-strong-01: #8d8d8d;
  --cds-border-strong-02: #8d8d8d;
  --cds-border-strong-03: #8d8d8d;
  --cds-border-subtle-00: #c6c6c6;
  --cds-border-subtle-01: #e0e0e0;
  --cds-border-subtle-02: #c6c6c6;
  --cds-border-subtle-03: #e0e0e0;
  --cds-border-subtle-selected-01: #c6c6c6;
  --cds-border-subtle-selected-02: #c6c6c6;
  --cds-border-subtle-selected-03: #c6c6c6;
  --cds-border-tile-01: #a8a8a8;
  --cds-border-tile-02: #c6c6c6;
  --cds-border-tile-03: #a8a8a8;
  --cds-chat-avatar-agent: #393939;
  --cds-chat-avatar-bot: #6f6f6f;
  --cds-chat-avatar-user: #0f62fe;
  --cds-chat-bubble-agent: #ffffff;
  --cds-chat-bubble-border: #e0e0e0;
  --cds-chat-bubble-user: #e0e0e0;
  --cds-chat-button: #0f62fe;
  --cds-chat-button-active: rgba(141, 141, 141, 0.5);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.12);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.2);
  --cds-chat-button-text-hover: #0043ce;
  --cds-chat-button-text-selected: #525252;
  --cds-chat-header-background: #ffffff;
  --cds-chat-prompt-background: #ffffff;
  --cds-chat-prompt-border-end: rgba(244, 244, 244, 0);
  --cds-chat-prompt-border-start: #f4f4f4;
  --cds-chat-shell-background: #ffffff;
  --cds-field-01: #ffffff;
  --cds-field-02: #f4f4f4;
  --cds-field-03: #ffffff;
  --cds-field-hover-01: #e8e8e8;
  --cds-field-hover-02: #e8e8e8;
  --cds-field-hover-03: #e8e8e8;
  --cds-focus: #0f62fe;
  --cds-focus-inset: #ffffff;
  --cds-focus-inverse: #ffffff;
  --cds-highlight: #d0e2ff;
  --cds-icon-disabled: rgba(22, 22, 22, 0.25);
  --cds-icon-interactive: #0f62fe;
  --cds-icon-inverse: #ffffff;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: #8d8d8d;
  --cds-icon-primary: #161616;
  --cds-icon-secondary: #525252;
  --cds-interactive: #0f62fe;
  --cds-layer-01: #ffffff;
  --cds-layer-02: #f4f4f4;
  --cds-layer-03: #ffffff;
  --cds-layer-accent-01: #e0e0e0;
  --cds-layer-accent-02: #e0e0e0;
  --cds-layer-accent-03: #e0e0e0;
  --cds-layer-accent-active-01: #a8a8a8;
  --cds-layer-accent-active-02: #a8a8a8;
  --cds-layer-accent-active-03: #a8a8a8;
  --cds-layer-accent-hover-01: #d1d1d1;
  --cds-layer-accent-hover-02: #d1d1d1;
  --cds-layer-accent-hover-03: #d1d1d1;
  --cds-layer-active-01: #c6c6c6;
  --cds-layer-active-02: #c6c6c6;
  --cds-layer-active-03: #c6c6c6;
  --cds-layer-background-01: #f4f4f4;
  --cds-layer-background-02: #ffffff;
  --cds-layer-background-03: #f4f4f4;
  --cds-layer-hover-01: #e8e8e8;
  --cds-layer-hover-02: #e8e8e8;
  --cds-layer-hover-03: #e8e8e8;
  --cds-layer-selected-01: #e0e0e0;
  --cds-layer-selected-02: #e0e0e0;
  --cds-layer-selected-03: #e0e0e0;
  --cds-layer-selected-disabled: #8d8d8d;
  --cds-layer-selected-hover-01: #d1d1d1;
  --cds-layer-selected-hover-02: #d1d1d1;
  --cds-layer-selected-hover-03: #d1d1d1;
  --cds-layer-selected-inverse: #161616;
  --cds-link-inverse: #78a9ff;
  --cds-link-inverse-active: #f4f4f4;
  --cds-link-inverse-hover: #a6c8ff;
  --cds-link-inverse-visited: #be95ff;
  --cds-link-primary: #0f62fe;
  --cds-link-primary-hover: #0043ce;
  --cds-link-secondary: #0043ce;
  --cds-link-visited: #8a3ffc;
  --cds-overlay: rgba(22, 22, 22, 0.5);
  --cds-shadow: rgba(0, 0, 0, 0.3);
  --cds-skeleton-background: #e8e8e8;
  --cds-skeleton-element: #c6c6c6;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #8a3ffc;
  --cds-support-error: #da1e28;
  --cds-support-error-inverse: #fa4d56;
  --cds-support-info: #0043ce;
  --cds-support-info-inverse: #4589ff;
  --cds-support-success: #24a148;
  --cds-support-success-inverse: #42be65;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-text-disabled: rgba(22, 22, 22, 0.25);
  --cds-text-error: #da1e28;
  --cds-text-helper: #6f6f6f;
  --cds-text-inverse: #ffffff;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: #8d8d8d;
  --cds-text-placeholder: rgba(22, 22, 22, 0.4);
  --cds-text-primary: #161616;
  --cds-text-secondary: #525252;
  --cds-toggle-off: #8d8d8d;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-color-scheme: light;
  --cds-alert-stroke: #b28600;
  --cds-layer-01-absolute: #ffffff;
  --cds-layer-inverse-absolute: #000000;
  --cds-null-state: none;
  --cds-grid-bg: #ffffff;
  --cds-meter-range-indicator: #a8a8a8;
  --cds-network-diagrams-background-hover: #f1f1f1;
  --cds-tooltip-line-border: #e0e0e0;
  --cds-zone-fill-01: #f4f4f4;
  --cds-zone-stroke-01: #8d8d8d;
  --cds-zone-fill-02: #e0e0e0;
  --cds-zone-stroke-02: #8d8d8d;
  --cds-zone-fill-03: #c6c6c6;
  --cds-zone-stroke-03: #8d8d8d;
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--chart-holder[data-carbon-theme=g90] {
  --cds-ai-aura-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-background: #474747;
  --cds-ai-aura-hover-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.4);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #4589ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.36);
  --cds-ai-border-strong: #78a9ff;
  --cds-ai-drop-shadow: rgba(0, 0, 0, 0.28);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.16);
  --cds-ai-overlay: rgba(0, 0, 0, 0.5);
  --cds-ai-popover-background: #161616;
  --cds-ai-popover-caret-bottom: #4589ff;
  --cds-ai-popover-caret-bottom-background: #202d45;
  --cds-ai-popover-caret-bottom-background-actions: #1e283a;
  --cds-ai-popover-caret-center: #4870b5;
  --cds-ai-popover-shadow-outer-01: rgba(0, 0, 0, 0.12);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.08);
  --cds-ai-skeleton-background: rgba(120, 169, 255, 0.5);
  --cds-ai-skeleton-element-background: rgba(120, 169, 255, 0.3);
  --cds-background: #262626;
  --cds-background-active: rgba(141, 141, 141, 0.4);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.16);
  --cds-background-inverse: #f4f4f4;
  --cds-background-inverse-hover: #e8e8e8;
  --cds-background-selected: rgba(141, 141, 141, 0.24);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: rgba(141, 141, 141, 0.5);
  --cds-border-interactive: #4589ff;
  --cds-border-inverse: #f4f4f4;
  --cds-border-strong-01: #8d8d8d;
  --cds-border-strong-02: #a8a8a8;
  --cds-border-strong-03: #c6c6c6;
  --cds-border-subtle-00: #525252;
  --cds-border-subtle-01: #6f6f6f;
  --cds-border-subtle-02: #8d8d8d;
  --cds-border-subtle-03: #8d8d8d;
  --cds-border-subtle-selected-01: #8d8d8d;
  --cds-border-subtle-selected-02: #a8a8a8;
  --cds-border-subtle-selected-03: #a8a8a8;
  --cds-border-tile-01: #6f6f6f;
  --cds-border-tile-02: #8d8d8d;
  --cds-border-tile-03: #a8a8a8;
  --cds-chat-avatar-agent: #c6c6c6;
  --cds-chat-avatar-bot: #8d8d8d;
  --cds-chat-avatar-user: #4589ff;
  --cds-chat-bubble-agent: #262626;
  --cds-chat-bubble-border: #525252;
  --cds-chat-bubble-user: #393939;
  --cds-chat-button: #78a9ff;
  --cds-chat-button-active: rgba(141, 141, 141, 0.4);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.16);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.24);
  --cds-chat-button-text-hover: #a6c8ff;
  --cds-chat-button-text-selected: #c6c6c6;
  --cds-chat-header-background: #262626;
  --cds-chat-prompt-background: #161616;
  --cds-chat-prompt-border-end: rgba(38, 38, 38, 0);
  --cds-chat-prompt-border-start: #262626;
  --cds-chat-shell-background: #262626;
  --cds-field-01: #393939;
  --cds-field-02: #525252;
  --cds-field-03: #6f6f6f;
  --cds-field-hover-01: #474747;
  --cds-field-hover-02: #636363;
  --cds-field-hover-03: #5e5e5e;
  --cds-focus: #ffffff;
  --cds-focus-inset: #161616;
  --cds-focus-inverse: #0f62fe;
  --cds-highlight: #002d9c;
  --cds-icon-disabled: rgba(244, 244, 244, 0.25);
  --cds-icon-interactive: #ffffff;
  --cds-icon-inverse: #161616;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-icon-primary: #f4f4f4;
  --cds-icon-secondary: #c6c6c6;
  --cds-interactive: #4589ff;
  --cds-layer-01: #393939;
  --cds-layer-02: #525252;
  --cds-layer-03: #6f6f6f;
  --cds-layer-accent-01: #525252;
  --cds-layer-accent-02: #6f6f6f;
  --cds-layer-accent-03: #8d8d8d;
  --cds-layer-accent-active-01: #8d8d8d;
  --cds-layer-accent-active-02: #393939;
  --cds-layer-accent-active-03: #525252;
  --cds-layer-accent-hover-01: #636363;
  --cds-layer-accent-hover-02: #5e5e5e;
  --cds-layer-accent-hover-03: #7a7a7a;
  --cds-layer-active-01: #6f6f6f;
  --cds-layer-active-02: #8d8d8d;
  --cds-layer-active-03: #393939;
  --cds-layer-background-01: #262626;
  --cds-layer-background-02: #393939;
  --cds-layer-background-03: #525252;
  --cds-layer-hover-01: #474747;
  --cds-layer-hover-02: #636363;
  --cds-layer-hover-03: #5e5e5e;
  --cds-layer-selected-01: #525252;
  --cds-layer-selected-02: #6f6f6f;
  --cds-layer-selected-03: #525252;
  --cds-layer-selected-disabled: #a8a8a8;
  --cds-layer-selected-hover-01: #636363;
  --cds-layer-selected-hover-02: #5e5e5e;
  --cds-layer-selected-hover-03: #636363;
  --cds-layer-selected-inverse: #f4f4f4;
  --cds-link-inverse: #0f62fe;
  --cds-link-inverse-active: #161616;
  --cds-link-inverse-hover: #0043ce;
  --cds-link-inverse-visited: #8a3ffc;
  --cds-link-primary: #78a9ff;
  --cds-link-primary-hover: #a6c8ff;
  --cds-link-secondary: #a6c8ff;
  --cds-link-visited: #be95ff;
  --cds-overlay: rgba(0, 0, 0, 0.65);
  --cds-shadow: rgba(0, 0, 0, 0.8);
  --cds-skeleton-background: #333333;
  --cds-skeleton-element: #525252;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #a56eff;
  --cds-support-error: #ff8389;
  --cds-support-error-inverse: #da1e28;
  --cds-support-info: #4589ff;
  --cds-support-info-inverse: #0043ce;
  --cds-support-success: #42be65;
  --cds-support-success-inverse: #24a148;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-text-disabled: rgba(244, 244, 244, 0.25);
  --cds-text-error: #ffb3b8;
  --cds-text-helper: #c6c6c6;
  --cds-text-inverse: #161616;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-text-placeholder: rgba(244, 244, 244, 0.4);
  --cds-text-primary: #f4f4f4;
  --cds-text-secondary: #c6c6c6;
  --cds-toggle-off: #8d8d8d;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-color-scheme: dark;
  --cds-alert-stroke: none;
  --cds-layer-01-absolute: #000000;
  --cds-layer-inverse-absolute: #ffffff;
  --cds-null-state: #161616;
  --cds-grid-bg: #161616;
  --cds-meter-range-indicator: #6f6f6f;
  --cds-network-diagrams-background-hover: #ededed;
  --cds-tooltip-line-border: #393939;
  --cds-zone-fill-01: #262626;
  --cds-zone-stroke-01: #6f6f6f;
  --cds-zone-fill-02: #393939;
  --cds-zone-stroke-02: #6f6f6f;
  --cds-zone-fill-03: #525252;
  --cds-zone-stroke-03: #6f6f6f;
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--chart-holder[data-carbon-theme=g100] {
  --cds-ai-aura-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-background: #333333;
  --cds-ai-aura-hover-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.4);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #4589ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.36);
  --cds-ai-border-strong: #78a9ff;
  --cds-ai-drop-shadow: rgba(0, 0, 0, 0.28);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.16);
  --cds-ai-overlay: rgba(0, 0, 0, 0.5);
  --cds-ai-popover-background: #161616;
  --cds-ai-popover-caret-bottom: #4589ff;
  --cds-ai-popover-caret-bottom-background: #202d45;
  --cds-ai-popover-caret-bottom-background-actions: #1e283a;
  --cds-ai-popover-caret-center: #4870b5;
  --cds-ai-popover-shadow-outer-01: rgba(0, 0, 0, 0.12);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.08);
  --cds-ai-skeleton-background: rgba(120, 169, 255, 0.5);
  --cds-ai-skeleton-element-background: rgba(120, 169, 255, 0.3);
  --cds-background: #161616;
  --cds-background-active: rgba(141, 141, 141, 0.4);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.16);
  --cds-background-inverse: #f4f4f4;
  --cds-background-inverse-hover: #e8e8e8;
  --cds-background-selected: rgba(141, 141, 141, 0.24);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: rgba(141, 141, 141, 0.5);
  --cds-border-interactive: #4589ff;
  --cds-border-inverse: #f4f4f4;
  --cds-border-strong-01: #6f6f6f;
  --cds-border-strong-02: #8d8d8d;
  --cds-border-strong-03: #a8a8a8;
  --cds-border-subtle-00: #393939;
  --cds-border-subtle-01: #525252;
  --cds-border-subtle-02: #6f6f6f;
  --cds-border-subtle-03: #6f6f6f;
  --cds-border-subtle-selected-01: #6f6f6f;
  --cds-border-subtle-selected-02: #8d8d8d;
  --cds-border-subtle-selected-03: #8d8d8d;
  --cds-border-tile-01: #525252;
  --cds-border-tile-02: #6f6f6f;
  --cds-border-tile-03: #8d8d8d;
  --cds-chat-avatar-agent: #c6c6c6;
  --cds-chat-avatar-bot: #8d8d8d;
  --cds-chat-avatar-user: #4589ff;
  --cds-chat-bubble-agent: #262626;
  --cds-chat-bubble-border: #525252;
  --cds-chat-bubble-user: #393939;
  --cds-chat-button: #78a9ff;
  --cds-chat-button-active: rgba(141, 141, 141, 0.4);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.16);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.24);
  --cds-chat-button-text-hover: #a6c8ff;
  --cds-chat-button-text-selected: #c6c6c6;
  --cds-chat-header-background: #262626;
  --cds-chat-prompt-background: #161616;
  --cds-chat-prompt-border-end: rgba(38, 38, 38, 0);
  --cds-chat-prompt-border-start: #262626;
  --cds-chat-shell-background: #262626;
  --cds-field-01: #262626;
  --cds-field-02: #393939;
  --cds-field-03: #525252;
  --cds-field-hover-01: #333333;
  --cds-field-hover-02: #474747;
  --cds-field-hover-03: #636363;
  --cds-focus: #ffffff;
  --cds-focus-inset: #161616;
  --cds-focus-inverse: #0f62fe;
  --cds-highlight: #001d6c;
  --cds-icon-disabled: rgba(244, 244, 244, 0.25);
  --cds-icon-interactive: #ffffff;
  --cds-icon-inverse: #161616;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-icon-primary: #f4f4f4;
  --cds-icon-secondary: #c6c6c6;
  --cds-interactive: #4589ff;
  --cds-layer-01: #262626;
  --cds-layer-02: #393939;
  --cds-layer-03: #525252;
  --cds-layer-accent-01: #393939;
  --cds-layer-accent-02: #525252;
  --cds-layer-accent-03: #6f6f6f;
  --cds-layer-accent-active-01: #6f6f6f;
  --cds-layer-accent-active-02: #8d8d8d;
  --cds-layer-accent-active-03: #393939;
  --cds-layer-accent-hover-01: #474747;
  --cds-layer-accent-hover-02: #636363;
  --cds-layer-accent-hover-03: #5e5e5e;
  --cds-layer-active-01: #525252;
  --cds-layer-active-02: #6f6f6f;
  --cds-layer-active-03: #8d8d8d;
  --cds-layer-background-01: #161616;
  --cds-layer-background-02: #262626;
  --cds-layer-background-03: #393939;
  --cds-layer-hover-01: #333333;
  --cds-layer-hover-02: #474747;
  --cds-layer-hover-03: #636363;
  --cds-layer-selected-01: #393939;
  --cds-layer-selected-02: #525252;
  --cds-layer-selected-03: #6f6f6f;
  --cds-layer-selected-disabled: #a8a8a8;
  --cds-layer-selected-hover-01: #474747;
  --cds-layer-selected-hover-02: #636363;
  --cds-layer-selected-hover-03: #5e5e5e;
  --cds-layer-selected-inverse: #f4f4f4;
  --cds-link-inverse: #0f62fe;
  --cds-link-inverse-active: #161616;
  --cds-link-inverse-hover: #0043ce;
  --cds-link-inverse-visited: #8a3ffc;
  --cds-link-primary: #78a9ff;
  --cds-link-primary-hover: #a6c8ff;
  --cds-link-secondary: #a6c8ff;
  --cds-link-visited: #be95ff;
  --cds-overlay: rgba(0, 0, 0, 0.65);
  --cds-shadow: rgba(0, 0, 0, 0.8);
  --cds-skeleton-background: #292929;
  --cds-skeleton-element: #393939;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #a56eff;
  --cds-support-error: #fa4d56;
  --cds-support-error-inverse: #da1e28;
  --cds-support-info: #4589ff;
  --cds-support-info-inverse: #0043ce;
  --cds-support-success: #42be65;
  --cds-support-success-inverse: #24a148;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-text-disabled: rgba(244, 244, 244, 0.25);
  --cds-text-error: #ff8389;
  --cds-text-helper: #a8a8a8;
  --cds-text-inverse: #161616;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-text-placeholder: rgba(244, 244, 244, 0.4);
  --cds-text-primary: #f4f4f4;
  --cds-text-secondary: #c6c6c6;
  --cds-toggle-off: #6f6f6f;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-color-scheme: dark;
  --cds-alert-stroke: none;
  --cds-layer-01-absolute: #000000;
  --cds-layer-inverse-absolute: #ffffff;
  --cds-null-state: none;
  --cds-grid-bg: #161616;
  --cds-meter-range-indicator: #6f6f6f;
  --cds-network-diagrams-background-hover: #ededed;
  --cds-tooltip-line-border: #6f6f6f;
  --cds-zone-fill-01: #262626;
  --cds-zone-stroke-01: #6f6f6f;
  --cds-zone-fill-02: #393939;
  --cds-zone-stroke-02: #6f6f6f;
  --cds-zone-fill-03: #525252;
  --cds-zone-stroke-03: #6f6f6f;
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--chart-holder.fullscreen {
  width: 100% !important;
  height: 100% !important;
  max-width: unset !important;
  max-height: unset !important;
  padding: 2em;
}

.cds--cc--chart-wrapper {
  overflow: visible;
  font-family: var(--cds-charts-font-family-condensed);
}

/*# sourceMappingURL=styles.css.map */
`, "",{"version":3,"sources":["webpack://./node_modules/@carbon/charts/scss/_colors.scss","webpack://./node_modules/@carbon/charts/dist/styles.css","webpack://./node_modules/@carbon/charts/scss/_transition.scss","webpack://./node_modules/@carbon/charts/scss/_tokens.scss","webpack://./node_modules/@carbon/charts/scss/components/_axis.scss","webpack://./node_modules/node_modules/@carbon/themes/scss/generated/_tokens.scss","webpack://./node_modules/node_modules/@carbon/styles/scss/theme/_theme.scss","webpack://./node_modules/@carbon/charts/scss/components/_callouts.scss","webpack://./node_modules/@carbon/charts/scss/components/_color-legend.scss","webpack://./node_modules/@carbon/charts/scss/components/diagrams/_card-node.scss","webpack://./node_modules/node_modules/@carbon/styles/scss/utilities/_focus-outline.scss","webpack://./node_modules/node_modules/@carbon/type/scss/_styles.scss","webpack://./node_modules/node_modules/@carbon/layout/scss/generated/_spacing.scss","webpack://./node_modules/@carbon/charts/scss/components/diagrams/_shape-node.scss","webpack://./node_modules/@carbon/charts/scss/components/diagrams/_edge.scss","webpack://./node_modules/@carbon/charts/scss/components/diagrams/_marker.scss","webpack://./node_modules/@carbon/charts/scss/components/_grid.scss","webpack://./node_modules/@carbon/charts/scss/components/_grid-brush.scss","webpack://./node_modules/node_modules/@carbon/styles/scss/components/button/_tokens.scss","webpack://./node_modules/@carbon/charts/scss/components/_highlights.scss","webpack://./node_modules/node_modules/@carbon/colors/index.scss","webpack://./node_modules/@carbon/charts/scss/components/_layout.scss","webpack://./node_modules/@carbon/charts/scss/components/_legend.scss","webpack://./node_modules/@carbon/charts/scss/components/_meter-title.scss","webpack://./node_modules/@carbon/charts/scss/components/_ruler.scss","webpack://./node_modules/@carbon/charts/scss/components/_skeleton.scss","webpack://./node_modules/@carbon/charts/scss/components/_skeleton-lines.scss","webpack://./node_modules/@carbon/charts/scss/components/_threshold.scss","webpack://./node_modules/node_modules/@carbon/motion/index.scss","webpack://./node_modules/@carbon/charts/scss/components/_title.scss","webpack://./node_modules/@carbon/charts/scss/components/toolbar/_buttons.scss","webpack://./node_modules/@carbon/charts/scss/components/toolbar/_modal.scss","webpack://./node_modules/@carbon/charts/scss/components/_tooltip.scss","webpack://./node_modules/@carbon/charts/scss/components/_zero-line.scss","webpack://./node_modules/@carbon/charts/scss/components/_zoom-bar.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_alluvial.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_area.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_bubble.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_bullet.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_choropleth.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_circle-pack.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_donut.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_gauge.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_heatmap.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_line.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_lollipop.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_meter.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_pie.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_radar.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_scatter.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_scatter-stacked.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_tree.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_treemap.scss","webpack://./node_modules/@carbon/charts/scss/graphs/_wordcloud.scss","webpack://./node_modules/@carbon/charts/scss/_type.scss","webpack://./node_modules/node_modules/@carbon/layout/scss/_convert.scss","webpack://./node_modules/@carbon/charts/scss/_chart-holder.scss","webpack://./node_modules/node_modules/@carbon/themes/scss/_theme.scss","webpack://./node_modules/node_modules/@carbon/styles/scss/utilities/_custom-property.scss","webpack://./node_modules/@carbon/charts/scss/_chart-wrapper.scss"],"names":[],"mappings":"AA8CA;EAEE,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,wDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,iDAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,8CAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,wDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,4EAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,8CAAA;EADA,2BAAA;EACA,wDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,8CAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,2EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,2EAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,4EAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,wDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,8CAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,wDAAA;EADA,2BAAA;EACA,yDAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,0EAAA;EADA,2BAAA;EACA,0DAAA;EADA,4BAAA;EACA,8EAAA;EADA,4BAAA;EACA,+EAAA;EADA,4BAAA;EACA,+CAAA;EADA,4BAAA;EACA,8EAAA;EADA,4BAAA;EACA,6EAAA;EADA,4BAAA;EACA,2EAAA;EADA,4BAAA;EACA,6EAAA;EADA,4BAAA;EACA,yDAAA;EADA,4BAAA;EACA,+EAAA;EADA,6BAAA;EACA,2DAAA;EADA,6BAAA;EACA,2DAAA;EADA,6BAAA;EACA,6EAAA;EADA,6BAAA;EACA,0DAAA;EADA,6BAAA;EACA,4DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,yEAAA;EADA,8BAAA;EACA,gFAAA;EADA,8BAAA;EACA,8DAAA;EADA,+BAAA;EACA,gFAAA;EADA,+BAAA;EACA,6DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,+EAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,2DAAA;EADA,+BAAA;EACA,2DAAA;EADA,+BAAA;EACA,0DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,qDAAA;EADA,8BAAA;EACA,iFAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,0DAAA;EADA,+BAAA;EACA,+EAAA;EADA,+BAAA;EACA,6DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,mEAAA;EADA,8BAAA;EACA,iFAAA;EADA,8BAAA;EACA,gFAAA;EADA,8BAAA;EACA,4DAAA;EADA,8BAAA;EACA,oDAAA;EADA,8BAAA;EACA,iDAAA;EADA,8BAAA;EACA,mDAAA;EADA,+BAAA;EACA,0DAAA;EADA,+BAAA;EACA,6EAAA;EADA,iCAAA;EACA,kFAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,kFAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,0DAAA;EADA,iCAAA;EACA,wDAAA;EADA,iCAAA;EACA,6DAAA;EADA,kCAAA;EACA,kEAAA;EADA,kCAAA;EACA,kEAAA;EADA,kCAAA;EACA,2DAAA;EADA,kCAAA;EACA,yDAAA;EADA,kCAAA;EACA,qFAAA;EADA,kCAAA;EACA,+DAAA;EADA,kCAAA;EACA,+DAAA;EADA,kCAAA;EACA,8DAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,4EAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,0DAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,6DAAA;EADA,kCAAA;EACA,2DAAA;EADA,kCAAA;EACA,uEAAA;EADA,kCAAA;EACA,qFAAA;EADA,kCAAA;EACA,oFAAA;EADA,kCAAA;EACA,gEAAA;EADA,kCAAA;EACA,wDAAA;EADA,kCAAA;EACA,qDAAA;EADA,kCAAA;EACA,uDAAA;AC8OF;;ADzOA;;EAGE,2BAAA;EACA,oDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,2DAAA;EADA,2BAAA;EACA,iDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,2DAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,oDAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,iDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,2DAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,2DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,oDAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,iDAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,8EAAA;EADA,2BAAA;EACA,sEAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,2DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,0DAAA;EADA,2BAAA;EACA,6EAAA;EADA,2BAAA;EACA,oDAAA;EADA,2BAAA;EACA,kDAAA;EADA,2BAAA;EACA,8EAAA;EADA,4BAAA;EACA,uEAAA;EADA,4BAAA;EACA,mDAAA;EADA,4BAAA;EACA,kDAAA;EADA,4BAAA;EACA,2DAAA;EADA,4BAAA;EACA,6EAAA;EADA,4BAAA;EACA,mDAAA;EADA,4BAAA;EACA,+EAAA;EADA,4BAAA;EACA,2DAAA;EADA,4BAAA;EACA,8EAAA;EADA,6BAAA;EACA,+EAAA;EADA,6BAAA;EACA,+EAAA;EADA,6BAAA;EACA,6DAAA;EADA,6BAAA;EACA,0DAAA;EADA,6BAAA;EACA,sDAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,yEAAA;EADA,8BAAA;EACA,gFAAA;EADA,8BAAA;EACA,8DAAA;EADA,+BAAA;EACA,gFAAA;EADA,+BAAA;EACA,6DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,6DAAA;EADA,8BAAA;EACA,+EAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,2DAAA;EADA,+BAAA;EACA,2DAAA;EADA,+BAAA;EACA,0DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,8DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,qDAAA;EADA,8BAAA;EACA,iFAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,2DAAA;EADA,8BAAA;EACA,0DAAA;EADA,+BAAA;EACA,+EAAA;EADA,+BAAA;EACA,6DAAA;EADA,8BAAA;EACA,0DAAA;EADA,8BAAA;EACA,uDAAA;EADA,8BAAA;EACA,mEAAA;EADA,8BAAA;EACA,iFAAA;EADA,8BAAA;EACA,gFAAA;EADA,8BAAA;EACA,4DAAA;EADA,8BAAA;EACA,oDAAA;EADA,8BAAA;EACA,iDAAA;EADA,8BAAA;EACA,mDAAA;EADA,+BAAA;EACA,0DAAA;EADA,+BAAA;EACA,6EAAA;EADA,iCAAA;EACA,kFAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,kFAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,0DAAA;EADA,iCAAA;EACA,wDAAA;EADA,iCAAA;EACA,6DAAA;EADA,kCAAA;EACA,kEAAA;EADA,kCAAA;EACA,kEAAA;EADA,kCAAA;EACA,2DAAA;EADA,kCAAA;EACA,yDAAA;EADA,kCAAA;EACA,qFAAA;EADA,kCAAA;EACA,+DAAA;EADA,kCAAA;EACA,+DAAA;EADA,kCAAA;EACA,8DAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,mFAAA;EADA,iCAAA;EACA,4EAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,gEAAA;EADA,iCAAA;EACA,0DAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,iEAAA;EADA,iCAAA;EACA,6DAAA;EADA,kCAAA;EACA,2DAAA;EADA,kCAAA;EACA,uEAAA;EADA,kCAAA;EACA,qFAAA;EADA,kCAAA;EACA,oFAAA;EADA,kCAAA;EACA,gEAAA;EADA,kCAAA;EACA,wDAAA;EADA,kCAAA;EACA,qDAAA;EADA,kCAAA;EACA,uDAAA;ACugBF;;ADhgBE;EACC,sCAAA;ACmgBH;ADjgBG;EACC,8CAAA;EEnEH,6BAAA;ADukBD;AD/fE;EACC,kDAAA;ACigBH;AD/fG;EACC,0DAAA;EE5EH,6BAAA;AD8kBD;AD7fE;EACC,wCAAA;AC+fH;AD5fE;EACC,4CAAA;AC8fH;ADrhBE;EACC,sCAAA;ACuhBH;ADrhBG;EACC,8CAAA;EEnEH,6BAAA;AD2lBD;ADnhBE;EACC,kDAAA;ACqhBH;ADnhBG;EACC,0DAAA;EE5EH,6BAAA;ADkmBD;ADjhBE;EACC,wCAAA;ACmhBH;ADhhBE;EACC,4CAAA;ACkhBH;ADziBE;EACC,sCAAA;AC2iBH;ADziBG;EACC,8CAAA;EEnEH,6BAAA;AD+mBD;ADviBE;EACC,kDAAA;ACyiBH;ADviBG;EACC,0DAAA;EE5EH,6BAAA;ADsnBD;ADriBE;EACC,wCAAA;ACuiBH;ADpiBE;EACC,4CAAA;ACsiBH;AD7jBE;EACC,sCAAA;AC+jBH;AD7jBG;EACC,8CAAA;EEnEH,6BAAA;ADmoBD;AD3jBE;EACC,kDAAA;AC6jBH;AD3jBG;EACC,0DAAA;EE5EH,6BAAA;AD0oBD;ADzjBE;EACC,wCAAA;AC2jBH;ADxjBE;EACC,4CAAA;AC0jBH;ADjlBE;EACC,sCAAA;ACmlBH;ADjlBG;EACC,8CAAA;EEnEH,6BAAA;ADupBD;AD/kBE;EACC,kDAAA;ACilBH;AD/kBG;EACC,0DAAA;EE5EH,6BAAA;AD8pBD;AD7kBE;EACC,wCAAA;AC+kBH;AD5kBE;EACC,4CAAA;AC8kBH;ADrmBE;EACC,sCAAA;ACumBH;ADrmBG;EACC,8CAAA;EEnEH,6BAAA;AD2qBD;ADnmBE;EACC,kDAAA;ACqmBH;ADnmBG;EACC,0DAAA;EE5EH,6BAAA;ADkrBD;ADjmBE;EACC,wCAAA;ACmmBH;ADhmBE;EACC,4CAAA;ACkmBH;ADznBE;EACC,sCAAA;AC2nBH;ADznBG;EACC,8CAAA;EEnEH,6BAAA;AD+rBD;ADvnBE;EACC,kDAAA;ACynBH;ADvnBG;EACC,0DAAA;EE5EH,6BAAA;ADssBD;ADrnBE;EACC,wCAAA;ACunBH;ADpnBE;EACC,4CAAA;ACsnBH;AD7oBE;EACC,sCAAA;AC+oBH;AD7oBG;EACC,8CAAA;EEnEH,6BAAA;ADmtBD;AD3oBE;EACC,kDAAA;AC6oBH;AD3oBG;EACC,0DAAA;EE5EH,6BAAA;AD0tBD;ADzoBE;EACC,wCAAA;AC2oBH;ADxoBE;EACC,4CAAA;AC0oBH;ADjqBE;EACC,sCAAA;ACmqBH;ADjqBG;EACC,8CAAA;EEnEH,6BAAA;ADuuBD;AD/pBE;EACC,kDAAA;ACiqBH;AD/pBG;EACC,0DAAA;EE5EH,6BAAA;AD8uBD;AD7pBE;EACC,wCAAA;AC+pBH;AD5pBE;EACC,4CAAA;AC8pBH;ADrrBE;EACC,sCAAA;ACurBH;ADrrBG;EACC,8CAAA;EEnEH,6BAAA;AD2vBD;ADnrBE;EACC,kDAAA;ACqrBH;ADnrBG;EACC,0DAAA;EE5EH,6BAAA;ADkwBD;ADjrBE;EACC,wCAAA;ACmrBH;ADhrBE;EACC,4CAAA;ACkrBH;ADzsBE;EACC,sCAAA;AC2sBH;ADzsBG;EACC,8CAAA;EEnEH,6BAAA;AD+wBD;ADvsBE;EACC,kDAAA;ACysBH;ADvsBG;EACC,0DAAA;EE5EH,6BAAA;ADsxBD;ADrsBE;EACC,wCAAA;ACusBH;ADpsBE;EACC,4CAAA;ACssBH;AD7tBE;EACC,sCAAA;AC+tBH;AD7tBG;EACC,8CAAA;EEnEH,6BAAA;ADmyBD;AD3tBE;EACC,kDAAA;AC6tBH;AD3tBG;EACC,0DAAA;EE5EH,6BAAA;AD0yBD;ADztBE;EACC,wCAAA;AC2tBH;ADxtBE;EACC,4CAAA;AC0tBH;ADjvBE;EACC,sCAAA;ACmvBH;ADjvBG;EACC,8CAAA;EEnEH,6BAAA;ADuzBD;AD/uBE;EACC,kDAAA;ACivBH;AD/uBG;EACC,0DAAA;EE5EH,6BAAA;AD8zBD;AD7uBE;EACC,wCAAA;AC+uBH;AD5uBE;EACC,4CAAA;AC8uBH;ADrwBE;EACC,sCAAA;ACuwBH;ADrwBG;EACC,8CAAA;EEnEH,6BAAA;AD20BD;ADnwBE;EACC,kDAAA;ACqwBH;ADnwBG;EACC,0DAAA;EE5EH,6BAAA;ADk1BD;ADjwBE;EACC,wCAAA;ACmwBH;ADhwBE;EACC,4CAAA;ACkwBH;ADzxBE;EACC,sCAAA;AC2xBH;ADzxBG;EACC,8CAAA;EEnEH,6BAAA;AD+1BD;ADvxBE;EACC,kDAAA;ACyxBH;ADvxBG;EACC,0DAAA;EE5EH,6BAAA;ADs2BD;ADrxBE;EACC,wCAAA;ACuxBH;ADpxBE;EACC,4CAAA;ACsxBH;AD7yBE;EACC,sCAAA;AC+yBH;AD7yBG;EACC,8CAAA;EEnEH,6BAAA;ADm3BD;AD3yBE;EACC,kDAAA;AC6yBH;AD3yBG;EACC,0DAAA;EE5EH,6BAAA;AD03BD;ADzyBE;EACC,wCAAA;AC2yBH;ADxyBE;EACC,4CAAA;AC0yBH;ADj0BE;EACC,sCAAA;ACm0BH;ADj0BG;EACC,8CAAA;EEnEH,6BAAA;ADu4BD;AD/zBE;EACC,kDAAA;ACi0BH;AD/zBG;EACC,0DAAA;EE5EH,6BAAA;AD84BD;AD7zBE;EACC,wCAAA;AC+zBH;AD5zBE;EACC,4CAAA;AC8zBH;ADr1BE;EACC,sCAAA;ACu1BH;ADr1BG;EACC,8CAAA;EEnEH,6BAAA;AD25BD;ADn1BE;EACC,kDAAA;ACq1BH;ADn1BG;EACC,0DAAA;EE5EH,6BAAA;ADk6BD;ADj1BE;EACC,wCAAA;ACm1BH;ADh1BE;EACC,4CAAA;ACk1BH;ADz2BE;EACC,sCAAA;AC22BH;ADz2BG;EACC,8CAAA;EEnEH,6BAAA;AD+6BD;ADv2BE;EACC,kDAAA;ACy2BH;ADv2BG;EACC,0DAAA;EE5EH,6BAAA;ADs7BD;ADr2BE;EACC,wCAAA;ACu2BH;ADp2BE;EACC,4CAAA;ACs2BH;AD73BE;EACC,sCAAA;AC+3BH;AD73BG;EACC,8CAAA;EEnEH,6BAAA;ADm8BD;AD33BE;EACC,kDAAA;AC63BH;AD33BG;EACC,0DAAA;EE5EH,6BAAA;AD08BD;ADz3BE;EACC,wCAAA;AC23BH;ADx3BE;EACC,4CAAA;AC03BH;ADj5BE;EACC,sCAAA;ACm5BH;ADj5BG;EACC,8CAAA;EEnEH,6BAAA;ADu9BD;AD/4BE;EACC,kDAAA;ACi5BH;AD/4BG;EACC,0DAAA;EE5EH,6BAAA;AD89BD;AD74BE;EACC,wCAAA;AC+4BH;AD54BE;EACC,4CAAA;AC84BH;ADr6BE;EACC,sCAAA;ACu6BH;ADr6BG;EACC,8CAAA;EEnEH,6BAAA;AD2+BD;ADn6BE;EACC,kDAAA;ACq6BH;ADn6BG;EACC,0DAAA;EE5EH,6BAAA;ADk/BD;ADj6BE;EACC,wCAAA;ACm6BH;ADh6BE;EACC,4CAAA;ACk6BH;ADz7BE;EACC,sCAAA;AC27BH;ADz7BG;EACC,8CAAA;EEnEH,6BAAA;AD+/BD;ADv7BE;EACC,kDAAA;ACy7BH;ADv7BG;EACC,0DAAA;EE5EH,6BAAA;ADsgCD;ADr7BE;EACC,wCAAA;ACu7BH;ADp7BE;EACC,4CAAA;ACs7BH;AD78BE;EACC,sCAAA;AC+8BH;AD78BG;EACC,8CAAA;EEnEH,6BAAA;ADmhCD;AD38BE;EACC,kDAAA;AC68BH;AD38BG;EACC,0DAAA;EE5EH,6BAAA;AD0hCD;ADz8BE;EACC,wCAAA;AC28BH;ADx8BE;EACC,4CAAA;AC08BH;ADj+BE;EACC,sCAAA;ACm+BH;ADj+BG;EACC,8CAAA;EEnEH,6BAAA;ADuiCD;AD/9BE;EACC,kDAAA;ACi+BH;AD/9BG;EACC,0DAAA;EE5EH,6BAAA;AD8iCD;AD79BE;EACC,wCAAA;AC+9BH;AD59BE;EACC,4CAAA;AC89BH;ADr/BE;EACC,sCAAA;ACu/BH;ADr/BG;EACC,8CAAA;EEnEH,6BAAA;AD2jCD;ADn/BE;EACC,kDAAA;ACq/BH;ADn/BG;EACC,0DAAA;EE5EH,6BAAA;ADkkCD;ADj/BE;EACC,wCAAA;ACm/BH;ADh/BE;EACC,4CAAA;ACk/BH;ADzgCE;EACC,sCAAA;AC2gCH;ADzgCG;EACC,8CAAA;EEnEH,6BAAA;AD+kCD;ADvgCE;EACC,kDAAA;ACygCH;ADvgCG;EACC,0DAAA;EE5EH,6BAAA;ADslCD;ADrgCE;EACC,wCAAA;ACugCH;ADpgCE;EACC,4CAAA;ACsgCH;AD7hCE;EACC,sCAAA;AC+hCH;AD7hCG;EACC,8CAAA;EEnEH,6BAAA;ADmmCD;AD3hCE;EACC,kDAAA;AC6hCH;AD3hCG;EACC,0DAAA;EE5EH,6BAAA;AD0mCD;ADzhCE;EACC,wCAAA;AC2hCH;ADxhCE;EACC,4CAAA;AC0hCH;ADjjCE;EACC,sCAAA;ACmjCH;ADjjCG;EACC,8CAAA;EEnEH,6BAAA;ADunCD;AD/iCE;EACC,kDAAA;ACijCH;AD/iCG;EACC,0DAAA;EE5EH,6BAAA;AD8nCD;AD7iCE;EACC,wCAAA;AC+iCH;AD5iCE;EACC,4CAAA;AC8iCH;ADrkCE;EACC,sCAAA;ACukCH;ADrkCG;EACC,8CAAA;EEnEH,6BAAA;AD2oCD;ADnkCE;EACC,kDAAA;ACqkCH;ADnkCG;EACC,0DAAA;EE5EH,6BAAA;ADkpCD;ADjkCE;EACC,wCAAA;ACmkCH;ADhkCE;EACC,4CAAA;ACkkCH;ADzlCE;EACC,sCAAA;AC2lCH;ADzlCG;EACC,8CAAA;EEnEH,6BAAA;AD+pCD;ADvlCE;EACC,kDAAA;ACylCH;ADvlCG;EACC,0DAAA;EE5EH,6BAAA;ADsqCD;ADrlCE;EACC,wCAAA;ACulCH;ADplCE;EACC,4CAAA;ACslCH;AD7mCE;EACC,sCAAA;AC+mCH;AD7mCG;EACC,8CAAA;EEnEH,6BAAA;ADmrCD;AD3mCE;EACC,kDAAA;AC6mCH;AD3mCG;EACC,0DAAA;EE5EH,6BAAA;AD0rCD;ADzmCE;EACC,wCAAA;AC2mCH;ADxmCE;EACC,4CAAA;AC0mCH;ADjoCE;EACC,sCAAA;ACmoCH;ADjoCG;EACC,8CAAA;EEnEH,6BAAA;ADusCD;AD/nCE;EACC,kDAAA;ACioCH;AD/nCG;EACC,0DAAA;EE5EH,6BAAA;AD8sCD;AD7nCE;EACC,wCAAA;AC+nCH;AD5nCE;EACC,4CAAA;AC8nCH;ADrpCE;EACC,sCAAA;ACupCH;ADrpCG;EACC,8CAAA;EEnEH,6BAAA;AD2tCD;ADnpCE;EACC,kDAAA;ACqpCH;ADnpCG;EACC,0DAAA;EE5EH,6BAAA;ADkuCD;ADjpCE;EACC,wCAAA;ACmpCH;ADhpCE;EACC,4CAAA;ACkpCH;ADzqCE;EACC,sCAAA;AC2qCH;ADzqCG;EACC,8CAAA;EEnEH,6BAAA;AD+uCD;ADvqCE;EACC,kDAAA;ACyqCH;ADvqCG;EACC,0DAAA;EE5EH,6BAAA;ADsvCD;ADrqCE;EACC,wCAAA;ACuqCH;ADpqCE;EACC,4CAAA;ACsqCH;AD7rCE;EACC,sCAAA;AC+rCH;AD7rCG;EACC,8CAAA;EEnEH,6BAAA;ADmwCD;AD3rCE;EACC,kDAAA;AC6rCH;AD3rCG;EACC,0DAAA;EE5EH,6BAAA;AD0wCD;ADzrCE;EACC,wCAAA;AC2rCH;ADxrCE;EACC,4CAAA;AC0rCH;ADjtCE;EACC,sCAAA;ACmtCH;ADjtCG;EACC,8CAAA;EEnEH,6BAAA;ADuxCD;AD/sCE;EACC,kDAAA;ACitCH;AD/sCG;EACC,0DAAA;EE5EH,6BAAA;AD8xCD;AD7sCE;EACC,wCAAA;AC+sCH;AD5sCE;EACC,4CAAA;AC8sCH;ADruCE;EACC,sCAAA;ACuuCH;ADruCG;EACC,8CAAA;EEnEH,6BAAA;AD2yCD;ADnuCE;EACC,kDAAA;ACquCH;ADnuCG;EACC,0DAAA;EE5EH,6BAAA;ADkzCD;ADjuCE;EACC,wCAAA;ACmuCH;ADhuCE;EACC,4CAAA;ACkuCH;ADzvCE;EACC,sCAAA;AC2vCH;ADzvCG;EACC,8CAAA;EEnEH,6BAAA;AD+zCD;ADvvCE;EACC,kDAAA;ACyvCH;ADvvCG;EACC,0DAAA;EE5EH,6BAAA;ADs0CD;ADrvCE;EACC,wCAAA;ACuvCH;ADpvCE;EACC,4CAAA;ACsvCH;AD7wCE;EACC,sCAAA;AC+wCH;AD7wCG;EACC,8CAAA;EEnEH,6BAAA;ADm1CD;AD3wCE;EACC,kDAAA;AC6wCH;AD3wCG;EACC,0DAAA;EE5EH,6BAAA;AD01CD;ADzwCE;EACC,wCAAA;AC2wCH;ADxwCE;EACC,4CAAA;AC0wCH;ADjyCE;EACC,sCAAA;ACmyCH;ADjyCG;EACC,8CAAA;EEnEH,6BAAA;ADu2CD;AD/xCE;EACC,kDAAA;ACiyCH;AD/xCG;EACC,0DAAA;EE5EH,6BAAA;AD82CD;AD7xCE;EACC,wCAAA;AC+xCH;AD5xCE;EACC,4CAAA;AC8xCH;ADrzCE;EACC,sCAAA;ACuzCH;ADrzCG;EACC,8CAAA;EEnEH,6BAAA;AD23CD;ADnzCE;EACC,kDAAA;ACqzCH;ADnzCG;EACC,0DAAA;EE5EH,6BAAA;ADk4CD;ADjzCE;EACC,wCAAA;ACmzCH;ADhzCE;EACC,4CAAA;ACkzCH;ADz0CE;EACC,sCAAA;AC20CH;ADz0CG;EACC,8CAAA;EEnEH,6BAAA;AD+4CD;ADv0CE;EACC,kDAAA;ACy0CH;ADv0CG;EACC,0DAAA;EE5EH,6BAAA;ADs5CD;ADr0CE;EACC,wCAAA;ACu0CH;ADp0CE;EACC,4CAAA;ACs0CH;AD71CE;EACC,sCAAA;AC+1CH;AD71CG;EACC,8CAAA;EEnEH,6BAAA;ADm6CD;AD31CE;EACC,kDAAA;AC61CH;AD31CG;EACC,0DAAA;EE5EH,6BAAA;AD06CD;ADz1CE;EACC,wCAAA;AC21CH;ADx1CE;EACC,4CAAA;AC01CH;ADj3CE;EACC,sCAAA;ACm3CH;ADj3CG;EACC,8CAAA;EEnEH,6BAAA;ADu7CD;AD/2CE;EACC,kDAAA;ACi3CH;AD/2CG;EACC,0DAAA;EE5EH,6BAAA;AD87CD;AD72CE;EACC,wCAAA;AC+2CH;AD52CE;EACC,4CAAA;AC82CH;ADr4CE;EACC,sCAAA;ACu4CH;ADr4CG;EACC,8CAAA;EEnEH,6BAAA;AD28CD;ADn4CE;EACC,kDAAA;ACq4CH;ADn4CG;EACC,0DAAA;EE5EH,6BAAA;ADk9CD;ADj4CE;EACC,wCAAA;ACm4CH;ADh4CE;EACC,4CAAA;ACk4CH;ADz5CE;EACC,sCAAA;AC25CH;ADz5CG;EACC,8CAAA;EEnEH,6BAAA;AD+9CD;ADv5CE;EACC,kDAAA;ACy5CH;ADv5CG;EACC,0DAAA;EE5EH,6BAAA;ADs+CD;ADr5CE;EACC,wCAAA;ACu5CH;ADp5CE;EACC,4CAAA;ACs5CH;AD76CE;EACC,sCAAA;AC+6CH;AD76CG;EACC,8CAAA;EEnEH,6BAAA;ADm/CD;AD36CE;EACC,kDAAA;AC66CH;AD36CG;EACC,0DAAA;EE5EH,6BAAA;AD0/CD;ADz6CE;EACC,wCAAA;AC26CH;ADx6CE;EACC,4CAAA;AC06CH;ADj8CE;EACC,sCAAA;ACm8CH;ADj8CG;EACC,8CAAA;EEnEH,6BAAA;ADugDD;AD/7CE;EACC,kDAAA;ACi8CH;AD/7CG;EACC,0DAAA;EE5EH,6BAAA;AD8gDD;AD77CE;EACC,wCAAA;AC+7CH;AD57CE;EACC,4CAAA;AC87CH;ADr9CE;EACC,sCAAA;ACu9CH;ADr9CG;EACC,8CAAA;EEnEH,6BAAA;AD2hDD;ADn9CE;EACC,kDAAA;ACq9CH;ADn9CG;EACC,0DAAA;EE5EH,6BAAA;ADkiDD;ADj9CE;EACC,wCAAA;ACm9CH;ADh9CE;EACC,4CAAA;ACk9CH;ADz+CE;EACC,sCAAA;AC2+CH;ADz+CG;EACC,8CAAA;EEnEH,6BAAA;AD+iDD;ADv+CE;EACC,kDAAA;ACy+CH;ADv+CG;EACC,0DAAA;EE5EH,6BAAA;ADsjDD;ADr+CE;EACC,wCAAA;ACu+CH;ADp+CE;EACC,4CAAA;ACs+CH;AD7/CE;EACC,uCAAA;AC+/CH;AD7/CG;EACC,+CAAA;EEnEH,6BAAA;ADmkDD;AD3/CE;EACC,mDAAA;AC6/CH;AD3/CG;EACC,2DAAA;EE5EH,6BAAA;AD0kDD;ADz/CE;EACC,yCAAA;AC2/CH;ADx/CE;EACC,6CAAA;AC0/CH;ADjhDE;EACC,uCAAA;ACmhDH;ADjhDG;EACC,+CAAA;EEnEH,6BAAA;ADulDD;AD/gDE;EACC,mDAAA;ACihDH;AD/gDG;EACC,2DAAA;EE5EH,6BAAA;AD8lDD;AD7gDE;EACC,yCAAA;AC+gDH;AD5gDE;EACC,6CAAA;AC8gDH;ADriDE;EACC,uCAAA;ACuiDH;ADriDG;EACC,+CAAA;EEnEH,6BAAA;AD2mDD;ADniDE;EACC,mDAAA;ACqiDH;ADniDG;EACC,2DAAA;EE5EH,6BAAA;ADknDD;ADjiDE;EACC,yCAAA;ACmiDH;ADhiDE;EACC,6CAAA;ACkiDH;ADzjDE;EACC,uCAAA;AC2jDH;ADzjDG;EACC,+CAAA;EEnEH,6BAAA;AD+nDD;ADvjDE;EACC,mDAAA;ACyjDH;ADvjDG;EACC,2DAAA;EE5EH,6BAAA;ADsoDD;ADrjDE;EACC,yCAAA;ACujDH;ADpjDE;EACC,6CAAA;ACsjDH;AD7kDE;EACC,uCAAA;AC+kDH;AD7kDG;EACC,+CAAA;EEnEH,6BAAA;ADmpDD;AD3kDE;EACC,mDAAA;AC6kDH;AD3kDG;EACC,2DAAA;EE5EH,6BAAA;AD0pDD;ADzkDE;EACC,yCAAA;AC2kDH;ADxkDE;EACC,6CAAA;AC0kDH;ADjmDE;EACC,uCAAA;ACmmDH;ADjmDG;EACC,+CAAA;EEnEH,6BAAA;ADuqDD;AD/lDE;EACC,mDAAA;ACimDH;AD/lDG;EACC,2DAAA;EE5EH,6BAAA;AD8qDD;AD7lDE;EACC,yCAAA;AC+lDH;AD5lDE;EACC,6CAAA;AC8lDH;ADrnDE;EACC,uCAAA;ACunDH;ADrnDG;EACC,+CAAA;EEnEH,6BAAA;AD2rDD;ADnnDE;EACC,mDAAA;ACqnDH;ADnnDG;EACC,2DAAA;EE5EH,6BAAA;ADksDD;ADjnDE;EACC,yCAAA;ACmnDH;ADhnDE;EACC,6CAAA;ACknDH;ADzoDE;EACC,uCAAA;AC2oDH;ADzoDG;EACC,+CAAA;EEnEH,6BAAA;AD+sDD;ADvoDE;EACC,mDAAA;ACyoDH;ADvoDG;EACC,2DAAA;EE5EH,6BAAA;ADstDD;ADroDE;EACC,yCAAA;ACuoDH;ADpoDE;EACC,6CAAA;ACsoDH;AD7pDE;EACC,uCAAA;AC+pDH;AD7pDG;EACC,+CAAA;EEnEH,6BAAA;ADmuDD;AD3pDE;EACC,mDAAA;AC6pDH;AD3pDG;EACC,2DAAA;EE5EH,6BAAA;AD0uDD;ADzpDE;EACC,yCAAA;AC2pDH;ADxpDE;EACC,6CAAA;AC0pDH;ADjrDE;EACC,wCAAA;ACmrDH;ADjrDG;EACC,gDAAA;EEnEH,6BAAA;ADuvDD;AD/qDE;EACC,oDAAA;ACirDH;AD/qDG;EACC,4DAAA;EE5EH,6BAAA;AD8vDD;AD7qDE;EACC,0CAAA;AC+qDH;AD5qDE;EACC,8CAAA;AC8qDH;ADrsDE;EACC,wCAAA;ACusDH;ADrsDG;EACC,gDAAA;EEnEH,6BAAA;AD2wDD;ADnsDE;EACC,oDAAA;ACqsDH;ADnsDG;EACC,4DAAA;EE5EH,6BAAA;ADkxDD;ADjsDE;EACC,0CAAA;ACmsDH;ADhsDE;EACC,8CAAA;ACksDH;ADztDE;EACC,wCAAA;AC2tDH;ADztDG;EACC,gDAAA;EEnEH,6BAAA;AD+xDD;ADvtDE;EACC,oDAAA;ACytDH;ADvtDG;EACC,4DAAA;EE5EH,6BAAA;ADsyDD;ADrtDE;EACC,0CAAA;ACutDH;ADptDE;EACC,8CAAA;ACstDH;AD7uDE;EACC,wCAAA;AC+uDH;AD7uDG;EACC,gDAAA;EEnEH,6BAAA;ADmzDD;AD3uDE;EACC,oDAAA;AC6uDH;AD3uDG;EACC,4DAAA;EE5EH,6BAAA;AD0zDD;ADzuDE;EACC,0CAAA;AC2uDH;ADxuDE;EACC,8CAAA;AC0uDH;ADjwDE;EACC,wCAAA;ACmwDH;ADjwDG;EACC,gDAAA;EEnEH,6BAAA;ADu0DD;AD/vDE;EACC,oDAAA;ACiwDH;AD/vDG;EACC,4DAAA;EE5EH,6BAAA;AD80DD;AD7vDE;EACC,0CAAA;AC+vDH;AD5vDE;EACC,8CAAA;AC8vDH;ADrxDE;EACC,yCAAA;ACuxDH;ADrxDG;EACC,iDAAA;EEnEH,6BAAA;AD21DD;ADnxDE;EACC,qDAAA;ACqxDH;ADnxDG;EACC,6DAAA;EE5EH,6BAAA;ADk2DD;ADjxDE;EACC,2CAAA;ACmxDH;ADhxDE;EACC,+CAAA;ACkxDH;ADzyDE;EACC,yCAAA;AC2yDH;ADzyDG;EACC,iDAAA;EEnEH,6BAAA;AD+2DD;ADvyDE;EACC,qDAAA;ACyyDH;ADvyDG;EACC,6DAAA;EE5EH,6BAAA;ADs3DD;ADryDE;EACC,2CAAA;ACuyDH;ADpyDE;EACC,+CAAA;ACsyDH;AD7zDE;EACC,yCAAA;AC+zDH;AD7zDG;EACC,iDAAA;EEnEH,6BAAA;ADm4DD;AD3zDE;EACC,qDAAA;AC6zDH;AD3zDG;EACC,6DAAA;EE5EH,6BAAA;AD04DD;ADzzDE;EACC,2CAAA;AC2zDH;ADxzDE;EACC,+CAAA;AC0zDH;ADj1DE;EACC,yCAAA;ACm1DH;ADj1DG;EACC,iDAAA;EEnEH,6BAAA;ADu5DD;AD/0DE;EACC,qDAAA;ACi1DH;AD/0DG;EACC,6DAAA;EE5EH,6BAAA;AD85DD;AD70DE;EACC,2CAAA;AC+0DH;AD50DE;EACC,+CAAA;AC80DH;ADr2DE;EACC,yCAAA;ACu2DH;ADr2DG;EACC,iDAAA;EEnEH,6BAAA;AD26DD;ADn2DE;EACC,qDAAA;ACq2DH;ADn2DG;EACC,6DAAA;EE5EH,6BAAA;ADk7DD;ADj2DE;EACC,2CAAA;ACm2DH;ADh2DE;EACC,+CAAA;ACk2DH;ADz3DE;EACC,yCAAA;AC23DH;ADz3DG;EACC,iDAAA;EEnEH,6BAAA;AD+7DD;ADv3DE;EACC,qDAAA;ACy3DH;ADv3DG;EACC,6DAAA;EE5EH,6BAAA;ADs8DD;ADr3DE;EACC,2CAAA;ACu3DH;ADp3DE;EACC,+CAAA;ACs3DH;AD74DE;EACC,yCAAA;AC+4DH;AD74DG;EACC,iDAAA;EEnEH,6BAAA;ADm9DD;AD34DE;EACC,qDAAA;AC64DH;AD34DG;EACC,6DAAA;EE5EH,6BAAA;AD09DD;ADz4DE;EACC,2CAAA;AC24DH;ADx4DE;EACC,+CAAA;AC04DH;ADj6DE;EACC,yCAAA;ACm6DH;ADj6DG;EACC,iDAAA;EEnEH,6BAAA;ADu+DD;AD/5DE;EACC,qDAAA;ACi6DH;AD/5DG;EACC,6DAAA;EE5EH,6BAAA;AD8+DD;AD75DE;EACC,2CAAA;AC+5DH;AD55DE;EACC,+CAAA;AC85DH;ADr7DE;EACC,yCAAA;ACu7DH;ADr7DG;EACC,iDAAA;EEnEH,6BAAA;AD2/DD;ADn7DE;EACC,qDAAA;ACq7DH;ADn7DG;EACC,6DAAA;EE5EH,6BAAA;ADkgED;ADj7DE;EACC,2CAAA;ACm7DH;ADh7DE;EACC,+CAAA;ACk7DH;ADz8DE;EACC,0CAAA;AC28DH;ADz8DG;EACC,kDAAA;EEnEH,6BAAA;AD+gED;ADv8DE;EACC,sDAAA;ACy8DH;ADv8DG;EACC,8DAAA;EE5EH,6BAAA;ADshED;ADr8DE;EACC,4CAAA;ACu8DH;ADp8DE;EACC,gDAAA;ACs8DH;AD79DE;EACC,0CAAA;AC+9DH;AD79DG;EACC,kDAAA;EEnEH,6BAAA;ADmiED;AD39DE;EACC,sDAAA;AC69DH;AD39DG;EACC,8DAAA;EE5EH,6BAAA;AD0iED;ADz9DE;EACC,4CAAA;AC29DH;ADx9DE;EACC,gDAAA;AC09DH;ADj/DE;EACC,yCAAA;ACm/DH;ADj/DG;EACC,iDAAA;EEnEH,6BAAA;ADujED;AD/+DE;EACC,qDAAA;ACi/DH;AD/+DG;EACC,6DAAA;EE5EH,6BAAA;AD8jED;AD7+DE;EACC,2CAAA;AC++DH;AD5+DE;EACC,+CAAA;AC8+DH;ADrgEE;EACC,yCAAA;ACugEH;ADrgEG;EACC,iDAAA;EEnEH,6BAAA;AD2kED;ADngEE;EACC,qDAAA;ACqgEH;ADngEG;EACC,6DAAA;EE5EH,6BAAA;ADklED;ADjgEE;EACC,2CAAA;ACmgEH;ADhgEE;EACC,+CAAA;ACkgEH;ADzhEE;EACC,yCAAA;AC2hEH;ADzhEG;EACC,iDAAA;EEnEH,6BAAA;AD+lED;ADvhEE;EACC,qDAAA;ACyhEH;ADvhEG;EACC,6DAAA;EE5EH,6BAAA;ADsmED;ADrhEE;EACC,2CAAA;ACuhEH;ADphEE;EACC,+CAAA;ACshEH;AD7iEE;EACC,yCAAA;AC+iEH;AD7iEG;EACC,iDAAA;EEnEH,6BAAA;ADmnED;AD3iEE;EACC,qDAAA;AC6iEH;AD3iEG;EACC,6DAAA;EE5EH,6BAAA;AD0nED;ADziEE;EACC,2CAAA;AC2iEH;ADxiEE;EACC,+CAAA;AC0iEH;ADjkEE;EACC,yCAAA;ACmkEH;ADjkEG;EACC,iDAAA;EEnEH,6BAAA;ADuoED;AD/jEE;EACC,qDAAA;ACikEH;AD/jEG;EACC,6DAAA;EE5EH,6BAAA;AD8oED;AD7jEE;EACC,2CAAA;AC+jEH;AD5jEE;EACC,+CAAA;AC8jEH;ADrlEE;EACC,yCAAA;ACulEH;ADrlEG;EACC,iDAAA;EEnEH,6BAAA;AD2pED;ADnlEE;EACC,qDAAA;ACqlEH;ADnlEG;EACC,6DAAA;EE5EH,6BAAA;ADkqED;ADjlEE;EACC,2CAAA;ACmlEH;ADhlEE;EACC,+CAAA;ACklEH;ADzmEE;EACC,yCAAA;AC2mEH;ADzmEG;EACC,iDAAA;EEnEH,6BAAA;AD+qED;ADvmEE;EACC,qDAAA;ACymEH;ADvmEG;EACC,6DAAA;EE5EH,6BAAA;ADsrED;ADrmEE;EACC,2CAAA;ACumEH;ADpmEE;EACC,+CAAA;ACsmEH;AD7nEE;EACC,yCAAA;AC+nEH;AD7nEG;EACC,iDAAA;EEnEH,6BAAA;ADmsED;AD3nEE;EACC,qDAAA;AC6nEH;AD3nEG;EACC,6DAAA;EE5EH,6BAAA;AD0sED;ADznEE;EACC,2CAAA;AC2nEH;ADxnEE;EACC,+CAAA;AC0nEH;ADjpEE;EACC,yCAAA;ACmpEH;ADjpEG;EACC,iDAAA;EEnEH,6BAAA;ADutED;AD/oEE;EACC,qDAAA;ACipEH;AD/oEG;EACC,6DAAA;EE5EH,6BAAA;AD8tED;AD7oEE;EACC,2CAAA;AC+oEH;AD5oEE;EACC,+CAAA;AC8oEH;ADrqEE;EACC,0CAAA;ACuqEH;ADrqEG;EACC,kDAAA;EEnEH,6BAAA;AD2uED;ADnqEE;EACC,sDAAA;ACqqEH;ADnqEG;EACC,8DAAA;EE5EH,6BAAA;ADkvED;ADjqEE;EACC,4CAAA;ACmqEH;ADhqEE;EACC,gDAAA;ACkqEH;ADzrEE;EACC,0CAAA;AC2rEH;ADzrEG;EACC,kDAAA;EEnEH,6BAAA;AD+vED;ADvrEE;EACC,sDAAA;ACyrEH;ADvrEG;EACC,8DAAA;EE5EH,6BAAA;ADswED;ADrrEE;EACC,4CAAA;ACurEH;ADprEE;EACC,gDAAA;ACsrEH;AD7sEE;EACC,yCAAA;AC+sEH;AD7sEG;EACC,iDAAA;EEnEH,6BAAA;ADmxED;AD3sEE;EACC,qDAAA;AC6sEH;AD3sEG;EACC,6DAAA;EE5EH,6BAAA;AD0xED;ADzsEE;EACC,2CAAA;AC2sEH;ADxsEE;EACC,+CAAA;AC0sEH;ADjuEE;EACC,yCAAA;ACmuEH;ADjuEG;EACC,iDAAA;EEnEH,6BAAA;ADuyED;AD/tEE;EACC,qDAAA;ACiuEH;AD/tEG;EACC,6DAAA;EE5EH,6BAAA;AD8yED;AD7tEE;EACC,2CAAA;AC+tEH;AD5tEE;EACC,+CAAA;AC8tEH;ADrvEE;EACC,yCAAA;ACuvEH;ADrvEG;EACC,iDAAA;EEnEH,6BAAA;AD2zED;ADnvEE;EACC,qDAAA;ACqvEH;ADnvEG;EACC,6DAAA;EE5EH,6BAAA;ADk0ED;ADjvEE;EACC,2CAAA;ACmvEH;ADhvEE;EACC,+CAAA;ACkvEH;ADzwEE;EACC,yCAAA;AC2wEH;ADzwEG;EACC,iDAAA;EEnEH,6BAAA;AD+0ED;ADvwEE;EACC,qDAAA;ACywEH;ADvwEG;EACC,6DAAA;EE5EH,6BAAA;ADs1ED;ADrwEE;EACC,2CAAA;ACuwEH;ADpwEE;EACC,+CAAA;ACswEH;AD7xEE;EACC,yCAAA;AC+xEH;AD7xEG;EACC,iDAAA;EEnEH,6BAAA;ADm2ED;AD3xEE;EACC,qDAAA;AC6xEH;AD3xEG;EACC,6DAAA;EE5EH,6BAAA;AD02ED;ADzxEE;EACC,2CAAA;AC2xEH;ADxxEE;EACC,+CAAA;AC0xEH;ADjzEE;EACC,yCAAA;ACmzEH;ADjzEG;EACC,iDAAA;EEnEH,6BAAA;ADu3ED;AD/yEE;EACC,qDAAA;ACizEH;AD/yEG;EACC,6DAAA;EE5EH,6BAAA;AD83ED;AD7yEE;EACC,2CAAA;AC+yEH;AD5yEE;EACC,+CAAA;AC8yEH;ADr0EE;EACC,yCAAA;ACu0EH;ADr0EG;EACC,iDAAA;EEnEH,6BAAA;AD24ED;ADn0EE;EACC,qDAAA;ACq0EH;ADn0EG;EACC,6DAAA;EE5EH,6BAAA;ADk5ED;ADj0EE;EACC,2CAAA;ACm0EH;ADh0EE;EACC,+CAAA;ACk0EH;ADz1EE;EACC,yCAAA;AC21EH;ADz1EG;EACC,iDAAA;EEnEH,6BAAA;AD+5ED;ADv1EE;EACC,qDAAA;ACy1EH;ADv1EG;EACC,6DAAA;EE5EH,6BAAA;ADs6ED;ADr1EE;EACC,2CAAA;ACu1EH;ADp1EE;EACC,+CAAA;ACs1EH;AD72EE;EACC,yCAAA;AC+2EH;AD72EG;EACC,iDAAA;EEnEH,6BAAA;ADm7ED;AD32EE;EACC,qDAAA;AC62EH;AD32EG;EACC,6DAAA;EE5EH,6BAAA;AD07ED;ADz2EE;EACC,2CAAA;AC22EH;ADx2EE;EACC,+CAAA;AC02EH;ADj4EE;EACC,0CAAA;ACm4EH;ADj4EG;EACC,kDAAA;EEnEH,6BAAA;ADu8ED;AD/3EE;EACC,sDAAA;ACi4EH;AD/3EG;EACC,8DAAA;EE5EH,6BAAA;AD88ED;AD73EE;EACC,4CAAA;AC+3EH;AD53EE;EACC,gDAAA;AC83EH;ADr5EE;EACC,0CAAA;ACu5EH;ADr5EG;EACC,kDAAA;EEnEH,6BAAA;AD29ED;ADn5EE;EACC,sDAAA;ACq5EH;ADn5EG;EACC,8DAAA;EE5EH,6BAAA;ADk+ED;ADj5EE;EACC,4CAAA;ACm5EH;ADh5EE;EACC,gDAAA;ACk5EH;ADz6EE;EACC,yCAAA;AC26EH;ADz6EG;EACC,iDAAA;EEnEH,6BAAA;AD++ED;ADv6EE;EACC,qDAAA;ACy6EH;ADv6EG;EACC,6DAAA;EE5EH,6BAAA;ADs/ED;ADr6EE;EACC,2CAAA;ACu6EH;ADp6EE;EACC,+CAAA;ACs6EH;AD77EE;EACC,yCAAA;AC+7EH;AD77EG;EACC,iDAAA;EEnEH,6BAAA;ADmgFD;AD37EE;EACC,qDAAA;AC67EH;AD37EG;EACC,6DAAA;EE5EH,6BAAA;AD0gFD;ADz7EE;EACC,2CAAA;AC27EH;ADx7EE;EACC,+CAAA;AC07EH;ADj9EE;EACC,yCAAA;ACm9EH;ADj9EG;EACC,iDAAA;EEnEH,6BAAA;ADuhFD;AD/8EE;EACC,qDAAA;ACi9EH;AD/8EG;EACC,6DAAA;EE5EH,6BAAA;AD8hFD;AD78EE;EACC,2CAAA;AC+8EH;AD58EE;EACC,+CAAA;AC88EH;ADr+EE;EACC,yCAAA;ACu+EH;ADr+EG;EACC,iDAAA;EEnEH,6BAAA;AD2iFD;ADn+EE;EACC,qDAAA;ACq+EH;ADn+EG;EACC,6DAAA;EE5EH,6BAAA;ADkjFD;ADj+EE;EACC,2CAAA;ACm+EH;ADh+EE;EACC,+CAAA;ACk+EH;ADz/EE;EACC,yCAAA;AC2/EH;ADz/EG;EACC,iDAAA;EEnEH,6BAAA;AD+jFD;ADv/EE;EACC,qDAAA;ACy/EH;ADv/EG;EACC,6DAAA;EE5EH,6BAAA;ADskFD;ADr/EE;EACC,2CAAA;ACu/EH;ADp/EE;EACC,+CAAA;ACs/EH;AD7gFE;EACC,yCAAA;AC+gFH;AD7gFG;EACC,iDAAA;EEnEH,6BAAA;ADmlFD;AD3gFE;EACC,qDAAA;AC6gFH;AD3gFG;EACC,6DAAA;EE5EH,6BAAA;AD0lFD;ADzgFE;EACC,2CAAA;AC2gFH;ADxgFE;EACC,+CAAA;AC0gFH;ADjiFE;EACC,yCAAA;ACmiFH;ADjiFG;EACC,iDAAA;EEnEH,6BAAA;ADumFD;AD/hFE;EACC,qDAAA;ACiiFH;AD/hFG;EACC,6DAAA;EE5EH,6BAAA;AD8mFD;AD7hFE;EACC,2CAAA;AC+hFH;AD5hFE;EACC,+CAAA;AC8hFH;ADrjFE;EACC,yCAAA;ACujFH;ADrjFG;EACC,iDAAA;EEnEH,6BAAA;AD2nFD;ADnjFE;EACC,qDAAA;ACqjFH;ADnjFG;EACC,6DAAA;EE5EH,6BAAA;ADkoFD;ADjjFE;EACC,2CAAA;ACmjFH;ADhjFE;EACC,+CAAA;ACkjFH;ADzkFE;EACC,yCAAA;AC2kFH;ADzkFG;EACC,iDAAA;EEnEH,6BAAA;AD+oFD;ADvkFE;EACC,qDAAA;ACykFH;ADvkFG;EACC,6DAAA;EE5EH,6BAAA;ADspFD;ADrkFE;EACC,2CAAA;ACukFH;ADpkFE;EACC,+CAAA;ACskFH;AD7lFE;EACC,0CAAA;AC+lFH;AD7lFG;EACC,kDAAA;EEnEH,6BAAA;ADmqFD;AD3lFE;EACC,sDAAA;AC6lFH;AD3lFG;EACC,8DAAA;EE5EH,6BAAA;AD0qFD;ADzlFE;EACC,4CAAA;AC2lFH;ADxlFE;EACC,gDAAA;AC0lFH;ADjnFE;EACC,0CAAA;ACmnFH;ADjnFG;EACC,kDAAA;EEnEH,6BAAA;ADurFD;AD/mFE;EACC,sDAAA;ACinFH;AD/mFG;EACC,8DAAA;EE5EH,6BAAA;AD8rFD;AD7mFE;EACC,4CAAA;AC+mFH;AD5mFE;EACC,gDAAA;AC8mFH;ADroFE;EACC,4CAAA;ACuoFH;ADroFG;EACC,oDAAA;EEnEH,6BAAA;AD2sFD;ADnoFE;EACC,wDAAA;ACqoFH;ADnoFG;EACC,gEAAA;EE5EH,6BAAA;ADktFD;ADjoFE;EACC,8CAAA;ACmoFH;ADhoFE;EACC,kDAAA;ACkoFH;ADzpFE;EACC,4CAAA;AC2pFH;ADzpFG;EACC,oDAAA;EEnEH,6BAAA;AD+tFD;ADvpFE;EACC,wDAAA;ACypFH;ADvpFG;EACC,gEAAA;EE5EH,6BAAA;ADsuFD;ADrpFE;EACC,8CAAA;ACupFH;ADppFE;EACC,kDAAA;ACspFH;AD7qFE;EACC,4CAAA;AC+qFH;AD7qFG;EACC,oDAAA;EEnEH,6BAAA;ADmvFD;AD3qFE;EACC,wDAAA;AC6qFH;AD3qFG;EACC,gEAAA;EE5EH,6BAAA;AD0vFD;ADzqFE;EACC,8CAAA;AC2qFH;ADxqFE;EACC,kDAAA;AC0qFH;ADjsFE;EACC,4CAAA;ACmsFH;ADjsFG;EACC,oDAAA;EEnEH,6BAAA;ADuwFD;AD/rFE;EACC,wDAAA;ACisFH;AD/rFG;EACC,gEAAA;EE5EH,6BAAA;AD8wFD;AD7rFE;EACC,8CAAA;AC+rFH;AD5rFE;EACC,kDAAA;AC8rFH;ADrtFE;EACC,4CAAA;ACutFH;ADrtFG;EACC,oDAAA;EEnEH,6BAAA;AD2xFD;ADntFE;EACC,wDAAA;ACqtFH;ADntFG;EACC,gEAAA;EE5EH,6BAAA;ADkyFD;ADjtFE;EACC,8CAAA;ACmtFH;ADhtFE;EACC,kDAAA;ACktFH;ADzuFE;EACC,4CAAA;AC2uFH;ADzuFG;EACC,oDAAA;EEnEH,6BAAA;AD+yFD;ADvuFE;EACC,wDAAA;ACyuFH;ADvuFG;EACC,gEAAA;EE5EH,6BAAA;ADszFD;ADruFE;EACC,8CAAA;ACuuFH;ADpuFE;EACC,kDAAA;ACsuFH;AD7vFE;EACC,4CAAA;AC+vFH;AD7vFG;EACC,oDAAA;EEnEH,6BAAA;ADm0FD;AD3vFE;EACC,wDAAA;AC6vFH;AD3vFG;EACC,gEAAA;EE5EH,6BAAA;AD00FD;ADzvFE;EACC,8CAAA;AC2vFH;ADxvFE;EACC,kDAAA;AC0vFH;ADjxFE;EACC,4CAAA;ACmxFH;ADjxFG;EACC,oDAAA;EEnEH,6BAAA;ADu1FD;AD/wFE;EACC,wDAAA;ACixFH;AD/wFG;EACC,gEAAA;EE5EH,6BAAA;AD81FD;AD7wFE;EACC,8CAAA;AC+wFH;AD5wFE;EACC,kDAAA;AC8wFH;ADryFE;EACC,4CAAA;ACuyFH;ADryFG;EACC,oDAAA;EEnEH,6BAAA;AD22FD;ADnyFE;EACC,wDAAA;ACqyFH;ADnyFG;EACC,gEAAA;EE5EH,6BAAA;ADk3FD;ADjyFE;EACC,8CAAA;ACmyFH;ADhyFE;EACC,kDAAA;ACkyFH;ADzzFE;EACC,6CAAA;AC2zFH;ADzzFG;EACC,qDAAA;EEnEH,6BAAA;AD+3FD;ADvzFE;EACC,yDAAA;ACyzFH;ADvzFG;EACC,iEAAA;EE5EH,6BAAA;ADs4FD;ADrzFE;EACC,+CAAA;ACuzFH;ADpzFE;EACC,mDAAA;ACszFH;AD70FE;EACC,6CAAA;AC+0FH;AD70FG;EACC,qDAAA;EEnEH,6BAAA;ADm5FD;AD30FE;EACC,yDAAA;AC60FH;AD30FG;EACC,iEAAA;EE5EH,6BAAA;AD05FD;ADz0FE;EACC,+CAAA;AC20FH;ADx0FE;EACC,mDAAA;AC00FH;ADj2FE;EACC,6CAAA;ACm2FH;ADj2FG;EACC,qDAAA;EEnEH,6BAAA;ADu6FD;AD/1FE;EACC,yDAAA;ACi2FH;AD/1FG;EACC,iEAAA;EE5EH,6BAAA;AD86FD;AD71FE;EACC,+CAAA;AC+1FH;AD51FE;EACC,mDAAA;AC81FH;ADr3FE;EACC,6CAAA;ACu3FH;ADr3FG;EACC,qDAAA;EEnEH,6BAAA;AD27FD;ADn3FE;EACC,yDAAA;ACq3FH;ADn3FG;EACC,iEAAA;EE5EH,6BAAA;ADk8FD;ADj3FE;EACC,+CAAA;ACm3FH;ADh3FE;EACC,mDAAA;ACk3FH;ADz4FE;EACC,6CAAA;AC24FH;ADz4FG;EACC,qDAAA;EEnEH,6BAAA;AD+8FD;ADv4FE;EACC,yDAAA;ACy4FH;ADv4FG;EACC,iEAAA;EE5EH,6BAAA;ADs9FD;ADr4FE;EACC,+CAAA;ACu4FH;ADp4FE;EACC,mDAAA;ACs4FH;AD75FE;EACC,6CAAA;AC+5FH;AD75FG;EACC,qDAAA;EEnEH,6BAAA;ADm+FD;AD35FE;EACC,yDAAA;AC65FH;AD35FG;EACC,iEAAA;EE5EH,6BAAA;AD0+FD;ADz5FE;EACC,+CAAA;AC25FH;ADx5FE;EACC,mDAAA;AC05FH;ADj7FE;EACC,6CAAA;ACm7FH;ADj7FG;EACC,qDAAA;EEnEH,6BAAA;ADu/FD;AD/6FE;EACC,yDAAA;ACi7FH;AD/6FG;EACC,iEAAA;EE5EH,6BAAA;AD8/FD;AD76FE;EACC,+CAAA;AC+6FH;AD56FE;EACC,mDAAA;AC86FH;ADr8FE;EACC,6CAAA;ACu8FH;ADr8FG;EACC,qDAAA;EEnEH,6BAAA;AD2gGD;ADn8FE;EACC,yDAAA;ACq8FH;ADn8FG;EACC,iEAAA;EE5EH,6BAAA;ADkhGD;ADj8FE;EACC,+CAAA;ACm8FH;ADh8FE;EACC,mDAAA;ACk8FH;ADz9FE;EACC,4CAAA;AC29FH;ADz9FG;EACC,oDAAA;EEnEH,6BAAA;AD+hGD;ADv9FE;EACC,wDAAA;ACy9FH;ADv9FG;EACC,gEAAA;EE5EH,6BAAA;ADsiGD;ADr9FE;EACC,8CAAA;ACu9FH;ADp9FE;EACC,kDAAA;ACs9FH;AD7+FE;EACC,4CAAA;AC++FH;AD7+FG;EACC,oDAAA;EEnEH,6BAAA;ADmjGD;AD3+FE;EACC,wDAAA;AC6+FH;AD3+FG;EACC,gEAAA;EE5EH,6BAAA;AD0jGD;ADz+FE;EACC,8CAAA;AC2+FH;ADx+FE;EACC,kDAAA;AC0+FH;ADjgGE;EACC,4CAAA;ACmgGH;ADjgGG;EACC,oDAAA;EEnEH,6BAAA;ADukGD;AD//FE;EACC,wDAAA;ACigGH;AD//FG;EACC,gEAAA;EE5EH,6BAAA;AD8kGD;AD7/FE;EACC,8CAAA;AC+/FH;AD5/FE;EACC,kDAAA;AC8/FH;ADrhGE;EACC,4CAAA;ACuhGH;ADrhGG;EACC,oDAAA;EEnEH,6BAAA;AD2lGD;ADnhGE;EACC,wDAAA;ACqhGH;ADnhGG;EACC,gEAAA;EE5EH,6BAAA;ADkmGD;ADjhGE;EACC,8CAAA;ACmhGH;ADhhGE;EACC,kDAAA;ACkhGH;ADziGE;EACC,4CAAA;AC2iGH;ADziGG;EACC,oDAAA;EEnEH,6BAAA;AD+mGD;ADviGE;EACC,wDAAA;ACyiGH;ADviGG;EACC,gEAAA;EE5EH,6BAAA;ADsnGD;ADriGE;EACC,8CAAA;ACuiGH;ADpiGE;EACC,kDAAA;ACsiGH;AD7jGE;EACC,4CAAA;AC+jGH;AD7jGG;EACC,oDAAA;EEnEH,6BAAA;ADmoGD;AD3jGE;EACC,wDAAA;AC6jGH;AD3jGG;EACC,gEAAA;EE5EH,6BAAA;AD0oGD;ADzjGE;EACC,8CAAA;AC2jGH;ADxjGE;EACC,kDAAA;AC0jGH;ADjlGE;EACC,4CAAA;ACmlGH;ADjlGG;EACC,oDAAA;EEnEH,6BAAA;ADupGD;AD/kGE;EACC,wDAAA;ACilGH;AD/kGG;EACC,gEAAA;EE5EH,6BAAA;AD8pGD;AD7kGE;EACC,8CAAA;AC+kGH;AD5kGE;EACC,kDAAA;AC8kGH;ADrmGE;EACC,4CAAA;ACumGH;ADrmGG;EACC,oDAAA;EEnEH,6BAAA;AD2qGD;ADnmGE;EACC,wDAAA;ACqmGH;ADnmGG;EACC,gEAAA;EE5EH,6BAAA;ADkrGD;ADjmGE;EACC,8CAAA;ACmmGH;ADhmGE;EACC,kDAAA;ACkmGH;ADznGE;EACC,4CAAA;AC2nGH;ADznGG;EACC,oDAAA;EEnEH,6BAAA;AD+rGD;ADvnGE;EACC,wDAAA;ACynGH;ADvnGG;EACC,gEAAA;EE5EH,6BAAA;ADssGD;ADrnGE;EACC,8CAAA;ACunGH;ADpnGE;EACC,kDAAA;ACsnGH;AD7oGE;EACC,6CAAA;AC+oGH;AD7oGG;EACC,qDAAA;EEnEH,6BAAA;ADmtGD;AD3oGE;EACC,yDAAA;AC6oGH;AD3oGG;EACC,iEAAA;EE5EH,6BAAA;AD0tGD;ADzoGE;EACC,+CAAA;AC2oGH;ADxoGE;EACC,mDAAA;AC0oGH;ADjqGE;EACC,6CAAA;ACmqGH;ADjqGG;EACC,qDAAA;EEnEH,6BAAA;ADuuGD;AD/pGE;EACC,yDAAA;ACiqGH;AD/pGG;EACC,iEAAA;EE5EH,6BAAA;AD8uGD;AD7pGE;EACC,+CAAA;AC+pGH;AD5pGE;EACC,mDAAA;AC8pGH;ADrrGE;EACC,6CAAA;ACurGH;ADrrGG;EACC,qDAAA;EEnEH,6BAAA;AD2vGD;ADnrGE;EACC,yDAAA;ACqrGH;ADnrGG;EACC,iEAAA;EE5EH,6BAAA;ADkwGD;ADjrGE;EACC,+CAAA;ACmrGH;ADhrGE;EACC,mDAAA;ACkrGH;ADzsGE;EACC,6CAAA;AC2sGH;ADzsGG;EACC,qDAAA;EEnEH,6BAAA;AD+wGD;ADvsGE;EACC,yDAAA;ACysGH;ADvsGG;EACC,iEAAA;EE5EH,6BAAA;ADsxGD;ADrsGE;EACC,+CAAA;ACusGH;ADpsGE;EACC,mDAAA;ACssGH;AD7tGE;EACC,6CAAA;AC+tGH;AD7tGG;EACC,qDAAA;EEnEH,6BAAA;ADmyGD;AD3tGE;EACC,yDAAA;AC6tGH;AD3tGG;EACC,iEAAA;EE5EH,6BAAA;AD0yGD;ADztGE;EACC,+CAAA;AC2tGH;ADxtGE;EACC,mDAAA;AC0tGH;ADjvGE;EACC,6CAAA;ACmvGH;ADjvGG;EACC,qDAAA;EEnEH,6BAAA;ADuzGD;AD/uGE;EACC,yDAAA;ACivGH;AD/uGG;EACC,iEAAA;EE5EH,6BAAA;AD8zGD;AD7uGE;EACC,+CAAA;AC+uGH;AD5uGE;EACC,mDAAA;AC8uGH;ADrwGE;EACC,6CAAA;ACuwGH;ADrwGG;EACC,qDAAA;EEnEH,6BAAA;AD20GD;ADnwGE;EACC,yDAAA;ACqwGH;ADnwGG;EACC,iEAAA;EE5EH,6BAAA;ADk1GD;ADjwGE;EACC,+CAAA;ACmwGH;ADhwGE;EACC,mDAAA;ACkwGH;ADzxGE;EACC,6CAAA;AC2xGH;ADzxGG;EACC,qDAAA;EEnEH,6BAAA;AD+1GD;ADvxGE;EACC,yDAAA;ACyxGH;ADvxGG;EACC,iEAAA;EE5EH,6BAAA;ADs2GD;ADrxGE;EACC,+CAAA;ACuxGH;ADpxGE;EACC,mDAAA;ACsxGH;;AD7wGE;EACC,kDAAA;ACgxGH;ADjxGE;EACC,kDAAA;ACmxGH;ADpxGE;EACC,kDAAA;ACsxGH;ADvxGE;EACC,kDAAA;ACyxGH;AD1xGE;EACC,kDAAA;AC4xGH;AD7xGE;EACC,kDAAA;AC+xGH;ADhyGE;EACC,kDAAA;ACkyGH;ADnyGE;EACC,kDAAA;ACqyGH;ADtyGE;EACC,kDAAA;ACwyGH;ADzyGE;EACC,kDAAA;AC2yGH;AD5yGE;EACC,kDAAA;AC8yGH;AD/yGE;EACC,kDAAA;ACizGH;ADlzGE;EACC,kDAAA;ACozGH;ADrzGE;EACC,kDAAA;ACuzGH;ADxzGE;EACC,kDAAA;AC0zGH;AD3zGE;EACC,kDAAA;AC6zGH;AD9zGE;EACC,kDAAA;ACg0GH;ADj0GE;EACC,kDAAA;ACm0GH;ADp0GE;EACC,kDAAA;ACs0GH;ADv0GE;EACC,kDAAA;ACy0GH;AD10GE;EACC,kDAAA;AC40GH;AD70GE;EACC,kDAAA;AC+0GH;ADh1GE;EACC,kDAAA;ACk1GH;ADn1GE;EACC,kDAAA;ACq1GH;ADt1GE;EACC,kDAAA;ACw1GH;ADz1GE;EACC,kDAAA;AC21GH;AD51GE;EACC,kDAAA;AC81GH;AD/1GE;EACC,kDAAA;ACi2GH;ADl2GE;EACC,kDAAA;ACo2GH;ADr2GE;EACC,kDAAA;ACu2GH;ADx2GE;EACC,kDAAA;AC02GH;AD32GE;EACC,kDAAA;AC62GH;AD92GE;EACC,kDAAA;ACg3GH;ADj3GE;EACC,kDAAA;ACm3GH;ADp3GE;EACC,kDAAA;ACs3GH;ADv3GE;EACC,kDAAA;ACy3GH;AD13GE;EACC,kDAAA;AC43GH;AD73GE;EACC,kDAAA;AC+3GH;ADh4GE;EACC,kDAAA;ACk4GH;ADn4GE;EACC,kDAAA;ACq4GH;ADt4GE;EACC,kDAAA;ACw4GH;ADz4GE;EACC,kDAAA;AC24GH;AD54GE;EACC,kDAAA;AC84GH;AD/4GE;EACC,kDAAA;ACi5GH;ADl5GE;EACC,kDAAA;ACo5GH;ADr5GE;EACC,kDAAA;ACu5GH;ADx5GE;EACC,kDAAA;AC05GH;AD35GE;EACC,kDAAA;AC65GH;AD95GE;EACC,kDAAA;ACg6GH;ADj6GE;EACC,kDAAA;ACm6GH;ADp6GE;EACC,kDAAA;ACs6GH;ADv6GE;EACC,mDAAA;ACy6GH;AD16GE;EACC,mDAAA;AC46GH;AD76GE;EACC,mDAAA;AC+6GH;ADh7GE;EACC,mDAAA;ACk7GH;ADn7GE;EACC,mDAAA;ACq7GH;ADt7GE;EACC,mDAAA;ACw7GH;ADz7GE;EACC,mDAAA;AC27GH;AD57GE;EACC,mDAAA;AC87GH;AD/7GE;EACC,mDAAA;ACi8GH;ADl8GE;EACC,oDAAA;ACo8GH;ADr8GE;EACC,oDAAA;ACu8GH;ADx8GE;EACC,oDAAA;AC08GH;AD38GE;EACC,oDAAA;AC68GH;AD98GE;EACC,oDAAA;ACg9GH;;ADz8GE;EACC,sCG8RY;EH7RZ,0CG8Rc;AF8qGjB;ADz8GE;EACC,sCG2RY;EH1RZ,0CG2Rc;AFgrGjB;ADx8GE;EACC,sCGwRY;EHvRZ,0CGwRc;AFkrGjB;ADt8GG;EACC,sCGgRW;EH/QX,0CG8Qa;AF0rGjB;ADr8GG;EACC,gDGmPqB;AFotGzB;;AGnkHA;EACC,oDAAA;EACA,iBAAA;AHskHD;AGnkHE;EACC,kBAAA;AHqkHH;AGlkHE;EACC,iBAAA;EACA,mBAAA;EACA,iBAAA;AHokHH;AG/jHG;;EACC,gDC+EqB;ED9ErB,kDC8EqB;ED7ErB,iBAAA;AHkkHJ;AG/jHG;;EACC,+BEEa;ALgkHjB;AG9jHE;EACC,wCC6Kc;ED5Kd,oDAAA;AHgkHH;AG9jHG;EACC,iBAAA;AHgkHJ;AG7jHG;EACC,mBAAA;AH+jHJ;AG3jHE;EACC,aAAA;AH6jHH;AG1jHE;EACC,4CC8HgB;AJ87GnB;AGzjHE;EACC,0CAAA;EAGA,gBAAA;EACA,sCCiJY;AJw6Gf;;AM/mHA;EACC,0CFyMgB;AJy6GjB;;AOnnHA;EACC,aAAA;EACA,iBAAA;APsnHD;AOpnHC;EACC,gDL0WuB;AF4wGzB;;AQ5mHA;EACC,aAAA;EACA,kBAAA;EACA,8CJyBU;EIxBV,UAAA;EACA,sBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,6DAAA;AR+mHD;;AQ5mHA;;EAEC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AR+mHD;;AQ5mHA;EACC,0CAAA;EACA,gBAAA;EACA,WAAA;AR+mHD;;AQ5mHA;;;;EAIC,uEN4UmC;AFmyGpC;;AQ5mHA;;ECzBI,4CAAA;EACA,oBAAA;AT0oHJ;ASxoHI;EDsBJ;;ICrBM,qBAAA;ET4oHJ;AACF;;AQlnHC;EApDA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,8DAAA;EACA,gEAAA;EACA,oBAAA;EA+CC,eAAA;EACA,iBAAA;AR4nHF;AQznHC;EA1DA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,8DAAA;EACA,gEAAA;EACA,oBAAA;EAqDC,eAAA;EACA,iBAAA;ARkoHF;;AQ9nHA;EACC,iBAAA;ARioHD;;AQ9nHA;EACC,iBAAA;ARioHD;;AQ9nHA;EEixBI,+DAAA;EAAA,8DAAA;EAAA,kEAAA;EAAA,uEAAA;EF/wBH,SAAA;ARooHD;;AQjoHA;EE4wBI,uDAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,+DAAA;EF1wBH,SAAA;ARuoHD;;AQpoHA;EACC,cAAA;EEswBG,iDAAA;EAAA,iDAAA;EAAA,qDAAA;EAAA,0DAAA;EFpwBH,yCJ+GgB;EI9GhB,mBG3DY;AXqsHb;;AYnuHA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CRoCU;EQnCV,sBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AZsuHD;;AYnuHA;EACC,mBAAA;AZsuHD;;AYnuHA;EACC,gBAAA;AZsuHD;;AYnuHA;EACC,qBAAA;AZsuHD;;AYnuHA;;EAEC,YAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AZsuHD;;AYnuHA;EACC,0CAAA;EACA,gBAAA;EACA,WAAA;AZsuHD;;AYnuHA;;;;EAIC,uEV+UmC;AFu5GpC;AYpuHC;;;;;;;;EAIC,gBAAA;AZ0uHF;;AYpuHC;;EACC,aAAA;EACA,+CAAA;AZwuHF;;AYpuHA;EACC,kBAAA;EACA,0BAAA;EACA,kBAAA;AZuuHD;;AYpuHA;EACC,wBD9DY;EDu1BT,uDAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,+DAAA;EEvxBH,uCR+Hc;AJ2mHf;;AYvuHA;EACC,aAAA;AZ0uHD;;AYvuHA;EFgxBI,uDAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,+DAAA;EE9wBH,uCRsHc;EQrHd,qBD1EY;EC2EZ,kBAAA;AZ6uHD;;Aa/zHA;EACC,iBAAA;Abk0HD;;Aa/zHA;EACC,oBF2BY;EE1BZ,mBAAA;EACA,sBAAA;Abk0HD;;Aa/zHA;EACC,uBAAA;EACA,4CT+JkB;AJmqHnB;;Aa/zHA;EACC,wBAAA;EACA,mBAAA;Abk0HD;;Aa9zHC;EACC,wBAAA;Abi0HF;;Aa7zHA;EACC,qBAAA;Abg0HD;;Aa7zHA;EACC,qBAAA;Abg0HD;;Aa7zHA;EACC,qBAAA;Abg0HD;;Aa7zHA;EACC,sBAAA;Abg0HD;;Aa5zHC;EACC,2CT0DgB;ESzDhB,sBAAA;Ab+zHF;;Aa1zHC;EACC,sCTjCW;AJ81Hb;Aa1zHC;EACC,0CTsIe;ESrIf,wBAAA;Ab4zHF;;Acr3HA;EACC,wCV6LgB;AJ2rHjB;;Aev3HC;EACC,iCbmXQ;AFugHV;Aev3HC;EACC,2CXgGgB;AJyxHlB;Aet3HC;EACC,2CX4FgB;AJ4xHlB;Aen3HE;;EACC,oBAAA;EACA,iBAAA;EACA,2CXoFe;AJkyHlB;Aen3HE;;EACC,qBAAA;EACA,iCX4ZK;AJ09GR;;AgB14HE;EACC,UAAA;EACA,eAAA;EACA,YAAA;AhB64HH;;AgBv4HC;EACC,yCZyFgB;EYxFhB,iBAAA;EACA,2CCkWgB;AjBwiHlB;;AkBz5HC;EACC,oBAAA;EACA,aC4DW;ED3DX,eC2DW;AnBi2Hb;;AoBh6HC;EACC,aAAA;EACA,mBAAA;ApBm6HF;AoBh6HC;EACC,aAAA;EACA,sBAAA;ApBk6HF;AoB/5HC;EACC,aAAA;EACA,2BAAA;ApBi6HF;AoB95HC;EACC,aAAA;EACA,8BAAA;ApBg6HF;AoB75HC;EACC,mBAAA;ApB+5HF;;AoB35HA;EACC,iBAAA;ApB85HD;;AoB35HA;EACC,eAAA;EACA,cAAA;EACA,iBAAA;ApB85HD;;AqB77HA;EACC,oDAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;ArBg8HD;AqB97HC;EACC,YAAA;ArBg8HF;AqB77HE;EACC,WAAA;ArB+7HH;AqB37HC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;ArB67HF;AqB37HE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDAAA;EACA,iCAAA;ArB67HH;AqB37HG;EARD;IASE,yBAAA;ErB87HF;AACF;AqB57HG;EACC,gDjBuKa;EiBtKb,0CjBjBS;AJ+8Hb;AqB37HG;EACC,aAAA;EACA,wBAAA;EACA,oCjBvBS;EiBwBT,sCjBxBS;AJq9Hb;AqBx7HG;EACC,iBAAA;ArB07HJ;AqBt7HE;EACC,eAAA;EACA,wCjBmJc;EiBlJd,iBAAA;ArBw7HH;AqBp7HC;EACC,uBAAA;ArBs7HF;AqBn7HC;EACC,yBAAA;ArBq7HF;AqB/6HI;EACC,cAAA;ArBi7HL;AqB36HC;EACC,YAAA;EACA,sBAAA;ArB66HF;AqB36HE;EACC,eAAA;EACA,mBAAA;EACA,mBAAA;ArB66HH;AqBz6HC;EACC,eAAA;ArB26HF;AqBz6HE;EACC,gDAAA;EACA,6BAAA;ArB26HH;AqBz6HG;EACC,gDjByGa;AJk0HjB;;AsB1gIA;EACC,iBAAA;AtB6gID;AsB3gIC;;;;EAIC,sClB8La;AJ+0Hf;AsBzgIE;EACC,uClBiQa;AJ0wHhB;AsBvgIG;EACC,yClBkQc;AJuwHlB;AsBtgIG;EACC,aHfQ;AnBuhIZ;AsBpgIE;EACC,yClBsPe;AJgxHlB;AsBngIE;EACC,2CpB8UiB;AFurHpB;;AuBniIC;;EACC,kDrB4WuB;EqB3WvB,iBAAA;EACA,mBAAA;EACA,oBAAA;AvBuiIF;;AwBpiIC;EACC,iCtB4WQ;AF2rHV;AwBpiIC;EACC,iBAAA;AxBsiIF;AwBniIC;EACC,iBAAA;AxBqiIF;AwBliIC;EACC,iBAAA;EACA,2CpBgFgB;AJo9HlB;AwBhiIE;EACC,+CpB2Ee;AJu9HlB;AwB/hIE;EACC,mBLuFO;AnB08HV;AwB7hIC;EACC,8BAjCe;AxBgkIjB;AwB3hIE;EACC,oCAtCc;AxBmkIjB;AwB1hIE;EACC,qCAzCmB;AxBqkItB;;AyBjkIC;EACC,iCvB4WQ;AFwtHV;AyBjkIC;EACC,iBAAA;AzBmkIF;AyBhkIC;EACC,iBAAA;AzBkkIF;AyB/jIC;EACC,iBAAA;EACA,2CrBgFgB;AJi/HlB;AyB7jIE;EACC,+CrB2Ee;AJo/HlB;AyB5jIE;EACC,mBNuFO;AnBu+HV;;A0B3lIC;EACC,ePyFO;EOxFP,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;A1B8lIF;A0B3lIC;EACC,eAAA;A1B6lIF;A0B1lIC;EACC,YAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;A1B4lIF;A0B1lIE;EACC,4CAAA;A1B4lIH;;A0BvlIA;EACC,yBPiEQ;EOhER,oBAAA;EACA,wBAAA;ECqBC,2DAAA;EDnBD,eAAA;EACA,0CAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,oDAAA;EAEA,uCtBgKc;EsB/Jd,iBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;A1BylID;A0BvlIC;EACC,UAAA;EACA,wBAAA;ECIA,2DAAA;A3BslIF;;A4BxoIC;EACC,uCxBqMa;EwBpMb,eAAA;EACA,0CAAA;EAGA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5ByoIF;;A4BpoIC;EACC,wBAAA;EACA,gBAAA;A5BuoIF;;A6BzpIC;EACC,aAAA;A7B4pIF;A6B1pIE;EACC,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;EACA,2DAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,kCAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;A7B4pIH;A6B1pIG;;;EAGC,mBAAA;A7B4pIJ;A6BzpIG;EACC,sBAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gEAAA;A7B2pIJ;A6BzpII;EACC,wCAAA;A7B2pIL;A6BxpII;EACC,yDAAA;EACA,wDAAA;EACA,4DAAA;EACA,iEAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,wJACC;A7BypIN;A6BtpIK;EACC,4CAAA;EACA,oBAAA;A7BwpIN;A6BppII;;;EAGC,mBAAA;A7BspIL;A6BjpIE;EACC,QAAA;EACA,WAAA;A7BmpIH;A6BhpIG;EACC,cAAA;A7BkpIJ;A6B/oIG;EACC,SAAA;EACA,UAAA;EACA,gBAAA;A7BipIJ;A6B7oIE;;EAEC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,6GACC;EAED,wBAAA;A7B6oIH;A6B3oIG;;EACC,wCAAA;A7B8oIJ;A6B3oIG;;EACC,4CAAA;EACA,oBAAA;A7B8oIJ;A6B3oIG;;;;;;EAGC,mBAAA;A7BgpIJ;A6B7oIG;;EACC,qBAAA;A7BgpIJ;A6B7oIG;;EACC,gBAAA;EACA,sCAAA;EACA,iBAAA;A7BgpIJ;;A8BzyIA;EACC,iCAAA;EACA,iCAAA;EACA,yCAAA;EACA,4CAAA;EACA,gDAAA;EACA,oDAAA;EACA,iCAAA;A9B4yID;A8B1yIC;EACC,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2DAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,UAAA;EACA,oFACC;EAED,kBAAA;A9B0yIF;A8BxyIE;EACC,cAAA;EAEA,UAAA;EACA,2EACC;EAED,mBAAA;A9BuyIH;A8BryIG;EACC,wBAAA;EACA,sDAAA;A9BuyIJ;A8BnyIE;EACC,eAAA;EACA,MAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;EACA,mCAAA;EACA,4BAAA;EACA,yDAAA;A9BqyIH;A8BnyIG;EAjBD;IAkBE,eAAA;E9BsyIF;AACF;A8BpyIG;EArBD;IAsBE,gBAAA;IACA,UAAA;IACA,YAAA;IACA,eAAA;E9BuyIF;AACF;A8BryIG;EA5BD;IA6BE,UAAA;IACA,eAAA;E9BwyIF;AACF;A8BtyIG;EAjCD;IAkCE,UAAA;E9ByyIF;AACF;A8BvyIG;EACC,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;A9ByyIJ;A8BvyII;EACC,aAAA;EACA,gBAAA;EAEA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,wBAAA;EACA,iDAAA;EACA,iDAAA;EACA,qDAAA;EACA,0DAAA;EACA,yCAAA;EAGA,yBAAA;EACA,gCAAA;A9BsyIL;A8BnyII;EACC,6BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,wBAAA;EACA,mDAAA;EACA,mDAAA;EACA,mDAAA;EACA,uDAAA;EACA,+BAAA;EACA,uCAAA;EAGA,yBAAA;EACA,gCAAA;A9BkyIL;A8B/xII;EACC,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,kEAAA;EAGA,SAAA;EACA,gBAAA;EACA,oBAAA;A9B+xIL;A8B7xIK;EACC,wCAAA;A9B+xIN;A8B5xIK;EACC,uCAAA;EACA,aAAA;A9B8xIN;A8B3xIK;EACC,cAAA;EACA,eAAA;EACA,sCAAA;A9B6xIN;A8BxxIG;EACC,qBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iDAAA;EACA,oDAAA;EACA,yDAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;A9B0xIJ;A8BxxII;EACC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;A9B0xIL;A8BxxIK;EACC,4DAAA;EACA,2DAAA;EACA,+DAAA;EACA,oEAAA;EACA,yCAAA;A9B0xIN;A8BxxIM;EACC,WAAA;EACA,YAAA;EACA,YAAA;A9B0xIP;A8BxxIO;EACC,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,uCAAA;EAEA,iBAAA;EACA,sBAAA;A9ByxIR;A8BvxIQ;EACC,gBAAA;A9ByxIT;A8BnxIK;EACC,yDAAA;EACA,wDAAA;EACA,4DAAA;EACA,iEAAA;EACA,kCAAA;EACA,WAAA;A9BqxIN;A8BnxIM;EACC,+DAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;A9BqxIP;A8BnxIO;EACC,6CAAA;A9BqxIR;A8BlxIO;EACC,+DAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gBAAA;EACA,sBAAA;A9BoxIR;A8B7wIG;EACC,6BAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;A9B+wIJ;A8B7wII;EACC,UAAA;A9B+wIL;A8B5wII;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,SAAA;EACA;;;;;;;GAAA;EAQA;;;;;;;GAAA;EAQA,mEAAA;EACA;;GAAA;EAGA;;GAAA;EAGA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,yDAAA;EACA,wDAAA;EACA,4DAAA;EACA,iEAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,0HAAA;EAIA,+FAAA;EAGA,sFAAA;EAGA,gBAAA;EACA,qBAAA;EACA,qMACC;EAID,mBAAA;A9BmwIL;A8BhwII;EACC,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oDAAA;EACA,wCAAA;A9BkwIL;A8BhwIK;EACC,wCAAA;EACA,0DAAA;A9BkwIN;A8B/vIK;EACC,sEAAA;EACA,oIACC;A9BgwIP;;A8BvvIA;EACC;IACC,4BAAA;E9B0vIA;AACF;A+B5lJA;EACC,8C3B0DU;E2BzDV,oBAAA;EJ+CC,2DAAA;EI7CD,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,oDAAA;EACA,mDACC;A/B6lJF;A+B1lJC;EACC,UAAA;EACA,kBAAA;EACA,iDACC;EJ8BD,2DAAA;A3B8jJF;A+BvlJC;EACC,uC3B4Ka;AJ66If;A+BvlJE;EACC,kBAAA;A/BylJH;A+BtlJE;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;A/BwlJH;A+BtlJG;EACC,WAAA;EACA,eAAA;EACA,iBAAA;A/BwlJJ;A+BplJE;EACC,aAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;A/BslJH;A+BplJG;EACC,aAAA;EACA,OAAA;A/BslJJ;A+BplJI;EACC,OAAA;EACA,kBAAA;A/BslJL;A+BnlJI;EACC,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gD7BySoB;AF4yIzB;A+B7kJI;EACC,gBAAA;A/B+kJL;A+B3kJG;EACC,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;A/B6kJJ;A+B3kJI;EACC,WAAA;EACA,gBAAA;A/B6kJL;A+BxkJE;EACC,SAAA;EACA,UAAA;A/B0kJH;A+BxkJG;EACC,gBAAA;EACA,kBAAA;A/B0kJJ;A+BxkJI;EACC,gEAAA;A/B0kJL;A+BpkJG;EACC,UAAA;A/BskJJ;A+BjkJC;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;A/BmkJF;A+BjkJE;EAPD;IAQE,yBAAA;E/BokJD;AACF;A+BlkJE;EACC,gBAAA;A/BokJH;;AgC1sJA;EACC,4C5B2KkB;AJkiJnB;;AiC5sJC;EACC,oC7BgBW;E6BfX,oC7BuCS;AJwqJX;AiC5sJC;EACC,kC7BmCS;AJ2qJX;AiC3sJC;EACC,wC7BiPe;AJ49IjB;AiC1sJC;EACC,4C7B4JiB;E6B3JjB,eAAA;AjC4sJF;AiCzsJC;EACC,yC7BkFgB;E6BjFhB,4C7BsJiB;E6BrJjB,eAAA;AjC2sJF;AiCxsJC;EACC,kC7BgBS;E6BfT,YAAA;AjC0sJF;AiCtsJE;EACC,wC7B4Nc;AJ4+IjB;AiCrsJE;EACC,kC7BwBQ;AJ+qJX;AiCnsJE;EACC,UAAA;EACA,YAAA;AjCqsJH;AiCjsJC;EACC,adeW;EcdX,edcW;AnBqrJb;;AkClvJC;;EAEC,gDhC2WuB;AF04IzB;AkClvJC;EACC,2ChCsWkB;AF84IpB;AkCjvJC;EACC,kC9B+BS;AJotJX;;AmChwJA;;EAEC,oBAAA;AnCmwJD;;AoClwJC;EACC,eAAA;EACA,oBAAA;ET+CA,2DAAA;A3ButJF;AoClwJC;EACC,kChCkCS;AJkuJX;AoCjwJC;EACC,wBAAA;ApCmwJF;;AqC/wJC;EACC,oBAAA;ArCkxJF;AqChxJE;EACC,sCnCgYY;EmC/XZ,0CnCgYc;AFk5IjB;AqC/wJE;EACC,sCnC6XY;EmC5XZ,0CnC6Xc;AFo5IjB;AqC9wJE;EACC,sCnC0XY;EmCzXZ,0CnC0Xc;AFs5IjB;AqC5wJC;;EAEC,oBAAA;EACA,mBAAA;EACA,kDnCuVuB;AFu7IzB;AqC3wJC;EACC,6CnCkVkB;AF27IpB;;AsCxyJC;EACC,qDlC2J0B;AJgpJ5B;AsCxyJC;EACC,qDlCuJ0B;EkCtJ1B,oClCYW;AJ8xJb;AsCvyJC;EACC,4ClCiKiB;EkChKjB,mBAAA;AtCyyJF;;AuCpzJC;EACC,mBAAA;AvCuzJF;AuCrzJE;EACC,eAAA;AvCuzJH;AuCpzJE;EACC,sDnCgQa;EmC/Pb,iBAAA;EACA,wDnC8Pa;AJwjJhB;AuCnzJE;EACC,eAAA;AvCqzJH;;AuChzJA;EACC,gBAAA;AvCmzJD;AuChzJG;EACC,2BAAA;AvCkzJJ;AuC/yJG;EACC,gBAAA;AvCizJJ;;AwC/0JA;EACC,iBAAA;AxCk1JD;;AyCl1JA;EACC,iBAAA;AzCq1JD;AyCn1JC;EACC,kCrCuCS;AJ8yJX;AyCj1JE;EACC,uCrCsQa;AJ6kJhB;AyCh1JE;EACC,yCrCwQe;AJ0kJlB;AyC/0JE;EACC,yCrCiQe;AJglJlB;;A0Cj2JC;EACC,kBAAA;A1Co2JF;A0Ch2JE;EACC,aAAA;EACA,iBAAA;A1Ck2JH;A0C71JE;EACC,aAAA;EACA,4BAAA;A1C+1JH;A0C11JE;EACC,aAAA;EACA,iBAAA;A1C41JH;A0Cx1JC;EACC,0CtCiJiB;AJysJnB;A0Ct1JE;EACC,uCAAA;A1Cw1JH;A0Cr1JE;EACC,sCAAA;A1Cu1JH;A0Cp1JE;EACC,uCAAA;A1Cs1JH;A0Cn1JE;EACC,sCAAA;A1Cq1JH;A0Cj1JC;EACC,iBAAA;EACA,sCtC/BW;AJk3Jb;A0Ch1JC;EACC,sCtC0Ma;AJwoJf;;A2Cn4JC;EACC,oBAAA;EACA,UAAA;EACA,iBAAA;A3Cs4JF;A2Cn4JC;EACC,uCAAA;A3Cq4JF;A2Cp4JE;EACC;IACC,2CvCwFc;EJ8yJhB;E2Cp4JC;IACC,exBqGM;IwBpGN,YAAA;E3Cs4JF;E2Cp4JC;IACC,2CvCiFc;EJqzJhB;AACF;;A4C75JC;EACC,oBAAA;A5Cg6JF;A4C75JC;EACC,iBAAA;A5C+5JF;;A6Cl6JC;EACC,kCzCwCS;AJ63JX;A6Cl6JC;EACC,iD3CkXsB;E2CjXtB,iBAAA;A7Co6JF;A6Ch6JE;EACC,uCzCkQa;AJgqJhB;A6C/5JE;EACC,yCzCoQe;EyCnQf,iBAAA;EACA,wC3C0VY;AFukJf;A6C95JE;EACC,yCzC2Pe;AJqqJlB;A6C55JC;EACC,0CzCkKe;EyCjKf,iBAAA;A7C85JF;;A8C57JA;EACC,iBAAA;A9C+7JD;;A+C77JC;EACC,mBAAA;A/Cg8JF;A+C77JC;;EAEC,iBAAA;EACA,2C3C8FgB;AJi2JlB;A+C57JC;EACC,kD7CkWuB;AF4lJzB;;AgDz8JC;EACC,eAAA;EACA,oBAAA;ErB+CA,2DAAA;A3B85JF;AgDz8JC;EACC,kC5CkCS;E4CjCT,iBAAA;AhD28JF;AgDx8JC;EACC,eAAA;AhD08JF;AgDv8JC;EACC,wBAAA;AhDy8JF;;AiD19JC;EACC,kC7CyCS;E6CxCT,iBAAA;AjD69JF;AiD19JC;EACC,eAAA;AjD49JF;;AkDh+JC;EACC,UAAA;EACA,4C9CuKiB;E8CtKjB,mBAAA;EACA,iBAAA;AlDm+JF;AkDh+JC;EACC,eAAA;AlDk+JF;AkD/9JG;EAGC,gBAAA;AlD+9JJ;AkD59JG;EACC,sC9CkLW;EHxMd,6BAAA;ADq/JD;AkDx9JE;EACC,wC9C6Kc;AJ6yJjB;AkDv9JE;EACC,0C9C2IgB;AJ80JnB;AkDr9JC;EACC,sC9CiKa;AJszJf;AkDr9JE;EACC,wC9C6KY;E8C5KZ,iBAAA;AlDu9JH;;AmDjgKC;EACC,oBAAA;AnDogKF;;AoDpgKE;EAGC,gBAAA;ApDqgKH;;AqDxgKA;EACC,wHAAA;EACA,4IAAA;EACA,0CAAA;ArD2gKD;;AqDvgKC;EACC,UAAA;EACA,SAAA;EACA,eAAA;EAGA,gBAAA;EACA,yCjD2Le;AJ60JjB;AqDrgKC;EACC,eAAA;EAGA,gBAAA;EACA,wCjDmLe;AJk1JjB;AqDlgKC;EACC,0CAAA;EAGA,gBAAA;ArDkgKF;AqD//JC;;EAEC,eCxBe;EDyBf,0CAAA;ArDigKF;AqD9/JC;EAGC,gBAAA;ArD8/JF;;AuDriKA;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AvDwiKD;AuDtiKC;EAEC,gDnDQW;AJ+hKb;AuDriKE;EACC,gDnDKU;AJkiKb;AuDliKC;EACC,gBAAA;EACA,UAAA;AvDoiKF;;AuDhiKA;ECyFI,yCAAA;EAAA,uCAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,oDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oDAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,2CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,oCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,2CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA,gDAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EC/DF,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AzDm7KF;;AuDz8KA;ECqFI,yCAAA;EAAA,uCAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,oDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oDAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,2CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,oCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,2CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA,gDAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EC/DF,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AzDg2LF;;AuDl3LA;ECiFI,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,8DAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,iDAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,8CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA,gDAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EC/DF,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AzD6wMF;;AuD3xMA;EC6EI,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,8DAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,iDAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,8CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA,gDAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EC/DF,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AzD0rNF;;AuDpsNA;EAEC,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;AvDssND;;A0DtvNA;EACC,iBAAA;EACA,oDAAA;A1DyvND;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
